// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/govcon/v1/govcon.proto (package mono.govcon.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
import { AwardDeliverableRoll, AwardPricedDuty, BlockExtractionResult, DocumentBlock, ExtractionCacheInfo, OrderCeiling, RequestMetadata, ReviewItem, ReviewSource, StatedObligation } from "../../common/v1/types_pb";
import { AwardedContractData, AwardedContractDataV2, ParsedModificationV2 } from "../../contractintel/v1/contractintel_pb";
/**
 * @generated from message mono.govcon.v1.ClassifyDocumentRequest
 */ export class ClassifyDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_path = 1;
   */ _define_property(this, "documentPath", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string force_method = 4;
   */ _define_property(this, "forceMethod", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyDocumentRequest, "runtime", proto3);
_define_property(ClassifyDocumentRequest, "typeName", "mono.govcon.v1.ClassifyDocumentRequest");
_define_property(ClassifyDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "force_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyDocumentResponse
 */ export class ClassifyDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ClassificationResult classification = 1;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: int64 processing_time_ms = 2;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyDocumentResponse, "runtime", proto3);
_define_property(ClassifyDocumentResponse, "typeName", "mono.govcon.v1.ClassifyDocumentResponse");
_define_property(ClassifyDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification",
            kind: "message",
            T: ClassificationResult
        },
        {
            no: 2,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyPackageRequest
 */ export class ClassifyPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string path = 1;
   */ _define_property(this, "path", ""), /**
   * @generated from field: bool is_zip = 2;
   */ _define_property(this, "isZip", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyPackageRequest, "runtime", proto3);
_define_property(ClassifyPackageRequest, "typeName", "mono.govcon.v1.ClassifyPackageRequest");
_define_property(ClassifyPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "is_zip",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyPackageResponse
 */ export class ClassifyPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ClassifiedDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: map<string, mono.govcon.v1.FolderContents> folder_structure = 2;
   */ _define_property(this, "folderStructure", {}), /**
   * @generated from field: int32 total_files = 3;
   */ _define_property(this, "totalFiles", 0), /**
   * @generated from field: int64 processing_time_ms = 4;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyPackageResponse, "runtime", proto3);
_define_property(ClassifyPackageResponse, "typeName", "mono.govcon.v1.ClassifyPackageResponse");
_define_property(ClassifyPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ClassifiedDocument,
            repeated: true
        },
        {
            no: 2,
            name: "folder_structure",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: FolderContents
            }
        },
        {
            no: 3,
            name: "total_files",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassificationResult
 */ export class ClassificationResult extends Message {
    static fromBinary(bytes, options) {
        return new ClassificationResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassificationResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassificationResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassificationResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_type = 1;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: double confidence = 2;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: bool is_amendment = 3;
   */ _define_property(this, "isAmendment", false), /**
   * @generated from field: string amendment_number = 4;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated string key_points = 6;
   */ _define_property(this, "keyPoints", []), /**
   * @generated from field: string detected_by = 7;
   */ _define_property(this, "detectedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp classified_at = 8;
   */ _define_property(this, "classifiedAt", void 0), /**
   * @generated from field: int64 process_time_ms = 9;
   */ _define_property(this, "processTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassificationResult, "runtime", proto3);
_define_property(ClassificationResult, "typeName", "mono.govcon.v1.ClassificationResult");
_define_property(ClassificationResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "is_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "key_points",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "detected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "classified_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "process_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifiedDocument
 */ export class ClassifiedDocument extends Message {
    static fromBinary(bytes, options) {
        return new ClassifiedDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifiedDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifiedDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifiedDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string path = 1;
   */ _define_property(this, "path", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: mono.govcon.v1.ClassificationResult classification = 3;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: string parent_folder = 4;
   */ _define_property(this, "parentFolder", ""), /**
   * @generated from field: int64 file_size = 5;
   */ _define_property(this, "fileSize", protoInt64.zero), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifiedDocument, "runtime", proto3);
_define_property(ClassifiedDocument, "typeName", "mono.govcon.v1.ClassifiedDocument");
_define_property(ClassifiedDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "classification",
            kind: "message",
            T: ClassificationResult
        },
        {
            no: 4,
            name: "parent_folder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "file_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.FolderContents
 */ export class FolderContents extends Message {
    static fromBinary(bytes, options) {
        return new FolderContents().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FolderContents().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FolderContents().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FolderContents, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string filenames = 1;
   */ _define_property(this, "filenames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FolderContents, "runtime", proto3);
_define_property(FolderContents, "typeName", "mono.govcon.v1.FolderContents");
_define_property(FolderContents, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filenames",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractBlocksRequest
 */ export class ExtractBlocksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractBlocksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractBlocksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractBlocksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractBlocksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_path = 1;
   */ _define_property(this, "documentPath", ""), /**
   * @generated from field: string mime_type = 2;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: bool include_bounding_box = 3;
   */ _define_property(this, "includeBoundingBox", false), /**
   * @generated from field: bool build_hierarchy = 4;
   */ _define_property(this, "buildHierarchy", false), /**
   * @generated from field: int32 max_blocks = 5;
   */ _define_property(this, "maxBlocks", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractBlocksRequest, "runtime", proto3);
_define_property(ExtractBlocksRequest, "typeName", "mono.govcon.v1.ExtractBlocksRequest");
_define_property(ExtractBlocksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_bounding_box",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "build_hierarchy",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "max_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractBlocksResponse
 */ export class ExtractBlocksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractBlocksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractBlocksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractBlocksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractBlocksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.BlockExtractionResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractBlocksResponse, "runtime", proto3);
_define_property(ExtractBlocksResponse, "typeName", "mono.govcon.v1.ExtractBlocksResponse");
_define_property(ExtractBlocksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: BlockExtractionResult
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractBlocksUploadRequest
 */ export class ExtractBlocksUploadRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractBlocksUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractBlocksUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractBlocksUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractBlocksUploadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: bool include_bounding_box = 4;
   */ _define_property(this, "includeBoundingBox", false), /**
   * @generated from field: bool build_hierarchy = 5;
   */ _define_property(this, "buildHierarchy", false), /**
   * @generated from field: int32 max_blocks = 6;
   */ _define_property(this, "maxBlocks", 0), /**
   * @generated from field: bool async = 7;
   */ _define_property(this, "async", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractBlocksUploadRequest, "runtime", proto3);
_define_property(ExtractBlocksUploadRequest, "typeName", "mono.govcon.v1.ExtractBlocksUploadRequest");
_define_property(ExtractBlocksUploadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_bounding_box",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "build_hierarchy",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "max_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "async",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractBlocksUploadResponse
 */ export class ExtractBlocksUploadResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractBlocksUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractBlocksUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractBlocksUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractBlocksUploadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.BlockExtractionResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractBlocksUploadResponse, "runtime", proto3);
_define_property(ExtractBlocksUploadResponse, "typeName", "mono.govcon.v1.ExtractBlocksUploadResponse");
_define_property(ExtractBlocksUploadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: BlockExtractionResult
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GetBlockRequest
 */ export class GetBlockRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlockRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Storage path of the source document
   *
   * @generated from field: string document_path = 1;
   */ _define_property(this, "documentPath", ""), /**
   * MIME type for extraction
   *
   * @generated from field: string mime_type = 2;
   */ _define_property(this, "mimeType", ""), /**
   * Target block ID to return
   *
   * @generated from field: string block_id = 3;
   */ _define_property(this, "blockId", ""), /**
   * Number of preceding blocks to include (max 50)
   *
   * @generated from field: int32 context_before = 4;
   */ _define_property(this, "contextBefore", 0), /**
   * Number of following blocks to include (max 50)
   *
   * @generated from field: int32 context_after = 5;
   */ _define_property(this, "contextAfter", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlockRequest, "runtime", proto3);
_define_property(GetBlockRequest, "typeName", "mono.govcon.v1.GetBlockRequest");
_define_property(GetBlockRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_before",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "context_after",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GetBlockResponse
 */ export class GetBlockResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlockResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.DocumentBlock block = 1;
   */ _define_property(this, "block", void 0), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock context_before = 2;
   */ _define_property(this, "contextBefore", []), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock context_after = 3;
   */ _define_property(this, "contextAfter", []), /**
   * Source document ID (from extraction result)
   *
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlockResponse, "runtime", proto3);
_define_property(GetBlockResponse, "typeName", "mono.govcon.v1.GetBlockResponse");
_define_property(GetBlockResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block",
            kind: "message",
            T: DocumentBlock
        },
        {
            no: 2,
            name: "context_before",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 3,
            name: "context_after",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessDocumentRequest
 */ export class ProcessDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_path = 1;
   */ _define_property(this, "documentPath", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: bool extract_blocks = 4;
   */ _define_property(this, "extractBlocks", false), /**
   * @generated from field: bool include_bounding_box = 5;
   */ _define_property(this, "includeBoundingBox", false), /**
   * @generated from field: bool build_hierarchy = 6;
   */ _define_property(this, "buildHierarchy", false), /**
   * @generated from field: bool process_excel = 7;
   */ _define_property(this, "processExcel", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentRequest, "runtime", proto3);
_define_property(ProcessDocumentRequest, "typeName", "mono.govcon.v1.ProcessDocumentRequest");
_define_property(ProcessDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "extract_blocks",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "include_bounding_box",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "build_hierarchy",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "process_excel",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessDocumentResponse
 */ export class ProcessDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ClassificationResult classification = 1;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: mono.common.v1.BlockExtractionResult blocks = 2;
   */ _define_property(this, "blocks", void 0), /**
   * @generated from field: mono.govcon.v1.ExcelContent excel_content = 3;
   */ _define_property(this, "excelContent", void 0), /**
   * @generated from field: int64 processing_time_ms = 4;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentResponse, "runtime", proto3);
_define_property(ProcessDocumentResponse, "typeName", "mono.govcon.v1.ProcessDocumentResponse");
_define_property(ProcessDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification",
            kind: "message",
            T: ClassificationResult
        },
        {
            no: 2,
            name: "blocks",
            kind: "message",
            T: BlockExtractionResult
        },
        {
            no: 3,
            name: "excel_content",
            kind: "message",
            T: ExcelContent
        },
        {
            no: 4,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessPackageRequest
 */ export class ProcessPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string zip_path = 1;
   */ _define_property(this, "zipPath", ""), /**
   * @generated from field: string directory_path = 2;
   */ _define_property(this, "directoryPath", ""), /**
   * @generated from field: bool is_zip = 3;
   */ _define_property(this, "isZip", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessPackageRequest, "runtime", proto3);
_define_property(ProcessPackageRequest, "typeName", "mono.govcon.v1.ProcessPackageRequest");
_define_property(ProcessPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "zip_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "directory_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_zip",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessPackageResponse
 */ export class ProcessPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ClassifiedDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: map<string, mono.govcon.v1.FolderContents> folder_structure = 2;
   */ _define_property(this, "folderStructure", {}), /**
   * @generated from field: int32 total_files = 3;
   */ _define_property(this, "totalFiles", 0), /**
   * @generated from field: int64 processing_time_ms = 4;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessPackageResponse, "runtime", proto3);
_define_property(ProcessPackageResponse, "typeName", "mono.govcon.v1.ProcessPackageResponse");
_define_property(ProcessPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ClassifiedDocument,
            repeated: true
        },
        {
            no: 2,
            name: "folder_structure",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: FolderContents
            }
        },
        {
            no: 3,
            name: "total_files",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExcelContent
 */ export class ExcelContent extends Message {
    static fromBinary(bytes, options) {
        return new ExcelContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExcelContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExcelContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExcelContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.SheetContent sheets = 1;
   */ _define_property(this, "sheets", []), /**
   * @generated from field: string detected_as = 2;
   */ _define_property(this, "detectedAs", ""), /**
   * @generated from field: repeated mono.govcon.v1.ExcelRow table_data = 3;
   */ _define_property(this, "tableData", []), /**
   * @generated from field: repeated string headers = 4;
   */ _define_property(this, "headers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExcelContent, "runtime", proto3);
_define_property(ExcelContent, "typeName", "mono.govcon.v1.ExcelContent");
_define_property(ExcelContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheets",
            kind: "message",
            T: SheetContent,
            repeated: true
        },
        {
            no: 2,
            name: "detected_as",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "table_data",
            kind: "message",
            T: ExcelRow,
            repeated: true
        },
        {
            no: 4,
            name: "headers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SheetContent
 */ export class SheetContent extends Message {
    static fromBinary(bytes, options) {
        return new SheetContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SheetContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SheetContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SheetContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated mono.govcon.v1.ExcelRow rows = 2;
   */ _define_property(this, "rows", []), /**
   * @generated from field: int32 row_count = 3;
   */ _define_property(this, "rowCount", 0), /**
   * @generated from field: int32 col_count = 4;
   */ _define_property(this, "colCount", 0), /**
   * @generated from field: bool has_header = 5;
   */ _define_property(this, "hasHeader", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SheetContent, "runtime", proto3);
_define_property(SheetContent, "typeName", "mono.govcon.v1.SheetContent");
_define_property(SheetContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rows",
            kind: "message",
            T: ExcelRow,
            repeated: true
        },
        {
            no: 3,
            name: "row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "col_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "has_header",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExcelRow
 */ export class ExcelRow extends Message {
    static fromBinary(bytes, options) {
        return new ExcelRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExcelRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExcelRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExcelRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string cells = 1;
   */ _define_property(this, "cells", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExcelRow, "runtime", proto3);
_define_property(ExcelRow, "typeName", "mono.govcon.v1.ExcelRow");
_define_property(ExcelRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cells",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ShredDocumentsRequest
 */ export class ShredDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ShredDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShredDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShredDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShredDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * @generated from field: mono.govcon.v1.ShredOptions options = 2;
   */ _define_property(this, "options", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShredDocumentsRequest, "runtime", proto3);
_define_property(ShredDocumentsRequest, "typeName", "mono.govcon.v1.ShredDocumentsRequest");
_define_property(ShredDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "options",
            kind: "message",
            T: ShredOptions
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ShredOptions
 */ export class ShredOptions extends Message {
    static fromBinary(bytes, options) {
        return new ShredOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShredOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShredOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShredOptions, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool include_shall_statements = 1;
   */ _define_property(this, "includeShallStatements", false), /**
   * @generated from field: bool include_will_statements = 2;
   */ _define_property(this, "includeWillStatements", false), /**
   * @generated from field: bool include_must_statements = 3;
   */ _define_property(this, "includeMustStatements", false), /**
   * @generated from field: int32 max_requirements = 4;
   */ _define_property(this, "maxRequirements", 0), /**
   * @generated from field: double min_confidence_score = 5;
   */ _define_property(this, "minConfidenceScore", 0), /**
   * Storage path to HTML output (e.g., from Marker/Datalab).
   * When provided, baltigo parses the HTML into structured blocks
   * (with real types: SectionHeader, Table, ListGroup, etc.) instead of
   * using the flat text blocks. This enables outline extraction,
   * section-aware shredding, and HTML table CLIN extraction.
   *
   * @generated from field: string html_path = 6;
   */ _define_property(this, "htmlPath", ""), /**
   * Tenant ID for storage access when downloading html_path.
   *
   * @generated from field: string tenant_id = 7;
   */ _define_property(this, "tenantId", ""), /**
   * MinIO path to pre-parsed blocks.json (from ParseDocumentStructure).
   * When provided, baltigo loads blocks from this file instead of re-parsing HTML.
   *
   * @generated from field: string blocks_path = 8;
   */ _define_property(this, "blocksPath", ""), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 9;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 10;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 11;
   */ _define_property(this, "docId", ""), /**
   * Original filename of the document being processed.
   *
   * @generated from field: string doc_filename = 12;
   */ _define_property(this, "docFilename", ""), /**
   * Classified document type (e.g., "RFP", "AMENDMENT", "PWS").
   *
   * @generated from field: string doc_type = 13;
   */ _define_property(this, "docType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShredOptions, "runtime", proto3);
_define_property(ShredOptions, "typeName", "mono.govcon.v1.ShredOptions");
_define_property(ShredOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "include_shall_statements",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "include_will_statements",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "include_must_statements",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "max_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "min_confidence_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "doc_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ShredDocumentsResponse
 */ export class ShredDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ShredDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShredDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShredDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShredDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement instructions = 1;
   */ _define_property(this, "instructions", []), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement scope_requirements = 2;
   */ _define_property(this, "scopeRequirements", []), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement evaluation_criteria = 3;
   */ _define_property(this, "evaluationCriteria", []), /**
   * @generated from field: mono.govcon.v1.ShredStatistics statistics = 4;
   */ _define_property(this, "statistics", void 0), /**
   * Flat list of all requirements with 12-category classifications.
   *
   * @generated from field: repeated mono.govcon.v1.ShredRequirement all_requirements = 5;
   */ _define_property(this, "allRequirements", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShredDocumentsResponse, "runtime", proto3);
_define_property(ShredDocumentsResponse, "typeName", "mono.govcon.v1.ShredDocumentsResponse");
_define_property(ShredDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instructions",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 2,
            name: "scope_requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 3,
            name: "evaluation_criteria",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 4,
            name: "statistics",
            kind: "message",
            T: ShredStatistics
        },
        {
            no: 5,
            name: "all_requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ShredRequirement
 */ export class ShredRequirement extends Message {
    static fromBinary(bytes, options) {
        return new ShredRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShredRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShredRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShredRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string text = 3;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string source_block_id = 4;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: string section_number = 5;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string requirement_type = 6;
   */ _define_property(this, "requirementType", ""), /**
   * @generated from field: double confidence_score = 7;
   */ _define_property(this, "confidenceScore", 0), /**
   * @generated from field: map<string, string> metadata = 8;
   */ _define_property(this, "metadata", {}), /**
   * @generated from field: bool is_mandatory = 9;
   */ _define_property(this, "isMandatory", false), /**
   * @generated from field: bool is_evaluated = 10;
   */ _define_property(this, "isEvaluated", false), /**
   * 12-category system: all applicable categories for this requirement.
   *
   * @generated from field: repeated string categories = 11;
   */ _define_property(this, "categories", []), /**
   * Named entities extracted from the text (agency names, system names, standards).
   *
   * @generated from field: repeated string entities = 12;
   */ _define_property(this, "entities", []), /**
   * CLIN numbers referenced in the text (e.g., "0001", "0002AA").
   *
   * @generated from field: repeated string related_clins = 13;
   */ _define_property(this, "relatedClins", []), /**
   * Obligation strength: SHALL, MUST, WILL, SHOULD, MAY, UNSPECIFIED.
   *
   * @generated from field: string obligation_strength = 14;
   */ _define_property(this, "obligationStrength", ""), /**
   * Structured section context from document outline.
   *
   * @generated from field: mono.govcon.v1.SectionContext section_context = 15;
   */ _define_property(this, "sectionContext", void 0), /**
   * Page number in the source document (1-based).
   *
   * @generated from field: int32 page_number = 16;
   */ _define_property(this, "pageNumber", 0), /**
   * What the proposal team must do (WRITE_APPROACH, PROVIDE_EVIDENCE, COMPLY_FORMAT, SUBMIT_ACTION, ACKNOWLEDGE, PRICE, STAFF).
   *
   * @generated from field: string response_action = 17;
   */ _define_property(this, "responseAction", ""), /**
   * When this requirement applies (PROPOSAL, CONTRACT, BOTH).
   *
   * @generated from field: string deliverable_type = 18;
   */ _define_property(this, "deliverableType", ""), /**
   * Who owns the action (PROPOSAL_ACTION, CONTRACT_ACTION, GOVERNMENT_ACTION, NO_ACTION).
   *
   * @generated from field: string action_owner = 19;
   */ _define_property(this, "actionOwner", ""), /**
   * Insight hints feed the V2 insights pipeline (services/baltigo/pkg/govcon/insights).
   * Allowed values are the InsightType enum: VOLUME_STRUCTURE, PAGE_LIMIT, FORMAT_RULE,
   * CONTENT_REQUIREMENT, FILE_REQUIREMENT, KEY_PERSONNEL, RESUME_REQUIREMENT,
   * PAST_PERFORMANCE_REQ, CPARS_REQ, SUBCONTRACTING_GOAL, DEADLINE, QA_PROTOCOL,
   * ORAL_PRESENTATION, SITE_VISIT, PRE_PROPOSAL_CONF, SECURITY_CLEARANCE,
   * BOND_REQUIREMENT, TEAMING_RESTRICTION, AWARD_MECHANISM, CONTRACT_TYPE,
   * PLACE_OF_PERFORMANCE.
   * Most blocks have 0 hints; a few have 1-3.
   *
   * @generated from field: repeated string insight_hints = 20;
   */ _define_property(this, "insightHints", []), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   * Set on per-doc shred at extraction time and preserved through merge.
   * Empty when the requirement was extracted from the base solicitation.
   *
   * @generated from field: string source_document_id = 21;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 22;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 23;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 24;
   */ _define_property(this, "amendmentNumber", ""), /**
   * Logical ordering of the source document across amendments. 0 = base.
   *
   * @generated from field: int32 amendment_sequence = 25;
   */ _define_property(this, "amendmentSequence", 0), /**
   * Logical key set during merge so the UI / insights pipeline can group
   * multiple versions of the same logical requirement (e.g., the
   * "Volume II shall be limited to N pages" rule across base + AM002).
   * Empty in per-doc shred files; populated only in merged output.
   *
   * @generated from field: string logical_key = 26;
   */ _define_property(this, "logicalKey", ""), /**
   * True for the row that represents the most recent version of its
   * logical group. Set during merge after grouping by logical_key. The
   * older versions stay in the merged file as history rows.
   *
   * @generated from field: bool is_current_version = 27;
   */ _define_property(this, "isCurrentVersion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShredRequirement, "runtime", proto3);
_define_property(ShredRequirement, "typeName", "mono.govcon.v1.ShredRequirement");
_define_property(ShredRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "requirement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "metadata",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 9,
            name: "is_mandatory",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "is_evaluated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "entities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "related_clins",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "obligation_strength",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "section_context",
            kind: "message",
            T: SectionContext
        },
        {
            no: 16,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "response_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "deliverable_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "action_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "insight_hints",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 21,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 26,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * SectionContext provides structured location within the document outline.
 *
 * @generated from message mono.govcon.v1.SectionContext
 */ export class SectionContext extends Message {
    static fromBinary(bytes, options) {
        return new SectionContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionContext, a, b);
    }
    constructor(data){
        super(), /**
   * "SECTION B > B.3 > 5.2.1"
   *
   * @generated from field: string full_path = 1;
   */ _define_property(this, "fullPath", ""), /**
   * "SECTION B"
   *
   * @generated from field: string top_level = 2;
   */ _define_property(this, "topLevel", ""), /**
   * "5.2.1"
   *
   * @generated from field: string section_number = 3;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 depth = 5;
   */ _define_property(this, "depth", 0), /**
   * @generated from field: bool is_pws = 6;
   */ _define_property(this, "isPws", false), /**
   * @generated from field: bool is_addendum = 7;
   */ _define_property(this, "isAddendum", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionContext, "runtime", proto3);
_define_property(SectionContext, "typeName", "mono.govcon.v1.SectionContext");
_define_property(SectionContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "full_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "top_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "is_pws",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "is_addendum",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ShredStatistics
 */ export class ShredStatistics extends Message {
    static fromBinary(bytes, options) {
        return new ShredStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShredStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShredStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShredStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_blocks = 1;
   */ _define_property(this, "totalBlocks", 0), /**
   * @generated from field: int32 processed_blocks = 2;
   */ _define_property(this, "processedBlocks", 0), /**
   * @generated from field: int32 total_requirements = 3;
   */ _define_property(this, "totalRequirements", 0), /**
   * @generated from field: int32 instructions_count = 4;
   */ _define_property(this, "instructionsCount", 0), /**
   * @generated from field: int32 scope_count = 5;
   */ _define_property(this, "scopeCount", 0), /**
   * @generated from field: int32 evaluation_count = 6;
   */ _define_property(this, "evaluationCount", 0), /**
   * @generated from field: int32 processing_time_ms = 7;
   */ _define_property(this, "processingTimeMs", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShredStatistics, "runtime", proto3);
_define_property(ShredStatistics, "typeName", "mono.govcon.v1.ShredStatistics");
_define_property(ShredStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "processed_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "instructions_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "scope_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "evaluation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "processing_time_ms",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GenerateComplianceMatrixRequest
 */ export class GenerateComplianceMatrixRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateComplianceMatrixRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateComplianceMatrixRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateComplianceMatrixRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateComplianceMatrixRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ShredDocumentsResponse shred_view = 1;
   */ _define_property(this, "shredView", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ProposalVolume proposal_volumes = 2;
   */ _define_property(this, "proposalVolumes", []), /**
   * @generated from field: mono.govcon.v1.ComplianceMatrixOptions options = 3;
   */ _define_property(this, "options", void 0), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", ""), /**
   * Original filename of the document being processed.
   *
   * @generated from field: string doc_filename = 7;
   */ _define_property(this, "docFilename", ""), /**
   * Classified document type (e.g., "RFP", "AMENDMENT", "PWS").
   *
   * @generated from field: string doc_type = 8;
   */ _define_property(this, "docType", ""), /**
   * MinIO path to pre-parsed blocks.json for section-level evaluation extraction.
   * When provided, baltigo loads blocks and runs the dedicated evaluation scheme extractor.
   *
   * @generated from field: string blocks_path = 9;
   */ _define_property(this, "blocksPath", ""), /**
   * Normalized 3-digit amendment number for this document ("001", "002", "003").
   * Empty for the base solicitation. Stamped onto every fact extracted from
   * this doc so the merge step can resolve conflicts via amendment supersession.
   *
   * @generated from field: string amendment_number = 10;
   */ _define_property(this, "amendmentNumber", ""), /**
   * 0-based ordering of amendments (0 = base, 1+ = amendments in issue order).
   * Used as a tiebreaker when amendment_number can't be parsed numerically.
   *
   * @generated from field: int32 amendment_sequence = 11;
   */ _define_property(this, "amendmentSequence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateComplianceMatrixRequest, "runtime", proto3);
_define_property(GenerateComplianceMatrixRequest, "typeName", "mono.govcon.v1.GenerateComplianceMatrixRequest");
_define_property(GenerateComplianceMatrixRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "shred_view",
            kind: "message",
            T: ShredDocumentsResponse
        },
        {
            no: 2,
            name: "proposal_volumes",
            kind: "message",
            T: ProposalVolume,
            repeated: true
        },
        {
            no: 3,
            name: "options",
            kind: "message",
            T: ComplianceMatrixOptions
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "doc_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ComplianceMatrixOptions
 */ export class ComplianceMatrixOptions extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceMatrixOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceMatrixOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceMatrixOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceMatrixOptions, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 min_text_length = 1;
   */ _define_property(this, "minTextLength", 0), /**
   * @generated from field: int32 max_text_length = 2;
   */ _define_property(this, "maxTextLength", 0), /**
   * @generated from field: double similarity_threshold = 3;
   */ _define_property(this, "similarityThreshold", 0), /**
   * @generated from field: bool enable_semantic_dedup = 4;
   */ _define_property(this, "enableSemanticDedup", false), /**
   * @generated from field: bool enable_deliverable_detection = 5;
   */ _define_property(this, "enableDeliverableDetection", false), /**
   * @generated from field: bool enable_clin_linking = 6;
   */ _define_property(this, "enableClinLinking", false), /**
   * @generated from field: bool enable_eval_factor_extraction = 7;
   */ _define_property(this, "enableEvalFactorExtraction", false), /**
   * @generated from field: bool preserve_existing_ids = 8;
   */ _define_property(this, "preserveExistingIds", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceMatrixOptions, "runtime", proto3);
_define_property(ComplianceMatrixOptions, "typeName", "mono.govcon.v1.ComplianceMatrixOptions");
_define_property(ComplianceMatrixOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "min_text_length",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "max_text_length",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "similarity_threshold",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "enable_semantic_dedup",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "enable_deliverable_detection",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "enable_clin_linking",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "enable_eval_factor_extraction",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "preserve_existing_ids",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProposalVolume
 */ export class ProposalVolume extends Message {
    static fromBinary(bytes, options) {
        return new ProposalVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalVolume, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string volume_id = 1;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string volume_number = 2;
   */ _define_property(this, "volumeNumber", ""), /**
   * @generated from field: string volume_name = 3;
   */ _define_property(this, "volumeName", ""), /**
   * @generated from field: string volume_type = 4;
   */ _define_property(this, "volumeType", ""), /**
   * @generated from field: repeated mono.govcon.v1.ProposalSection sections = 5;
   */ _define_property(this, "sections", []), /**
   * @generated from field: int32 page_limit = 6;
   */ _define_property(this, "pageLimit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalVolume, "runtime", proto3);
_define_property(ProposalVolume, "typeName", "mono.govcon.v1.ProposalVolume");
_define_property(ProposalVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "volume_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sections",
            kind: "message",
            T: ProposalSection,
            repeated: true
        },
        {
            no: 6,
            name: "page_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProposalSection
 */ export class ProposalSection extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string section_number = 2;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string section_title = 3;
   */ _define_property(this, "sectionTitle", ""), /**
   * @generated from field: repeated string traced_requirements = 4;
   */ _define_property(this, "tracedRequirements", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSection, "runtime", proto3);
_define_property(ProposalSection, "typeName", "mono.govcon.v1.ProposalSection");
_define_property(ProposalSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "traced_requirements",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GenerateComplianceMatrixResponse
 */ export class GenerateComplianceMatrixResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateComplianceMatrixResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateComplianceMatrixResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateComplianceMatrixResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateComplianceMatrixResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The compliance matrix is a deeply nested structure with many sub-types.
   * Encoded as Struct for flexibility (same pattern as etl.proto).
   *
   * @generated from field: google.protobuf.Struct result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateComplianceMatrixResponse, "runtime", proto3);
_define_property(GenerateComplianceMatrixResponse, "typeName", "mono.govcon.v1.GenerateComplianceMatrixResponse");
_define_property(GenerateComplianceMatrixResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractCLINsRequest
 */ export class ExtractCLINsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractCLINsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractCLINsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractCLINsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractCLINsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * @generated from field: string excel_path = 2;
   */ _define_property(this, "excelPath", ""), /**
   * @generated from field: mono.govcon.v1.CLINExtractionOptions options = 3;
   */ _define_property(this, "options", void 0), /**
   * Storage path to HTML output for structured block parsing (same as ShredOptions.html_path).
   *
   * @generated from field: string html_path = 4;
   */ _define_property(this, "htmlPath", ""), /**
   * Tenant ID for storage access when downloading html_path.
   *
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", ""), /**
   * MinIO path to pre-parsed blocks.json (from ParseDocumentStructure).
   * When provided, baltigo loads blocks from this file instead of re-parsing HTML.
   *
   * @generated from field: string blocks_path = 6;
   */ _define_property(this, "blocksPath", ""), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 7;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 9;
   */ _define_property(this, "docId", ""), /**
   * Original filename of the document being processed.
   *
   * @generated from field: string doc_filename = 10;
   */ _define_property(this, "docFilename", ""), /**
   * Classified document type (e.g., "RFP", "AMENDMENT", "PWS").
   *
   * @generated from field: string doc_type = 11;
   */ _define_property(this, "docType", ""), /**
   * Set by reverie's modification-comparison path (SAD-580); baltigo runs
   * this call at BALTIGO_COMPARISON_REASONING_EFFORT (default medium) with
   * the matching per-call timeout.
   *
   * @generated from field: bool comparison = 12;
   */ _define_property(this, "comparison", false), /**
   * The award's attachments and addenda (a deliverables schedule, a price
   * list) uploaded beside it. Their stored blocks are read behind the
   * award's, each under a heading carrying the name the award cites it by,
   * and anything read from them points at their own document.
   *
   * @generated from field: repeated mono.govcon.v1.AwardAttachmentRef attachments = 13;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractCLINsRequest, "runtime", proto3);
_define_property(ExtractCLINsRequest, "typeName", "mono.govcon.v1.ExtractCLINsRequest");
_define_property(ExtractCLINsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "excel_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "options",
            kind: "message",
            T: CLINExtractionOptions
        },
        {
            no: 4,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "doc_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "comparison",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "attachments",
            kind: "message",
            T: AwardAttachmentRef,
            repeated: true
        }
    ]));
/**
 * AwardAttachmentRef is one document the award relies on, by baltigo
 * document id (its blocks.json lives under it) and filename.
 *
 * @generated from message mono.govcon.v1.AwardAttachmentRef
 */ export class AwardAttachmentRef extends Message {
    static fromBinary(bytes, options) {
        return new AwardAttachmentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardAttachmentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardAttachmentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardAttachmentRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string doc_id = 1;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardAttachmentRef, "runtime", proto3);
_define_property(AwardAttachmentRef, "typeName", "mono.govcon.v1.AwardAttachmentRef");
_define_property(AwardAttachmentRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLINExtractionOptions
 */ export class CLINExtractionOptions extends Message {
    static fromBinary(bytes, options) {
        return new CLINExtractionOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINExtractionOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINExtractionOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINExtractionOptions, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool section_b_only = 1;
   */ _define_property(this, "sectionBOnly", false), /**
   * @generated from field: double min_confidence = 2;
   */ _define_property(this, "minConfidence", 0), /**
   * @generated from field: bool extract_metadata = 3;
   */ _define_property(this, "extractMetadata", false), /**
   * @generated from field: int32 max_clins = 4;
   */ _define_property(this, "maxClins", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINExtractionOptions, "runtime", proto3);
_define_property(CLINExtractionOptions, "typeName", "mono.govcon.v1.CLINExtractionOptions");
_define_property(CLINExtractionOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_b_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "min_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "extract_metadata",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "max_clins",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractCLINsResponse
 */ export class ExtractCLINsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractCLINsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractCLINsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractCLINsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractCLINsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.CLIN clins = 1;
   */ _define_property(this, "clins", []), /**
   * @generated from field: mono.govcon.v1.CLINStatistics statistics = 2;
   */ _define_property(this, "statistics", void 0), /**
   * @generated from field: repeated string warnings = 3;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: int64 processing_time_ms = 4;
   */ _define_property(this, "processingTimeMs", protoInt64.zero), /**
   * @generated from field: string source_type = 5;
   */ _define_property(this, "sourceType", ""), /**
   * Per-line and header facts code could not settle (D93), staged by the
   * contract-upload sync into the program's ContractIntake set.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 6;
   */ _define_property(this, "reviewItems", []), /**
   * S7a priced-line duties (SAD-752 S7c-lite). Forwarded onto
   * SyncFromExtraction and written by pangaea's ImportAwardDuties.
   *
   * @generated from field: repeated mono.common.v1.AwardPricedDuty award_duties = 7;
   */ _define_property(this, "awardDuties", []), /**
   * The award's weekend/holiday roll for due dates, forwarded onto
   * SyncFromExtraction. Unset when the award states none, or when its clause
   * could not be read (that is a review item instead).
   *
   * @generated from field: mono.common.v1.AwardDeliverableRoll deliverable_roll = 8;
   */ _define_property(this, "deliverableRoll", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractCLINsResponse, "runtime", proto3);
_define_property(ExtractCLINsResponse, "typeName", "mono.govcon.v1.ExtractCLINsResponse");
_define_property(ExtractCLINsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clins",
            kind: "message",
            T: CLIN,
            repeated: true
        },
        {
            no: 2,
            name: "statistics",
            kind: "message",
            T: CLINStatistics
        },
        {
            no: 3,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "source_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 7,
            name: "award_duties",
            kind: "message",
            T: AwardPricedDuty,
            repeated: true
        },
        {
            no: 8,
            name: "deliverable_roll",
            kind: "message",
            T: AwardDeliverableRoll
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLIN
 */ export class CLIN extends Message {
    static fromBinary(bytes, options) {
        return new CLIN().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLIN().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLIN().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLIN, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin = 2;
   */ _define_property(this, "parentClin", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string option_type = 5;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: string contract_type = 6;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: mono.govcon.v1.CLINPricing pricing = 7;
   */ _define_property(this, "pricing", void 0), /**
   * @generated from field: repeated mono.govcon.v1.Deliverable deliverables = 8;
   */ _define_property(this, "deliverables", []), /**
   * @generated from field: mono.govcon.v1.RequirementSource source = 9;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: double confidence = 10;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: map<string, string> metadata = 11;
   */ _define_property(this, "metadata", {}), /**
   * PWS section references found in the CLIN description (e.g., ["5.2.1", "6.3"]).
   *
   * @generated from field: repeated string pws_references = 12;
   */ _define_property(this, "pwsReferences", []), /**
   * Attachment references found in the CLIN description (e.g., ["Attachment J-5", "CDRL A001"]).
   *
   * @generated from field: repeated string attachment_references = 13;
   */ _define_property(this, "attachmentReferences", []), /**
   * Period tracking: human-readable name (e.g., "Base Period", "Option Period 1", "Optional Task 3").
   *
   * @generated from field: string period_name = 14;
   */ _define_property(this, "periodName", ""), /**
   * Period type: "base", "option_period", or "optional_task".
   *
   * @generated from field: string period_type = 15;
   */ _define_property(this, "periodType", ""), /**
   * Option number: 0 for base, 1+ for option periods/tasks.
   *
   * @generated from field: int32 option_number = 16;
   */ _define_property(this, "optionNumber", 0), /**
   * Amendment tracking (populated in Phase 8): "UNCHANGED", "MODIFIED", "ADDED", "REMOVED".
   *
   * @generated from field: string amendment_status = 17;
   */ _define_property(this, "amendmentStatus", ""), /**
   * Amendment number that last modified this CLIN (0 = original).
   *
   * @generated from field: int32 last_modified_in = 18;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * Cross-period linking: corresponding base period CLIN (e.g., "0001" for CLIN "1001").
   *
   * @generated from field: string corresponding_base_clin = 19;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * Whether this CLIN is an optional task (independent of period — can be optional task within any period).
   *
   * @generated from field: bool is_optional_task = 20;
   */ _define_property(this, "isOptionalTask", false), /**
   * Which optional task number (1, 2, 3...) when is_optional_task is true.
   *
   * @generated from field: int32 optional_task_number = 21;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * Title/name of the optional task (e.g., "Additional System Teams").
   *
   * @generated from field: string optional_task_title = 22;
   */ _define_property(this, "optionalTaskTitle", ""), /**
   * Source block IDs that contributed to this CLIN (from block coalescing).
   * When a table spans multiple pages/blocks, this tracks all contributing blocks.
   *
   * @generated from field: repeated string source_block_ids = 23;
   */ _define_property(this, "sourceBlockIds", []), /**
   * Exercise authority and period-of-performance details for this CLIN.
   *
   * @generated from field: mono.govcon.v1.CLINExerciseInfo exercise_info = 24;
   */ _define_property(this, "exerciseInfo", void 0), /**
   * Scoped PWS references with outline-resolved subsections.
   *
   * @generated from field: repeated mono.govcon.v1.ScopedPWSReference scoped_pws_refs = 25;
   */ _define_property(this, "scopedPwsRefs", []), /**
   * Cost type classification: "labor", "travel", "odc", "materials", "subcontractor", "other".
   * Determines which indirect rate pools apply (e.g., travel/ODC = G&A only, no fringe/OH).
   *
   * @generated from field: string cost_type = 26;
   */ _define_property(this, "costType", ""), /**
   * Whether this CLIN requires team-level (t-shirt) pricing (e.g., Level 1-5 team sizes).
   *
   * @generated from field: bool needs_team_pricing = 27;
   */ _define_property(this, "needsTeamPricing", false), /**
   * Team tier labels and definitions extracted from the solicitation.
   *
   * @generated from field: repeated mono.govcon.v1.ExtractedTeamTier extracted_team_tiers = 28;
   */ _define_property(this, "extractedTeamTiers", []), /**
   * Fee constraints extracted from the solicitation (e.g., "fee shall not exceed 8%").
   *
   * @generated from field: mono.govcon.v1.ExtractedFeeTarget extracted_fee_target = 29;
   */ _define_property(this, "extractedFeeTarget", void 0), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   *
   * @generated from field: string source_document_id = 30;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 31;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 32;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 33;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 34;
   */ _define_property(this, "amendmentSequence", 0), /**
   * Logical key set during merge so multiple versions of the same CLIN
   * can be grouped (e.g., "0001AA" appearing in base + every amendment).
   *
   * @generated from field: string logical_key = 35;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 36;
   */ _define_property(this, "isCurrentVersion", false), /**
   * JSON of the T&M LCAT rate card embedded in this CLIN's table (govcon.CLINLaborMix):
   * {categories:[{lcat,hourlyRate,hoursPerIteration,iterationPrice,blockId}], sourceBlockIds, extractionMethod}.
   *
   * @generated from field: string labor_mix_json = 37;
   */ _define_property(this, "laborMixJson", ""), /**
   * Per-CLIN period of performance (each CLIN/executed SLIN states its own
   * PoP, e.g. "PoP: September 27, 2024 through September 26, 2025"). ISO 8601.
   *
   * @generated from field: string pop_start_date = 38;
   */ _define_property(this, "popStartDate", ""), /**
   * @generated from field: string pop_end_date = 39;
   */ _define_property(this, "popEndDate", ""), /**
   * K9c-1c (D103): the task's exercise cap, read from the document's own
   * "may be exercised up to N times" sentences (Section B, and the PWS's "can
   * be exercised up to N times"), never from the family's printed quantity.
   * Set on the family's parent line only; known is false when the document
   * states none, and a stated 0 (or "once" = 1) is known.
   *
   * @generated from field: int32 optional_task_max_exercises = 40;
   */ _define_property(this, "optionalTaskMaxExercises", 0), /**
   * @generated from field: bool optional_task_max_exercises_known = 41;
   */ _define_property(this, "optionalTaskMaxExercisesKnown", false), /**
   * The cap sentences, one source each.
   *
   * @generated from field: repeated mono.common.v1.ReviewSource optional_task_max_exercises_sources = 42;
   */ _define_property(this, "optionalTaskMaxExercisesSources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLIN, "runtime", proto3);
_define_property(CLIN, "typeName", "mono.govcon.v1.CLIN");
_define_property(CLIN, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pricing",
            kind: "message",
            T: CLINPricing
        },
        {
            no: 8,
            name: "deliverables",
            kind: "message",
            T: Deliverable,
            repeated: true
        },
        {
            no: 9,
            name: "source",
            kind: "message",
            T: RequirementSource
        },
        {
            no: 10,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "metadata",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 12,
            name: "pws_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 24,
            name: "exercise_info",
            kind: "message",
            T: CLINExerciseInfo
        },
        {
            no: 25,
            name: "scoped_pws_refs",
            kind: "message",
            T: ScopedPWSReference,
            repeated: true
        },
        {
            no: 26,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "needs_team_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 28,
            name: "extracted_team_tiers",
            kind: "message",
            T: ExtractedTeamTier,
            repeated: true
        },
        {
            no: 29,
            name: "extracted_fee_target",
            kind: "message",
            T: ExtractedFeeTarget
        },
        {
            no: 30,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 35,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 37,
            name: "labor_mix_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "pop_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 39,
            name: "pop_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "optional_task_max_exercises",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 41,
            name: "optional_task_max_exercises_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 42,
            name: "optional_task_max_exercises_sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        }
    ]));
/**
 * ScopedPWSReference captures a PWS section reference with scope qualifiers
 * (e.g., "all subparagraphs", "inclusive of 5.2.1 ONLY", "except 3.1.2")
 * and the resolved list of applicable sections from the document outline.
 *
 * @generated from message mono.govcon.v1.ScopedPWSReference
 */ export class ScopedPWSReference extends Message {
    static fromBinary(bytes, options) {
        return new ScopedPWSReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScopedPWSReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScopedPWSReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScopedPWSReference, a, b);
    }
    constructor(data){
        super(), /**
   * Root section number: "5.2"
   *
   * @generated from field: string section = 1;
   */ _define_property(this, "section", ""), /**
   * Section title from outline: "Technical Approach"
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * True when "and all corresponding subparagraphs" qualifier is present.
   *
   * @generated from field: bool includes_all = 3;
   */ _define_property(this, "includesAll", false), /**
   * Specific children when "inclusive of subtask X ONLY" qualifier is present.
   *
   * @generated from field: repeated string only_children = 4;
   */ _define_property(this, "onlyChildren", []), /**
   * Excluded sections when "except X" qualifier is present.
   *
   * @generated from field: repeated string excludes = 5;
   */ _define_property(this, "excludes", []), /**
   * Resolved sections after expanding against the document outline.
   *
   * @generated from field: repeated string expanded_sections = 6;
   */ _define_property(this, "expandedSections", []), /**
   * Original matched text from the CLIN description.
   *
   * @generated from field: string raw_text = 7;
   */ _define_property(this, "rawText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScopedPWSReference, "runtime", proto3);
_define_property(ScopedPWSReference, "typeName", "mono.govcon.v1.ScopedPWSReference");
_define_property(ScopedPWSReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "includes_all",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "only_children",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "excludes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "expanded_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CLINExerciseInfo captures exercise authority (FAR clause), frequency,
 * and period-of-performance duration for a CLIN.
 *
 * @generated from message mono.govcon.v1.CLINExerciseInfo
 */ export class CLINExerciseInfo extends Message {
    static fromBinary(bytes, options) {
        return new CLINExerciseInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINExerciseInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINExerciseInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINExerciseInfo, a, b);
    }
    constructor(data){
        super(), /**
   * FAR clause authorizing exercise (e.g., "52.217-7", "52.217-9", or "").
   *
   * @generated from field: string far_clause = 1;
   */ _define_property(this, "farClause", ""), /**
   * How often the option can be exercised: "once", "multiple", or "".
   *
   * @generated from field: string exercise_frequency = 2;
   */ _define_property(this, "exerciseFrequency", ""), /**
   * Primary PoP duration in months (0 if conditional/unknown).
   *
   * @generated from field: int32 pop_months = 3;
   */ _define_property(this, "popMonths", 0), /**
   * Human-readable PoP description (e.g., "up to 12 months").
   *
   * @generated from field: string pop_description = 4;
   */ _define_property(this, "popDescription", ""), /**
   * True when PoP varies by exercise period (e.g., different during base vs option).
   *
   * @generated from field: bool pop_is_conditional = 5;
   */ _define_property(this, "popIsConditional", false), /**
   * Per-period PoP breakdowns when pop_is_conditional is true.
   *
   * @generated from field: repeated mono.govcon.v1.ConditionalPoP conditional_pops = 6;
   */ _define_property(this, "conditionalPops", []), /**
   * Whether the PoP may extend past the performance period boundary.
   *
   * @generated from field: bool allows_cross_period = 7;
   */ _define_property(this, "allowsCrossPeriod", false), /**
   * Upper bound constraint (e.g., "expiration of the base period").
   *
   * @generated from field: string pop_upper_bound = 8;
   */ _define_property(this, "popUpperBound", ""), /**
   * K11: the schedule row's scope name and letter SLIN. Unset when the row
   * states neither.
   *
   * @generated from field: mono.govcon.v1.ScheduleScopeIdentity scope_identity = 9;
   */ _define_property(this, "scopeIdentity", void 0), /**
   * Where the scope name was read when it is not the line's own row (a
   * funding map's project column): the row's text, its page and document.
   * A team-naming item quotes this row (pangaea parseScopeIdentity).
   *
   * @generated from field: string quote = 10;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: int32 page = 11;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string document_id = 12;
   */ _define_property(this, "documentId", ""), /**
   * SAD-882: the document's own sentence exercising this line's optional task
   * ("The Government hereby partially exercises Optional Task One ...") and
   * its page. Unset when no document says the task is exercised. pangaea's
   * award sync settles the task as exercised from it.
   *
   * @generated from field: string exercised_quote = 13;
   */ _define_property(this, "exercisedQuote", ""), /**
   * @generated from field: int32 exercised_page = 14;
   */ _define_property(this, "exercisedPage", 0), /**
   * The line's own row says it is part of that exercise ("The Optional Task
   * is hereby partially exercised ..."): one of the exercise's lines.
   *
   * @generated from field: bool exercise_line = 15;
   */ _define_property(this, "exerciseLine", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINExerciseInfo, "runtime", proto3);
_define_property(CLINExerciseInfo, "typeName", "mono.govcon.v1.CLINExerciseInfo");
_define_property(CLINExerciseInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "far_clause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercise_frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pop_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "pop_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pop_is_conditional",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "conditional_pops",
            kind: "message",
            T: ConditionalPoP,
            repeated: true
        },
        {
            no: 7,
            name: "allows_cross_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "pop_upper_bound",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "scope_identity",
            kind: "message",
            T: ScheduleScopeIdentity
        },
        {
            no: 10,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "exercised_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "exercised_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "exercise_line",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ScheduleScopeIdentity is a Section B.2 row's sub-CLIN identity (K11).
 *
 * @generated from message mono.govcon.v1.ScheduleScopeIdentity
 */ export class ScheduleScopeIdentity extends Message {
    static fromBinary(bytes, options) {
        return new ScheduleScopeIdentity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScheduleScopeIdentity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScheduleScopeIdentity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScheduleScopeIdentity, a, b);
    }
    constructor(data){
        super(), /**
   * The body of work the line funds, as the row states it.
   *
   * @generated from field: string scope_name = 1;
   */ _define_property(this, "scopeName", ""), /**
   * "stated" whenever scope_name is set. A name the row does not state is
   * never settled here: it travels only as a candidate on the line's
   * LINE_IDENTITY_UNRESOLVED item (key scope_name:<sub-CLIN>).
   *
   * @generated from field: string scope_name_basis = 2;
   */ _define_property(this, "scopeNameBasis", ""), /**
   * The iFAMS letter SLIN ("0101-AB"), the line's join key across
   * instruments.
   *
   * @generated from field: string letter_slin = 3;
   */ _define_property(this, "letterSlin", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScheduleScopeIdentity, "runtime", proto3);
_define_property(ScheduleScopeIdentity, "typeName", "mono.govcon.v1.ScheduleScopeIdentity");
_define_property(ScheduleScopeIdentity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_name_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "letter_slin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ConditionalPoP represents a period-specific PoP duration.
 *
 * @generated from message mono.govcon.v1.ConditionalPoP
 */ export class ConditionalPoP extends Message {
    static fromBinary(bytes, options) {
        return new ConditionalPoP().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConditionalPoP().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConditionalPoP().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConditionalPoP, a, b);
    }
    constructor(data){
        super(), /**
   * Which period this applies to: "base", "option".
   *
   * @generated from field: string during_period = 1;
   */ _define_property(this, "duringPeriod", ""), /**
   * Max months for this condition.
   *
   * @generated from field: int32 pop_months = 2;
   */ _define_property(this, "popMonths", 0), /**
   * Raw text match from the description.
   *
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConditionalPoP, "runtime", proto3);
_define_property(ConditionalPoP, "typeName", "mono.govcon.v1.ConditionalPoP");
_define_property(ConditionalPoP, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "during_period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pop_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLINPricing
 */ export class CLINPricing extends Message {
    static fromBinary(bytes, options) {
        return new CLINPricing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPricing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPricing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPricing, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string unit_price = 1;
   */ _define_property(this, "unitPrice", ""), /**
   * @generated from field: string quantity = 2;
   */ _define_property(this, "quantity", ""), /**
   * @generated from field: string extended_price = 3;
   */ _define_property(this, "extendedPrice", ""), /**
   * @generated from field: string ceiling = 4;
   */ _define_property(this, "ceiling", ""), /**
   * Semantically parsed unit price (isNSP, isNTE, numeric value, etc.)
   *
   * @generated from field: mono.govcon.v1.ParsedPricingValue unit_price_parsed = 5;
   */ _define_property(this, "unitPriceParsed", void 0), /**
   * Semantically parsed extended/total price
   *
   * @generated from field: mono.govcon.v1.ParsedPricingValue extended_price_parsed = 6;
   */ _define_property(this, "extendedPriceParsed", void 0), /**
   * Unit of issue (e.g., "EA", "MO", "LO", "HR")
   *
   * @generated from field: string unit = 7;
   */ _define_property(this, "unit", ""), /**
   * Per-CLIN funding from the FAR 52.232-7 funding summary block.
   *
   * obligated / authorized-to-spend dollars
   *
   * @generated from field: double funded_amount = 8;
   */ _define_property(this, "fundedAmount", 0), /**
   * ceiling not yet obligated
   *
   * @generated from field: double unfunded_amount = 9;
   */ _define_property(this, "unfundedAmount", 0), /**
   * total NTE (funded + unfunded, unless nte_ceiling_stated)
   *
   * @generated from field: double nte_ceiling = 10;
   */ _define_property(this, "nteCeiling", 0), /**
   * True when nte_ceiling was read verbatim from the document's stated
   * multi-period Total NTE Ceiling, false when it is only the derived
   * funded_amount + unfunded_amount floor.
   *
   * @generated from field: bool nte_ceiling_stated = 11;
   */ _define_property(this, "nteCeilingStated", false), /**
   * True when funded_amount was read from a funding-summary entry whose own
   * narrative introducer told the reader the funding is unchanged (e.g.
   * "remains unchanged", "is unchanged") -- a restatement of existing
   * funding, not a change. False covers both a revised/obligated introducer
   * and an unrecognized one.
   *
   * @generated from field: bool funded_amount_restated = 12;
   */ _define_property(this, "fundedAmountRestated", false), /**
   * The cells as the document prints them, captured before any cleanup
   * (K10b): the working fields above may be cleared or moved by the
   * extractor. Absent when the document prints no cell.
   *
   * @generated from field: optional string raw_unit_price = 13;
   */ _define_property(this, "rawUnitPrice", void 0), /**
   * @generated from field: optional string raw_extended_price = 14;
   */ _define_property(this, "rawExtendedPrice", void 0), /**
   * @generated from field: optional string raw_quantity = 15;
   */ _define_property(this, "rawQuantity", void 0), /**
   * @generated from field: optional string raw_ceiling = 16;
   */ _define_property(this, "rawCeiling", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPricing, "runtime", proto3);
_define_property(CLINPricing, "typeName", "mono.govcon.v1.CLINPricing");
_define_property(CLINPricing, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unit_price_parsed",
            kind: "message",
            T: ParsedPricingValue
        },
        {
            no: 6,
            name: "extended_price_parsed",
            kind: "message",
            T: ParsedPricingValue
        },
        {
            no: 7,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "nte_ceiling_stated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "funded_amount_restated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 14,
            name: "raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * ParsedPricingValue represents a semantically parsed pricing field.
 * Raw strings like "NSP", "NTE$316,110.68", "$50,000.00" are parsed into structured fields.
 *
 * @generated from message mono.govcon.v1.ParsedPricingValue
 */ export class ParsedPricingValue extends Message {
    static fromBinary(bytes, options) {
        return new ParsedPricingValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParsedPricingValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParsedPricingValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParsedPricingValue, a, b);
    }
    constructor(data){
        super(), /**
   * Original string as extracted
   *
   * @generated from field: string raw_value = 1;
   */ _define_property(this, "rawValue", ""), /**
   * Parsed dollar amount (0 if non-numeric)
   *
   * @generated from field: double numeric_value = 2;
   */ _define_property(this, "numericValue", 0), /**
   * Whether numeric_value is meaningful
   *
   * @generated from field: bool has_numeric_value = 3;
   */ _define_property(this, "hasNumericValue", false), /**
   * "Not Separately Priced"
   *
   * @generated from field: bool is_nsp = 4;
   */ _define_property(this, "isNsp", false), /**
   * "Not To Exceed"
   *
   * @generated from field: bool is_nte = 5;
   */ _define_property(this, "isNte", false), /**
   * NTE ceiling amount (0 if not specified)
   *
   * @generated from field: double nte_ceiling = 6;
   */ _define_property(this, "nteCeiling", 0), /**
   * Whether nte_ceiling is meaningful
   *
   * @generated from field: bool has_nte_ceiling = 7;
   */ _define_property(this, "hasNteCeiling", false), /**
   * "To Be Determined" or placeholder
   *
   * @generated from field: bool is_tbd = 8;
   */ _define_property(this, "isTbd", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParsedPricingValue, "runtime", proto3);
_define_property(ParsedPricingValue, "typeName", "mono.govcon.v1.ParsedPricingValue");
_define_property(ParsedPricingValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "numeric_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "has_numeric_value",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "has_nte_ceiling",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "is_tbd",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.Deliverable
 */ export class Deliverable extends Message {
    static fromBinary(bytes, options) {
        return new Deliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Deliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Deliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Deliverable, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string deliverable_id = 1;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string due_date = 4;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: string cdrl_reference = 5;
   */ _define_property(this, "cdrlReference", ""), /**
   * monthly, quarterly, weekly, annually, bi-weekly, one-time, as-needed
   *
   * @generated from field: string cadence = 6;
   */ _define_property(this, "cadence", ""), /**
   * e.g., "by the first Friday of each month"
   *
   * @generated from field: string recurring_detail = 7;
   */ _define_property(this, "recurringDetail", ""), /**
   * report, document, presentation, meeting, training, data, other
   *
   * @generated from field: string deliverable_type = 8;
   */ _define_property(this, "deliverableType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Deliverable, "runtime", proto3);
_define_property(Deliverable, "typeName", "mono.govcon.v1.Deliverable");
_define_property(Deliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cdrl_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "deliverable_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RequirementSource
 */ export class RequirementSource extends Message {
    static fromBinary(bytes, options) {
        return new RequirementSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string block_id = 2;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string section_number = 3;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 page_number = 4;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string document_type = 5;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string filename = 6;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementSource, "runtime", proto3);
_define_property(RequirementSource, "typeName", "mono.govcon.v1.RequirementSource");
_define_property(RequirementSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLINStatistics
 */ export class CLINStatistics extends Message {
    static fromBinary(bytes, options) {
        return new CLINStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_clins = 1;
   */ _define_property(this, "totalClins", 0), /**
   * @generated from field: int32 blocks_processed = 2;
   */ _define_property(this, "blocksProcessed", 0), /**
   * @generated from field: int32 section_b_blocks = 3;
   */ _define_property(this, "sectionBBlocks", 0), /**
   * @generated from field: double avg_confidence = 4;
   */ _define_property(this, "avgConfidence", 0), /**
   * @generated from field: int32 clins_with_pricing = 5;
   */ _define_property(this, "clinsWithPricing", 0), /**
   * @generated from field: int32 clins_with_metadata = 6;
   */ _define_property(this, "clinsWithMetadata", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINStatistics, "runtime", proto3);
_define_property(CLINStatistics, "typeName", "mono.govcon.v1.CLINStatistics");
_define_property(CLINStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_clins",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "blocks_processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "section_b_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "avg_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "clins_with_pricing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "clins_with_metadata",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractLCATsRequest
 */ export class ExtractLCATsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractLCATsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractLCATsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractLCATsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractLCATsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * Storage path to HTML output for structured block parsing.
   *
   * @generated from field: string html_path = 2;
   */ _define_property(this, "htmlPath", ""), /**
   * Tenant ID for storage access when downloading html_path.
   *
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * CLINs from Phase 5 — used to look up PWS references and determine roles per CLIN.
   *
   * @generated from field: repeated mono.govcon.v1.CLIN clins = 4;
   */ _define_property(this, "clins", []), /**
   * MinIO path to pre-parsed blocks.json (from ParseDocumentStructure).
   * When provided, baltigo loads blocks from this file instead of re-parsing HTML.
   *
   * @generated from field: string blocks_path = 5;
   */ _define_property(this, "blocksPath", ""), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 6;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 8;
   */ _define_property(this, "docId", ""), /**
   * Original filename of the document being processed.
   *
   * @generated from field: string doc_filename = 9;
   */ _define_property(this, "docFilename", ""), /**
   * Classified document type (e.g., "RFP", "AMENDMENT", "PWS").
   *
   * @generated from field: string doc_type = 10;
   */ _define_property(this, "docType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractLCATsRequest, "runtime", proto3);
_define_property(ExtractLCATsRequest, "typeName", "mono.govcon.v1.ExtractLCATsRequest");
_define_property(ExtractLCATsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clins",
            kind: "message",
            T: CLIN,
            repeated: true
        },
        {
            no: 5,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "doc_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractLCATsResponse
 */ export class ExtractLCATsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractLCATsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractLCATsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractLCATsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractLCATsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * LCAT results contain deeply nested types (education, experience, clearance).
   * Encoded as Struct for flexibility.
   *
   * @generated from field: google.protobuf.Struct result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractLCATsResponse, "runtime", proto3);
_define_property(ExtractLCATsResponse, "typeName", "mono.govcon.v1.ExtractLCATsResponse");
_define_property(ExtractLCATsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyProposalRequest
 */ export class ClassifyProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string minio_path = 3;
   */ _define_property(this, "minioPath", ""), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", ""), /**
   * All filenames in the solicitation package (for batch context).
   * Helps the classifier determine if this doc is a base solicitation or amendment.
   *
   * @generated from field: repeated string batch_filenames = 7;
   */ _define_property(this, "batchFilenames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyProposalRequest, "runtime", proto3);
_define_property(ClassifyProposalRequest, "typeName", "mono.govcon.v1.ClassifyProposalRequest");
_define_property(ClassifyProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "minio_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "batch_filenames",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyProposalResponse
 */ export class ClassifyProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ProposalClassificationResult classification = 1;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: mono.govcon.v1.ProposalSummary summary = 2;
   */ _define_property(this, "summary", void 0), /**
   * Sub-classifications detected from document outline (e.g., SECTION_B, PWS, SECTION_L).
   *
   * @generated from field: repeated mono.govcon.v1.SubClassification sub_classifications = 3;
   */ _define_property(this, "subClassifications", []), /**
   * Extracted opportunity metadata (solicitation number, agency, NAICS, etc.).
   *
   * @generated from field: mono.govcon.v1.OpportunityMetadata opportunity_metadata = 4;
   */ _define_property(this, "opportunityMetadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyProposalResponse, "runtime", proto3);
_define_property(ClassifyProposalResponse, "typeName", "mono.govcon.v1.ClassifyProposalResponse");
_define_property(ClassifyProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification",
            kind: "message",
            T: ProposalClassificationResult
        },
        {
            no: 2,
            name: "summary",
            kind: "message",
            T: ProposalSummary
        },
        {
            no: 3,
            name: "sub_classifications",
            kind: "message",
            T: SubClassification,
            repeated: true
        },
        {
            no: 4,
            name: "opportunity_metadata",
            kind: "message",
            T: OpportunityMetadata
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProposalClassificationResult
 */ export class ProposalClassificationResult extends Message {
    static fromBinary(bytes, options) {
        return new ProposalClassificationResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalClassificationResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalClassificationResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalClassificationResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_type = 1;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string primary_type = 2;
   */ _define_property(this, "primaryType", ""), /**
   * @generated from field: double confidence = 3;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string confidence_source = 4;
   */ _define_property(this, "confidenceSource", ""), /**
   * @generated from field: mono.govcon.v1.ProposalClassificationMetadata metadata = 5;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalClassificationResult, "runtime", proto3);
_define_property(ProposalClassificationResult, "typeName", "mono.govcon.v1.ProposalClassificationResult");
_define_property(ProposalClassificationResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "primary_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "confidence_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "metadata",
            kind: "message",
            T: ProposalClassificationMetadata
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProposalClassificationMetadata
 */ export class ProposalClassificationMetadata extends Message {
    static fromBinary(bytes, options) {
        return new ProposalClassificationMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalClassificationMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalClassificationMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalClassificationMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string amendment_number = 1;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string attachment_id = 2;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string classification_reason = 3;
   */ _define_property(this, "classificationReason", ""), /**
   * Solicitation/contract number this document belongs to (e.g., "36C10B20Q0089").
   *
   * @generated from field: string solicitation_number = 4;
   */ _define_property(this, "solicitationNumber", ""), /**
   * For amendments: what document type this amends (e.g., "RFP", "SOLICITATION").
   *
   * @generated from field: string parent_document_type = 5;
   */ _define_property(this, "parentDocumentType", ""), /**
   * For multi-section documents: additional section types detected beyond primary.
   *
   * @generated from field: repeated string additional_sections = 6;
   */ _define_property(this, "additionalSections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalClassificationMetadata, "runtime", proto3);
_define_property(ProposalClassificationMetadata, "typeName", "mono.govcon.v1.ProposalClassificationMetadata");
_define_property(ProposalClassificationMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "classification_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "parent_document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "additional_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProposalSummary
 */ export class ProposalSummary extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string short_summary = 1;
   */ _define_property(this, "shortSummary", ""), /**
   * @generated from field: repeated string key_topics = 2;
   */ _define_property(this, "keyTopics", []), /**
   * @generated from field: repeated string key_entities = 3;
   */ _define_property(this, "keyEntities", []), /**
   * Solicitation or contract number extracted from content.
   *
   * @generated from field: string solicitation_number = 4;
   */ _define_property(this, "solicitationNumber", ""), /**
   * Issuing agency (e.g., "Department of Veterans Affairs").
   *
   * @generated from field: string agency = 5;
   */ _define_property(this, "agency", ""), /**
   * Proposal due date in ISO 8601 format, if found.
   *
   * @generated from field: string due_date = 6;
   */ _define_property(this, "dueDate", ""), /**
   * Contract number, if referenced.
   *
   * @generated from field: string contract_number = 7;
   */ _define_property(this, "contractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSummary, "runtime", proto3);
_define_property(ProposalSummary, "typeName", "mono.govcon.v1.ProposalSummary");
_define_property(ProposalSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "short_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key_topics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "key_entities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ParseDocumentStructureRequest
 */ export class ParseDocumentStructureRequest extends Message {
    static fromBinary(bytes, options) {
        return new ParseDocumentStructureRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParseDocumentStructureRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParseDocumentStructureRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParseDocumentStructureRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Path to HTML file in MinIO (e.g., "{tenantID}/{docID}.html").
   *
   * @generated from field: string html_path = 1;
   */ _define_property(this, "htmlPath", ""), /**
   * Tenant ID for storage access.
   *
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Path to Datalab JSON file in MinIO (e.g., "{tenantID}/{docID}.json").
   * When provided, blocks are parsed from the JSON (which has native block types
   * including Table with per-block HTML) instead of the HTML.
   *
   * @generated from field: string json_path = 3;
   */ _define_property(this, "jsonPath", ""), /**
   * Project ID for hierarchical MinIO storage of per-doc artifacts.
   *
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for hierarchical MinIO storage.
   *
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID for per-doc artifact storage.
   *
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParseDocumentStructureRequest, "runtime", proto3);
_define_property(ParseDocumentStructureRequest, "typeName", "mono.govcon.v1.ParseDocumentStructureRequest");
_define_property(ParseDocumentStructureRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "json_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ParseDocumentStructureResponse
 */ export class ParseDocumentStructureResponse extends Message {
    static fromBinary(bytes, options) {
        return new ParseDocumentStructureResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParseDocumentStructureResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParseDocumentStructureResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParseDocumentStructureResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Structured blocks parsed from HTML.
   *
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * Hierarchical document outline.
   *
   * @generated from field: mono.govcon.v1.DocumentOutline outline = 2;
   */ _define_property(this, "outline", void 0), /**
   * Number of blocks parsed.
   *
   * @generated from field: int32 block_count = 3;
   */ _define_property(this, "blockCount", 0), /**
   * Detected document type from outline analysis (e.g., "solicitation", "pws", "amendment").
   *
   * @generated from field: string detected_type = 4;
   */ _define_property(this, "detectedType", ""), /**
   * MinIO path where blocks.json was saved (e.g., "{tenantID}/{docID}.blocks.json").
   *
   * @generated from field: string blocks_path = 5;
   */ _define_property(this, "blocksPath", ""), /**
   * MinIO path where outline.json was saved (e.g., "{tenantID}/{docID}.outline.json").
   *
   * @generated from field: string outline_path = 6;
   */ _define_property(this, "outlinePath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParseDocumentStructureResponse, "runtime", proto3);
_define_property(ParseDocumentStructureResponse, "typeName", "mono.govcon.v1.ParseDocumentStructureResponse");
_define_property(ParseDocumentStructureResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "outline",
            kind: "message",
            T: DocumentOutline
        },
        {
            no: 3,
            name: "block_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "detected_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "outline_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DocumentOutline is the hierarchical structure of a document.
 *
 * @generated from message mono.govcon.v1.DocumentOutline
 */ export class DocumentOutline extends Message {
    static fromBinary(bytes, options) {
        return new DocumentOutline().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentOutline().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentOutline().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentOutline, a, b);
    }
    constructor(data){
        super(), /**
   * Root-level sections.
   *
   * @generated from field: repeated mono.govcon.v1.OutlineNode roots = 1;
   */ _define_property(this, "roots", []), /**
   * Total number of sections detected.
   *
   * @generated from field: int32 total_sections = 2;
   */ _define_property(this, "totalSections", 0), /**
   * Whether a table of contents was detected.
   *
   * @generated from field: bool has_toc = 3;
   */ _define_property(this, "hasToc", false), /**
   * Document type detected from structure (e.g., "solicitation", "pws", "amendment").
   *
   * @generated from field: string detected_type = 4;
   */ _define_property(this, "detectedType", ""), /**
   * Flat list of all headings with their full paths.
   *
   * @generated from field: repeated mono.govcon.v1.FlatHeading flat_headings = 5;
   */ _define_property(this, "flatHeadings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentOutline, "runtime", proto3);
_define_property(DocumentOutline, "typeName", "mono.govcon.v1.DocumentOutline");
_define_property(DocumentOutline, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roots",
            kind: "message",
            T: OutlineNode,
            repeated: true
        },
        {
            no: 2,
            name: "total_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "has_toc",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "detected_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "flat_headings",
            kind: "message",
            T: FlatHeading,
            repeated: true
        }
    ]));
/**
 * OutlineNode represents one node in the document outline tree.
 *
 * @generated from message mono.govcon.v1.OutlineNode
 */ export class OutlineNode extends Message {
    static fromBinary(bytes, options) {
        return new OutlineNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutlineNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutlineNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutlineNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string section_number = 2;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 level = 4;
   */ _define_property(this, "level", 0), /**
   * @generated from field: int32 page_number = 5;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string block_id = 6;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: repeated mono.govcon.v1.OutlineNode children = 7;
   */ _define_property(this, "children", []), /**
   * @generated from field: mono.govcon.v1.SectionContext context = 8;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OutlineNode, "runtime", proto3);
_define_property(OutlineNode, "typeName", "mono.govcon.v1.OutlineNode");
_define_property(OutlineNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "children",
            kind: "message",
            T: OutlineNode,
            repeated: true
        },
        {
            no: 8,
            name: "context",
            kind: "message",
            T: SectionContext
        }
    ]));
/**
 * FlatHeading is a flattened view of an outline node.
 *
 * @generated from message mono.govcon.v1.FlatHeading
 */ export class FlatHeading extends Message {
    static fromBinary(bytes, options) {
        return new FlatHeading().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FlatHeading().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FlatHeading().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FlatHeading, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string section_number = 2;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 level = 4;
   */ _define_property(this, "level", 0), /**
   * @generated from field: int32 page_number = 5;
   */ _define_property(this, "pageNumber", 0), /**
   * Full path like "SECTION L > L.5 > L.5.1".
   *
   * @generated from field: string path = 6;
   */ _define_property(this, "path", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FlatHeading, "runtime", proto3);
_define_property(FlatHeading, "typeName", "mono.govcon.v1.FlatHeading");
_define_property(FlatHeading, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * MergeProjectArtifactRequest merges per-document extraction artifacts into
 * a single project-level merged file in MinIO.
 *
 * @generated from message mono.govcon.v1.MergeProjectArtifactRequest
 */ export class MergeProjectArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeProjectArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeProjectArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeProjectArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeProjectArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * Artifact type: "shred", "clins", "lcats", "compliance", "classification", "master_matrix".
   *
   * @generated from field: string artifact_type = 4;
   */ _define_property(this, "artifactType", ""), /**
   * Document IDs whose per-doc artifacts should be merged (all completed so far).
   * Kept for backwards compatibility — when `documents` is also populated,
   * its document_id values take precedence and `document_ids` is ignored.
   *
   * @generated from field: repeated string document_ids = 5;
   */ _define_property(this, "documentIds", []), /**
   * Per-document amendment metadata. When populated, the merge functions
   * stamp every merged row with provenance (source document id + amendment
   * number + amendment sequence) and resolve conflicts using amendment
   * supersession instead of insertion-order. Required for amendment-aware
   * merge behavior; when omitted the merge falls back to legacy union+dedup.
   *
   * @generated from field: repeated mono.govcon.v1.DocumentMergeMetadata documents = 6;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeProjectArtifactRequest, "runtime", proto3);
_define_property(MergeProjectArtifactRequest, "typeName", "mono.govcon.v1.MergeProjectArtifactRequest");
_define_property(MergeProjectArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "documents",
            kind: "message",
            T: DocumentMergeMetadata,
            repeated: true
        }
    ]));
/**
 * DocumentMergeMetadata describes one document being merged into a project-level
 * artifact. The merge functions use this to stamp every output row with its
 * source provenance and to resolve conflicts via amendment supersession.
 *
 * @generated from message mono.govcon.v1.DocumentMergeMetadata
 */ export class DocumentMergeMetadata extends Message {
    static fromBinary(bytes, options) {
        return new DocumentMergeMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentMergeMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentMergeMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentMergeMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * Document type from classification: "BASE", "AMENDMENT", "ATTACHMENT", etc.
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * Normalized 3-digit amendment number ("001", "002", "003"). Empty for base.
   *
   * @generated from field: string amendment_number = 4;
   */ _define_property(this, "amendmentNumber", ""), /**
   * Logical ordering across amendments: 0 = base, 1+ = amendments in order.
   * Used as a tiebreaker when amendment_number can't be parsed numerically.
   *
   * @generated from field: int32 amendment_sequence = 5;
   */ _define_property(this, "amendmentSequence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentMergeMetadata, "runtime", proto3);
_define_property(DocumentMergeMetadata, "typeName", "mono.govcon.v1.DocumentMergeMetadata");
_define_property(DocumentMergeMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.MergeProjectArtifactResponse
 */ export class MergeProjectArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeProjectArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeProjectArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeProjectArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeProjectArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * MinIO path where the merged artifact was saved.
   *
   * @generated from field: string merged_path = 1;
   */ _define_property(this, "mergedPath", ""), /**
   * Number of documents whose artifacts were successfully loaded and merged.
   *
   * @generated from field: int32 documents_merged = 2;
   */ _define_property(this, "documentsMerged", 0), /**
   * Total items in the merged artifact (e.g., total CLINs, total requirements).
   *
   * @generated from field: int32 total_items = 3;
   */ _define_property(this, "totalItems", 0), /**
   * Non-fatal warnings encountered during merge.
   *
   * @generated from field: repeated string warnings = 4;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeProjectArtifactResponse, "runtime", proto3);
_define_property(MergeProjectArtifactResponse, "typeName", "mono.govcon.v1.MergeProjectArtifactResponse");
_define_property(MergeProjectArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "merged_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "documents_merged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_items",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.DetectAmbiguitiesRequest
 */ export class DetectAmbiguitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new DetectAmbiguitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetectAmbiguitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetectAmbiguitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetectAmbiguitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement requirements = 1;
   */ _define_property(this, "requirements", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DetectAmbiguitiesRequest, "runtime", proto3);
_define_property(DetectAmbiguitiesRequest, "typeName", "mono.govcon.v1.DetectAmbiguitiesRequest");
_define_property(DetectAmbiguitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.DetectAmbiguitiesResponse
 */ export class DetectAmbiguitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new DetectAmbiguitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetectAmbiguitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetectAmbiguitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetectAmbiguitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.RequirementAmbiguityResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: mono.govcon.v1.AmbiguityStatistics statistics = 2;
   */ _define_property(this, "statistics", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DetectAmbiguitiesResponse, "runtime", proto3);
_define_property(DetectAmbiguitiesResponse, "typeName", "mono.govcon.v1.DetectAmbiguitiesResponse");
_define_property(DetectAmbiguitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: RequirementAmbiguityResult,
            repeated: true
        },
        {
            no: 2,
            name: "statistics",
            kind: "message",
            T: AmbiguityStatistics
        }
    ]));
/**
 * @generated from message mono.govcon.v1.DetectedAmbiguity
 */ export class DetectedAmbiguity extends Message {
    static fromBinary(bytes, options) {
        return new DetectedAmbiguity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetectedAmbiguity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetectedAmbiguity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetectedAmbiguity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pattern_type = 1;
   */ _define_property(this, "patternType", ""), /**
   * @generated from field: string matched_text = 2;
   */ _define_property(this, "matchedText", ""), /**
   * @generated from field: string suggestion = 3;
   */ _define_property(this, "suggestion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DetectedAmbiguity, "runtime", proto3);
_define_property(DetectedAmbiguity, "typeName", "mono.govcon.v1.DetectedAmbiguity");
_define_property(DetectedAmbiguity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pattern_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "matched_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "suggestion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RequirementAmbiguityResult
 */ export class RequirementAmbiguityResult extends Message {
    static fromBinary(bytes, options) {
        return new RequirementAmbiguityResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementAmbiguityResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementAmbiguityResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementAmbiguityResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: repeated mono.govcon.v1.DetectedAmbiguity ambiguities = 2;
   */ _define_property(this, "ambiguities", []), /**
   * Priority: HIGH, MEDIUM, LOW.
   *
   * @generated from field: string priority = 3;
   */ _define_property(this, "priority", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementAmbiguityResult, "runtime", proto3);
_define_property(RequirementAmbiguityResult, "typeName", "mono.govcon.v1.RequirementAmbiguityResult");
_define_property(RequirementAmbiguityResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "ambiguities",
            kind: "message",
            T: DetectedAmbiguity,
            repeated: true
        },
        {
            no: 3,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AmbiguityStatistics
 */ export class AmbiguityStatistics extends Message {
    static fromBinary(bytes, options) {
        return new AmbiguityStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AmbiguityStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AmbiguityStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AmbiguityStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_analyzed = 1;
   */ _define_property(this, "totalAnalyzed", 0), /**
   * @generated from field: int32 requirements_with_ambiguities = 2;
   */ _define_property(this, "requirementsWithAmbiguities", 0), /**
   * @generated from field: int32 total_ambiguities = 3;
   */ _define_property(this, "totalAmbiguities", 0), /**
   * @generated from field: map<string, int32> by_type = 4;
   */ _define_property(this, "byType", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(AmbiguityStatistics, "runtime", proto3);
_define_property(AmbiguityStatistics, "typeName", "mono.govcon.v1.AmbiguityStatistics");
_define_property(AmbiguityStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_analyzed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "requirements_with_ambiguities",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_ambiguities",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "by_type",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CompareAmendmentsRequest
 */ export class CompareAmendmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompareAmendmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareAmendmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareAmendmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareAmendmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement base_requirements = 1;
   */ _define_property(this, "baseRequirements", []), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement amendment_requirements = 2;
   */ _define_property(this, "amendmentRequirements", []), /**
   * When true, uses LLM to validate detected changes and filter false positives.
   *
   * @generated from field: bool validate_with_llm = 3;
   */ _define_property(this, "validateWithLlm", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareAmendmentsRequest, "runtime", proto3);
_define_property(CompareAmendmentsRequest, "typeName", "mono.govcon.v1.CompareAmendmentsRequest");
_define_property(CompareAmendmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base_requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 2,
            name: "amendment_requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 3,
            name: "validate_with_llm",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CompareAmendmentsResponse
 */ export class CompareAmendmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompareAmendmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareAmendmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareAmendmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareAmendmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.RequirementChange changes = 1;
   */ _define_property(this, "changes", []), /**
   * @generated from field: mono.govcon.v1.AmendmentComparisonStatistics statistics = 2;
   */ _define_property(this, "statistics", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareAmendmentsResponse, "runtime", proto3);
_define_property(CompareAmendmentsResponse, "typeName", "mono.govcon.v1.CompareAmendmentsResponse");
_define_property(CompareAmendmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "changes",
            kind: "message",
            T: RequirementChange,
            repeated: true
        },
        {
            no: 2,
            name: "statistics",
            kind: "message",
            T: AmendmentComparisonStatistics
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RequirementChange
 */ export class RequirementChange extends Message {
    static fromBinary(bytes, options) {
        return new RequirementChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * Status: UNCHANGED, MODIFIED, ADDED, REMOVED, SUPERSEDED.
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * Match method: EXACT_TEXT, FUZZY_TEXT, SPLIT, UNMATCHED.
   *
   * @generated from field: string match_method = 3;
   */ _define_property(this, "matchMethod", ""), /**
   * @generated from field: double similarity_score = 4;
   */ _define_property(this, "similarityScore", 0), /**
   * @generated from field: string base_text = 5;
   */ _define_property(this, "baseText", ""), /**
   * @generated from field: string amendment_text = 6;
   */ _define_property(this, "amendmentText", ""), /**
   * @generated from field: string base_section = 7;
   */ _define_property(this, "baseSection", ""), /**
   * @generated from field: string amendment_section = 8;
   */ _define_property(this, "amendmentSection", ""), /**
   * @generated from field: repeated string added_words = 9;
   */ _define_property(this, "addedWords", []), /**
   * @generated from field: repeated string removed_words = 10;
   */ _define_property(this, "removedWords", []), /**
   * @generated from field: string change_description = 11;
   */ _define_property(this, "changeDescription", ""), /**
   * @generated from field: string base_requirement_id = 12;
   */ _define_property(this, "baseRequirementId", ""), /**
   * @generated from field: string amendment_requirement_id = 13;
   */ _define_property(this, "amendmentRequirementId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementChange, "runtime", proto3);
_define_property(RequirementChange, "typeName", "mono.govcon.v1.RequirementChange");
_define_property(RequirementChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "match_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "similarity_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "base_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "amendment_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "base_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "amendment_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "added_words",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "removed_words",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "base_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "amendment_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AmendmentComparisonStatistics
 */ export class AmendmentComparisonStatistics extends Message {
    static fromBinary(bytes, options) {
        return new AmendmentComparisonStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AmendmentComparisonStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AmendmentComparisonStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AmendmentComparisonStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_base_requirements = 1;
   */ _define_property(this, "totalBaseRequirements", 0), /**
   * @generated from field: int32 total_amendment_requirements = 2;
   */ _define_property(this, "totalAmendmentRequirements", 0), /**
   * @generated from field: int32 unchanged = 3;
   */ _define_property(this, "unchanged", 0), /**
   * @generated from field: int32 modified = 4;
   */ _define_property(this, "modified", 0), /**
   * @generated from field: int32 added = 5;
   */ _define_property(this, "added", 0), /**
   * @generated from field: int32 removed = 6;
   */ _define_property(this, "removed", 0), /**
   * @generated from field: int32 superseded = 7;
   */ _define_property(this, "superseded", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AmendmentComparisonStatistics, "runtime", proto3);
_define_property(AmendmentComparisonStatistics, "typeName", "mono.govcon.v1.AmendmentComparisonStatistics");
_define_property(AmendmentComparisonStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_base_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_amendment_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "unchanged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "modified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "superseded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GenerateMasterMatrixRequest
 */ export class GenerateMasterMatrixRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateMasterMatrixRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateMasterMatrixRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateMasterMatrixRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateMasterMatrixRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ShredRequirement base_requirements = 1;
   */ _define_property(this, "baseRequirements", []), /**
   * @generated from field: repeated mono.govcon.v1.AmendmentComparison comparisons = 2;
   */ _define_property(this, "comparisons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateMasterMatrixRequest, "runtime", proto3);
_define_property(GenerateMasterMatrixRequest, "typeName", "mono.govcon.v1.GenerateMasterMatrixRequest");
_define_property(GenerateMasterMatrixRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base_requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 2,
            name: "comparisons",
            kind: "message",
            T: AmendmentComparison,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GenerateMasterMatrixResponse
 */ export class GenerateMasterMatrixResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateMasterMatrixResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateMasterMatrixResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateMasterMatrixResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateMasterMatrixResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.MasterMatrixEntry entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateMasterMatrixResponse, "runtime", proto3);
_define_property(GenerateMasterMatrixResponse, "typeName", "mono.govcon.v1.GenerateMasterMatrixResponse");
_define_property(GenerateMasterMatrixResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: MasterMatrixEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AmendmentComparison
 */ export class AmendmentComparison extends Message {
    static fromBinary(bytes, options) {
        return new AmendmentComparison().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AmendmentComparison().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AmendmentComparison().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AmendmentComparison, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string amendment_number = 1;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: repeated mono.govcon.v1.RequirementChange changes = 2;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AmendmentComparison, "runtime", proto3);
_define_property(AmendmentComparison, "typeName", "mono.govcon.v1.AmendmentComparison");
_define_property(AmendmentComparison, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changes",
            kind: "message",
            T: RequirementChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.MasterMatrixEntry
 */ export class MasterMatrixEntry extends Message {
    static fromBinary(bytes, options) {
        return new MasterMatrixEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MasterMatrixEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MasterMatrixEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MasterMatrixEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: string current_text = 2;
   */ _define_property(this, "currentText", ""), /**
   * Current status: ACTIVE, REMOVED.
   *
   * @generated from field: string current_status = 3;
   */ _define_property(this, "currentStatus", ""), /**
   * @generated from field: string current_section = 4;
   */ _define_property(this, "currentSection", ""), /**
   * @generated from field: repeated mono.govcon.v1.RequirementVersion versions = 5;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated string categories = 6;
   */ _define_property(this, "categories", []), /**
   * @generated from field: string obligation = 7;
   */ _define_property(this, "obligation", ""), /**
   * Amendment where first introduced (empty = base).
   *
   * @generated from field: string introduced_in = 8;
   */ _define_property(this, "introducedIn", ""), /**
   * Amendment where last modified.
   *
   * @generated from field: string last_modified_in = 9;
   */ _define_property(this, "lastModifiedIn", ""), /**
   * Amendment where removed.
   *
   * @generated from field: string removed_in = 10;
   */ _define_property(this, "removedIn", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MasterMatrixEntry, "runtime", proto3);
_define_property(MasterMatrixEntry, "typeName", "mono.govcon.v1.MasterMatrixEntry");
_define_property(MasterMatrixEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "current_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "current_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "current_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "versions",
            kind: "message",
            T: RequirementVersion,
            repeated: true
        },
        {
            no: 6,
            name: "categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "obligation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "introduced_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "last_modified_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "removed_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RequirementVersion
 */ export class RequirementVersion extends Message {
    static fromBinary(bytes, options) {
        return new RequirementVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementVersion, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = base version.
   *
   * @generated from field: string amendment_number = 1;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * Status: UNCHANGED, MODIFIED, ADDED, REMOVED.
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string section = 4;
   */ _define_property(this, "section", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementVersion, "runtime", proto3);
_define_property(RequirementVersion, "typeName", "mono.govcon.v1.RequirementVersion");
_define_property(RequirementVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessQARequest
 */ export class ProcessQARequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessQARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessQARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessQARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessQARequest, a, b);
    }
    constructor(data){
        super(), /**
   * Excel file bytes (inline).
   *
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * Or MinIO path to Excel file.
   *
   * @generated from field: string minio_path = 2;
   */ _define_property(this, "minioPath", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * Requirements to link Q&A entries against.
   *
   * @generated from field: repeated mono.govcon.v1.ShredRequirement requirements = 4;
   */ _define_property(this, "requirements", []), /**
   * @generated from field: mono.govcon.v1.ProcessQAOptions options = 5;
   */ _define_property(this, "options", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessQARequest, "runtime", proto3);
_define_property(ProcessQARequest, "typeName", "mono.govcon.v1.ProcessQARequest");
_define_property(ProcessQARequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "minio_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirements",
            kind: "message",
            T: ShredRequirement,
            repeated: true
        },
        {
            no: 5,
            name: "options",
            kind: "message",
            T: ProcessQAOptions
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessQAOptions
 */ export class ProcessQAOptions extends Message {
    static fromBinary(bytes, options) {
        return new ProcessQAOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessQAOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessQAOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessQAOptions, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sheet_name = 1;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: int32 skip_rows = 2;
   */ _define_property(this, "skipRows", 0), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string file_name = 4;
   */ _define_property(this, "fileName", ""), /**
   * Whether to run LLM impact analysis on Q&A entries.
   *
   * @generated from field: bool analyze_impact = 5;
   */ _define_property(this, "analyzeImpact", false), /**
   * Whether to link Q&A entries to requirements.
   *
   * @generated from field: bool link_to_requirements = 6;
   */ _define_property(this, "linkToRequirements", false), /**
   * @generated from field: double min_link_confidence = 7;
   */ _define_property(this, "minLinkConfidence", 0), /**
   * @generated from field: int32 max_links_per_entry = 8;
   */ _define_property(this, "maxLinksPerEntry", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessQAOptions, "runtime", proto3);
_define_property(ProcessQAOptions, "typeName", "mono.govcon.v1.ProcessQAOptions");
_define_property(ProcessQAOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "skip_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "analyze_impact",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "link_to_requirements",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "min_link_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "max_links_per_entry",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProcessQAResponse
 */ export class ProcessQAResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessQAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessQAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessQAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessQAResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.QAEntry entries = 1;
   */ _define_property(this, "entries", []), /**
   * @generated from field: repeated mono.govcon.v1.QAEntryLinks links = 2;
   */ _define_property(this, "links", []), /**
   * @generated from field: mono.govcon.v1.QAStatistics statistics = 3;
   */ _define_property(this, "statistics", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessQAResponse, "runtime", proto3);
_define_property(ProcessQAResponse, "typeName", "mono.govcon.v1.ProcessQAResponse");
_define_property(ProcessQAResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: QAEntry,
            repeated: true
        },
        {
            no: 2,
            name: "links",
            kind: "message",
            T: QAEntryLinks,
            repeated: true
        },
        {
            no: 3,
            name: "statistics",
            kind: "message",
            T: QAStatistics
        }
    ]));
/**
 * @generated from message mono.govcon.v1.QAEntry
 */ export class QAEntry extends Message {
    static fromBinary(bytes, options) {
        return new QAEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string question_number = 2;
   */ _define_property(this, "questionNumber", ""), /**
   * @generated from field: string question = 3;
   */ _define_property(this, "question", ""), /**
   * @generated from field: string answer = 4;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: mono.govcon.v1.ParsedReference reference = 5;
   */ _define_property(this, "reference", void 0), /**
   * Impact type: CLARIFIES, MODIFIES, RESTRICTS, ADDS_INFO, NO_CHANGE.
   *
   * @generated from field: string impact_type = 6;
   */ _define_property(this, "impactType", ""), /**
   * @generated from field: string impact_summary = 7;
   */ _define_property(this, "impactSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAEntry, "runtime", proto3);
_define_property(QAEntry, "typeName", "mono.govcon.v1.QAEntry");
_define_property(QAEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reference",
            kind: "message",
            T: ParsedReference
        },
        {
            no: 6,
            name: "impact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "impact_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ParsedReference
 */ export class ParsedReference extends Message {
    static fromBinary(bytes, options) {
        return new ParsedReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParsedReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParsedReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParsedReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string raw_text = 1;
   */ _define_property(this, "rawText", ""), /**
   * @generated from field: string parsed_section = 2;
   */ _define_property(this, "parsedSection", ""), /**
   * @generated from field: int32 parsed_page = 3;
   */ _define_property(this, "parsedPage", 0), /**
   * @generated from field: string parsed_document = 4;
   */ _define_property(this, "parsedDocument", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParsedReference, "runtime", proto3);
_define_property(ParsedReference, "typeName", "mono.govcon.v1.ParsedReference");
_define_property(ParsedReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parsed_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parsed_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "parsed_document",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.QAEntryLinks
 */ export class QAEntryLinks extends Message {
    static fromBinary(bytes, options) {
        return new QAEntryLinks().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAEntryLinks().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAEntryLinks().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAEntryLinks, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string qa_entry_id = 1;
   */ _define_property(this, "qaEntryId", ""), /**
   * @generated from field: repeated mono.govcon.v1.QARequirementLink links = 2;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAEntryLinks, "runtime", proto3);
_define_property(QAEntryLinks, "typeName", "mono.govcon.v1.QAEntryLinks");
_define_property(QAEntryLinks, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qa_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "links",
            kind: "message",
            T: QARequirementLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.QARequirementLink
 */ export class QARequirementLink extends Message {
    static fromBinary(bytes, options) {
        return new QARequirementLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QARequirementLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QARequirementLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QARequirementLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: double confidence = 2;
   */ _define_property(this, "confidence", 0), /**
   * Match reason: SECTION_MATCH, TEXT_SIMILARITY, KEYWORD_MATCH.
   *
   * @generated from field: string match_reason = 3;
   */ _define_property(this, "matchReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QARequirementLink, "runtime", proto3);
_define_property(QARequirementLink, "typeName", "mono.govcon.v1.QARequirementLink");
_define_property(QARequirementLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "match_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.QAStatistics
 */ export class QAStatistics extends Message {
    static fromBinary(bytes, options) {
        return new QAStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_questions = 1;
   */ _define_property(this, "totalQuestions", 0), /**
   * @generated from field: int32 parse_errors = 2;
   */ _define_property(this, "parseErrors", 0), /**
   * @generated from field: int32 with_impact = 3;
   */ _define_property(this, "withImpact", 0), /**
   * @generated from field: int32 linked_to_requirements = 4;
   */ _define_property(this, "linkedToRequirements", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAStatistics, "runtime", proto3);
_define_property(QAStatistics, "typeName", "mono.govcon.v1.QAStatistics");
_define_property(QAStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_questions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "parse_errors",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "with_impact",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "linked_to_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExpandSentencesRequest
 */ export class ExpandSentencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExpandSentencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExpandSentencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExpandSentencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExpandSentencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * Extraction mode: SWM_ONLY, ACTIONABLE, ALL.
   *
   * @generated from field: string mode = 2;
   */ _define_property(this, "mode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExpandSentencesRequest, "runtime", proto3);
_define_property(ExpandSentencesRequest, "typeName", "mono.govcon.v1.ExpandSentencesRequest");
_define_property(ExpandSentencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExpandSentencesResponse
 */ export class ExpandSentencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExpandSentencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExpandSentencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExpandSentencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExpandSentencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * @generated from field: int32 original_count = 2;
   */ _define_property(this, "originalCount", 0), /**
   * @generated from field: int32 expanded_count = 3;
   */ _define_property(this, "expandedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExpandSentencesResponse, "runtime", proto3);
_define_property(ExpandSentencesResponse, "typeName", "mono.govcon.v1.ExpandSentencesResponse");
_define_property(ExpandSentencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "original_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "expanded_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SubClassification
 */ export class SubClassification extends Message {
    static fromBinary(bytes, options) {
        return new SubClassification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubClassification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubClassification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubClassification, a, b);
    }
    constructor(data){
        super(), /**
   * Section type detected from outline (e.g., "SECTION_B", "PWS", "SECTION_L", "SECTION_M").
   *
   * @generated from field: string section_type = 1;
   */ _define_property(this, "sectionType", ""), /**
   * Section letter or number (e.g., "B", "L", "M").
   *
   * @generated from field: string section_number = 2;
   */ _define_property(this, "sectionNumber", ""), /**
   * Section title (e.g., "Performance Work Statement").
   *
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: double confidence = 4;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: int32 page_start = 5;
   */ _define_property(this, "pageStart", 0), /**
   * @generated from field: int32 page_end = 6;
   */ _define_property(this, "pageEnd", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubClassification, "runtime", proto3);
_define_property(SubClassification, "typeName", "mono.govcon.v1.SubClassification");
_define_property(SubClassification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "page_start",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "page_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.OpportunityMetadata
 */ export class OpportunityMetadata extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string solicitation_number = 1;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string contract_number = 2;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string agency = 3;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string department = 4;
   */ _define_property(this, "department", ""), /**
   * @generated from field: string office = 5;
   */ _define_property(this, "office", ""), /**
   * @generated from field: string suggested_project_name = 6;
   */ _define_property(this, "suggestedProjectName", ""), /**
   * @generated from field: string due_date = 7;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: string naics_code = 8;
   */ _define_property(this, "naicsCode", ""), /**
   * Set-aside type (e.g., "Small Business", "8(a)", "SDVOSB", "HUBZone").
   *
   * @generated from field: string set_aside = 9;
   */ _define_property(this, "setAside", ""), /**
   * Contract type (e.g., "FFP", "T&M", "CPFF", "IDIQ").
   *
   * @generated from field: string contract_type = 10;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: double confidence = 11;
   */ _define_property(this, "confidence", 0), /**
   * Named contract vehicle (e.g., "Alliant 2", "T4NG2", "OASIS+", "CIO-SP3").
   *
   * @generated from field: string contract_vehicle = 12;
   */ _define_property(this, "contractVehicle", ""), /**
   * Vehicle ID matching vehicle_lcats catalog (e.g., "alliant2", "t4ng2").
   *
   * @generated from field: string contract_vehicle_id = 13;
   */ _define_property(this, "contractVehicleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityMetadata, "runtime", proto3);
_define_property(OpportunityMetadata, "typeName", "mono.govcon.v1.OpportunityMetadata");
_define_property(OpportunityMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "suggested_project_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifySpreadsheetRequest
 */ export class ClassifySpreadsheetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifySpreadsheetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifySpreadsheetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifySpreadsheetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifySpreadsheetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * Optional: when provided, baltigo saves per-doc classification.json to MinIO.
   *
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifySpreadsheetRequest, "runtime", proto3);
_define_property(ClassifySpreadsheetRequest, "typeName", "mono.govcon.v1.ClassifySpreadsheetRequest");
_define_property(ClassifySpreadsheetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifySpreadsheetResponse
 */ export class ClassifySpreadsheetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifySpreadsheetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifySpreadsheetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifySpreadsheetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifySpreadsheetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ProposalClassificationResult classification = 1;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: repeated mono.govcon.v1.SpreadsheetTabSummary tabs = 2;
   */ _define_property(this, "tabs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifySpreadsheetResponse, "runtime", proto3);
_define_property(ClassifySpreadsheetResponse, "typeName", "mono.govcon.v1.ClassifySpreadsheetResponse");
_define_property(ClassifySpreadsheetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification",
            kind: "message",
            T: ProposalClassificationResult
        },
        {
            no: 2,
            name: "tabs",
            kind: "message",
            T: SpreadsheetTabSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SpreadsheetTabSummary
 */ export class SpreadsheetTabSummary extends Message {
    static fromBinary(bytes, options) {
        return new SpreadsheetTabSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpreadsheetTabSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpreadsheetTabSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpreadsheetTabSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tab_name = 1;
   */ _define_property(this, "tabName", ""), /**
   * Classification of this tab (e.g., "PRICING", "LABOR_RATES", "QA", "CLIN_TABLE").
   *
   * @generated from field: string classification = 2;
   */ _define_property(this, "classification", ""), /**
   * @generated from field: string summary = 3;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: int32 row_count = 4;
   */ _define_property(this, "rowCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SpreadsheetTabSummary, "runtime", proto3);
_define_property(SpreadsheetTabSummary, "typeName", "mono.govcon.v1.SpreadsheetTabSummary");
_define_property(SpreadsheetTabSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tab_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "classification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractProjectLCATsRequest
 */ export class ExtractProjectLCATsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractProjectLCATsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractProjectLCATsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractProjectLCATsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractProjectLCATsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Pre-merged CLINs from all project documents.
   *
   * @generated from field: repeated mono.govcon.v1.CLIN clins = 3;
   */ _define_property(this, "clins", []), /**
   * MinIO paths to PWS/SOW HTML documents for content lookup.
   *
   * @generated from field: repeated mono.govcon.v1.DocumentReference pws_documents = 4;
   */ _define_property(this, "pwsDocuments", []), /**
   * MinIO paths to attachment documents for context.
   *
   * @generated from field: repeated mono.govcon.v1.DocumentReference attachment_documents = 5;
   */ _define_property(this, "attachmentDocuments", []), /**
   * Per-document amendment metadata for the entire batch. Used by the
   * post-extraction stamping step to attach amendment_number /
   * amendment_sequence to each LCAT row by matching its Source.DocumentID,
   * then collapse multi-version rows of the same role across base + amds
   * and mark the latest as is_current_version=true. Optional — when
   * empty, LCATs are emitted without amendment supersession (legacy).
   *
   * @generated from field: repeated mono.govcon.v1.DocumentMergeMetadata documents = 6;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractProjectLCATsRequest, "runtime", proto3);
_define_property(ExtractProjectLCATsRequest, "typeName", "mono.govcon.v1.ExtractProjectLCATsRequest");
_define_property(ExtractProjectLCATsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clins",
            kind: "message",
            T: CLIN,
            repeated: true
        },
        {
            no: 4,
            name: "pws_documents",
            kind: "message",
            T: DocumentReference,
            repeated: true
        },
        {
            no: 5,
            name: "attachment_documents",
            kind: "message",
            T: DocumentReference,
            repeated: true
        },
        {
            no: 6,
            name: "documents",
            kind: "message",
            T: DocumentMergeMetadata,
            repeated: true
        }
    ]));
/**
 * DocumentReference identifies a project document and its storage location.
 *
 * @generated from message mono.govcon.v1.DocumentReference
 */ export class DocumentReference extends Message {
    static fromBinary(bytes, options) {
        return new DocumentReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * MinIO path to the HTML version of the document.
   *
   * @generated from field: string html_path = 2;
   */ _define_property(this, "htmlPath", ""), /**
   * Classified document type (e.g., "RFP", "PWS", "ATTACHMENT").
   *
   * @generated from field: string classification = 3;
   */ _define_property(this, "classification", ""), /**
   * @generated from field: string filename = 4;
   */ _define_property(this, "filename", ""), /**
   * MinIO path to pre-parsed blocks.json.
   *
   * @generated from field: string blocks_path = 5;
   */ _define_property(this, "blocksPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentReference, "runtime", proto3);
_define_property(DocumentReference, "typeName", "mono.govcon.v1.DocumentReference");
_define_property(DocumentReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "classification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractProjectLCATsResponse
 */ export class ExtractProjectLCATsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractProjectLCATsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractProjectLCATsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractProjectLCATsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractProjectLCATsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * LCAT results encoded as Struct for flexibility (same pattern as ExtractLCATsResponse).
   *
   * @generated from field: google.protobuf.Struct result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractProjectLCATsResponse, "runtime", proto3);
_define_property(ExtractProjectLCATsResponse, "typeName", "mono.govcon.v1.ExtractProjectLCATsResponse");
_define_property(ExtractProjectLCATsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * ExtractedTeamTier represents a team-level pricing tier found in a solicitation
 * (e.g., "Level 5" at "$___/mo" for "Base Period").
 *
 * @generated from message mono.govcon.v1.ExtractedTeamTier
 */ export class ExtractedTeamTier extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTeamTier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTeamTier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTeamTier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTeamTier, a, b);
    }
    constructor(data){
        super(), /**
   * Tier label as it appears in the solicitation (e.g., "Level 5", "Team Size Large").
   *
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * Normalized ordinal (1=smallest, 5=largest).
   *
   * @generated from field: int32 tier_number = 2;
   */ _define_property(this, "tierNumber", 0), /**
   * Which performance period this tier pricing applies to.
   *
   * @generated from field: string period = 3;
   */ _define_property(this, "period", ""), /**
   * Price placeholder or extracted price (e.g., "$___/mo", "$150,000.00").
   *
   * @generated from field: string price_placeholder = 4;
   */ _define_property(this, "pricePlaceholder", ""), /**
   * Tier composition definition, if the solicitation specifies it. May be empty.
   *
   * @generated from field: mono.govcon.v1.ExtractedTierDefinition definition = 5;
   */ _define_property(this, "definition", void 0), /**
   * Where this tier was found: "clin_table", "pws_text", "excel_attachment".
   *
   * @generated from field: string source = 6;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTeamTier, "runtime", proto3);
_define_property(ExtractedTeamTier, "typeName", "mono.govcon.v1.ExtractedTeamTier");
_define_property(ExtractedTeamTier, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tier_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "price_placeholder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "definition",
            kind: "message",
            T: ExtractedTierDefinition
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExtractedTierDefinition captures what roles/FTEs make up a team tier,
 * when the solicitation defines it (often it doesn't — the offeror proposes).
 *
 * @generated from message mono.govcon.v1.ExtractedTierDefinition
 */ export class ExtractedTierDefinition extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTierDefinition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTierDefinition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTierDefinition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTierDefinition, a, b);
    }
    constructor(data){
        super(), /**
   * Original text from the solicitation describing the tier composition.
   *
   * @generated from field: string raw_text = 1;
   */ _define_property(this, "rawText", ""), /**
   * Parsed roles with counts, if extractable.
   *
   * @generated from field: repeated mono.govcon.v1.ExtractedTierRole roles = 2;
   */ _define_property(this, "roles", []), /**
   * Total headcount if stated in the solicitation (equals fte_max for ranges).
   *
   * @generated from field: int32 total_ftes = 3;
   */ _define_property(this, "totalFtes", 0), /**
   * Where the definition was found (e.g., "PWS 5.2.1", "Attachment J-3 Sheet 2").
   *
   * @generated from field: string source_location = 4;
   */ _define_property(this, "sourceLocation", ""), /**
   * Minimum FTEs when a range is specified (e.g., 30 in "30-35 FTEs").
   *
   * @generated from field: int32 fte_min = 5;
   */ _define_property(this, "fteMin", 0), /**
   * Maximum FTEs when a range is specified (e.g., 35 in "30-35 FTEs").
   *
   * @generated from field: int32 fte_max = 6;
   */ _define_property(this, "fteMax", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTierDefinition, "runtime", proto3);
_define_property(ExtractedTierDefinition, "typeName", "mono.govcon.v1.ExtractedTierDefinition");
_define_property(ExtractedTierDefinition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "roles",
            kind: "message",
            T: ExtractedTierRole,
            repeated: true
        },
        {
            no: 3,
            name: "total_ftes",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "source_location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fte_min",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "fte_max",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExtractedTierRole is a single role within a team tier definition.
 *
 * @generated from message mono.govcon.v1.ExtractedTierRole
 */ export class ExtractedTierRole extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTierRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTierRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTierRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTierRole, a, b);
    }
    constructor(data){
        super(), /**
   * Role title (e.g., "Senior Software Developer").
   *
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * Number of this role in the tier.
   *
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0), /**
   * FTE equivalent (may differ from count for part-time roles).
   *
   * @generated from field: double ftes = 3;
   */ _define_property(this, "ftes", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTierRole, "runtime", proto3);
_define_property(ExtractedTierRole, "typeName", "mono.govcon.v1.ExtractedTierRole");
_define_property(ExtractedTierRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * ExtractedFeeTarget captures fee/profit constraints stated in the solicitation.
 *
 * @generated from message mono.govcon.v1.ExtractedFeeTarget
 */ export class ExtractedFeeTarget extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedFeeTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedFeeTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedFeeTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedFeeTarget, a, b);
    }
    constructor(data){
        super(), /**
   * Fee type: "fixed_fee", "award_fee", "incentive_fee", "none_specified".
   *
   * @generated from field: string fee_type = 1;
   */ _define_property(this, "feeType", ""), /**
   * Target fee percentage if specified (e.g., 0.08 for 8%).
   *
   * @generated from field: double target_percentage = 2;
   */ _define_property(this, "targetPercentage", 0), /**
   * Maximum fee percentage (statutory or stated).
   *
   * @generated from field: double max_percentage = 3;
   */ _define_property(this, "maxPercentage", 0), /**
   * Source text from the solicitation.
   *
   * @generated from field: string raw_text = 4;
   */ _define_property(this, "rawText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedFeeTarget, "runtime", proto3);
_define_property(ExtractedFeeTarget, "typeName", "mono.govcon.v1.ExtractedFeeTarget");
_define_property(ExtractedFeeTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fee_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "max_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * IndirectRateConfig stores a company's indirect rate structure.
 * Companies can have multiple named configs (e.g., "FY2026 Rates", "Competitive Scenario").
 *
 * @generated from message mono.govcon.v1.IndirectRateConfig
 */ export class IndirectRateConfig extends Message {
    static fromBinary(bytes, options) {
        return new IndirectRateConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndirectRateConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndirectRateConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndirectRateConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * Human-readable name (e.g., "FY2026 Rates", "Competitive Scenario").
   *
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * Whether this is the company's default rate config.
   *
   * @generated from field: bool is_default = 4;
   */ _define_property(this, "isDefault", false), /**
   * Ordered list of indirect rate pools (fringe → overhead → G&A).
   *
   * @generated from field: repeated mono.govcon.v1.IndirectRatePool pools = 5;
   */ _define_property(this, "pools", []), /**
   * G&A allocation base method: "total_cost_input" or "value_added".
   *
   * @generated from field: string ga_base_method = 6;
   */ _define_property(this, "gaBaseMethod", ""), /**
   * true = DCAA standard multiplicative cascading; false = additive (simplified).
   *
   * @generated from field: bool use_multiplicative = 7;
   */ _define_property(this, "useMultiplicative", false), /**
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string updated_at = 9;
   */ _define_property(this, "updatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndirectRateConfig, "runtime", proto3);
_define_property(IndirectRateConfig, "typeName", "mono.govcon.v1.IndirectRateConfig");
_define_property(IndirectRateConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "pools",
            kind: "message",
            T: IndirectRatePool,
            repeated: true
        },
        {
            no: 6,
            name: "ga_base_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "use_multiplicative",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * IndirectRatePool represents one pool in the indirect rate cascade
 * (e.g., fringe at 25%, overhead at 20%, G&A at 10%).
 *
 * @generated from message mono.govcon.v1.IndirectRatePool
 */ export class IndirectRatePool extends Message {
    static fromBinary(bytes, options) {
        return new IndirectRatePool().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndirectRatePool().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndirectRatePool().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndirectRatePool, a, b);
    }
    constructor(data){
        super(), /**
   * Pool name: "fringe", "overhead", "g_and_a", "facilities", "material_handling".
   *
   * @generated from field: string pool_name = 1;
   */ _define_property(this, "poolName", ""), /**
   * Rate as a decimal (e.g., 0.25 for 25%).
   *
   * @generated from field: double rate_percent = 2;
   */ _define_property(this, "ratePercent", 0), /**
   * Application order in the cascade (1=first, 2=second, etc.).
   *
   * @generated from field: int32 apply_order = 3;
   */ _define_property(this, "applyOrder", 0), /**
   * What cost base this pool applies to: "all_labor", "direct_labor_plus_fringe", "total_cost_input".
   *
   * @generated from field: string allocation_base = 4;
   */ _define_property(this, "allocationBase", ""), /**
   * Which CLIN cost types this pool applies to (e.g., ["labor"] for fringe/OH).
   *
   * @generated from field: repeated string applies_to_cost_types = 5;
   */ _define_property(this, "appliesToCostTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndirectRatePool, "runtime", proto3);
_define_property(IndirectRatePool, "typeName", "mono.govcon.v1.IndirectRatePool");
_define_property(IndirectRatePool, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pool_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rate_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "apply_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "allocation_base",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "applies_to_cost_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * FeeConfig captures the fee/profit structure for a contract.
 *
 * @generated from message mono.govcon.v1.FeeConfig
 */ export class FeeConfig extends Message {
    static fromBinary(bytes, options) {
        return new FeeConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeeConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeeConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeeConfig, a, b);
    }
    constructor(data){
        super(), /**
   * Fee structure type: "fixed_percentage", "award_fee", "incentive_fee", "embedded".
   *
   * @generated from field: string fee_structure = 1;
   */ _define_property(this, "feeStructure", ""), /**
   * Primary fee percentage (e.g., 0.08 for 8%).
   *
   * @generated from field: double fee_percent = 2;
   */ _define_property(this, "feePercent", 0), /**
   * For award fee: guaranteed base fee percentage.
   *
   * @generated from field: double base_fee_percent = 3;
   */ _define_property(this, "baseFeePercent", 0), /**
   * For award fee: available award fee pool percentage.
   *
   * @generated from field: double award_fee_pool_percent = 4;
   */ _define_property(this, "awardFeePoolPercent", 0), /**
   * For incentive fee: target fee percentage.
   *
   * @generated from field: double target_fee_percent = 5;
   */ _define_property(this, "targetFeePercent", 0), /**
   * For incentive fee: minimum fee percentage.
   *
   * @generated from field: double min_fee_percent = 6;
   */ _define_property(this, "minFeePercent", 0), /**
   * For incentive fee: maximum fee percentage.
   *
   * @generated from field: double max_fee_percent = 7;
   */ _define_property(this, "maxFeePercent", 0), /**
   * For incentive fee: government/contractor share ratio (e.g., 0.6 for 60/40).
   *
   * @generated from field: double share_ratio = 8;
   */ _define_property(this, "shareRatio", 0), /**
   * How fee is applied: "on_total_cost" or "on_direct_cost".
   *
   * @generated from field: string application = 9;
   */ _define_property(this, "application", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FeeConfig, "runtime", proto3);
_define_property(FeeConfig, "typeName", "mono.govcon.v1.FeeConfig");
_define_property(FeeConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fee_structure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fee_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "base_fee_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "award_fee_pool_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "target_fee_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "min_fee_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "max_fee_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "share_ratio",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "application",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EscalationConfig defines year-over-year rate escalation.
 *
 * @generated from message mono.govcon.v1.EscalationConfig
 */ export class EscalationConfig extends Message {
    static fromBinary(bytes, options) {
        return new EscalationConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalationConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalationConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalationConfig, a, b);
    }
    constructor(data){
        super(), /**
   * Method: "fixed_percentage", "eci_indexed", "cpi_indexed", "none", "custom_per_year".
   *
   * @generated from field: string method = 1;
   */ _define_property(this, "method", ""), /**
   * Annual escalation rate for fixed_percentage (e.g., 0.03 for 3%).
   *
   * @generated from field: double annual_percent = 2;
   */ _define_property(this, "annualPercent", 0), /**
   * Per-year escalation rates when method is "custom_per_year".
   *
   * @generated from field: repeated mono.govcon.v1.YearEscalation year_escalations = 3;
   */ _define_property(this, "yearEscalations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalationConfig, "runtime", proto3);
_define_property(EscalationConfig, "typeName", "mono.govcon.v1.EscalationConfig");
_define_property(EscalationConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "annual_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "year_escalations",
            kind: "message",
            T: YearEscalation,
            repeated: true
        }
    ]));
/**
 * YearEscalation defines escalation for a specific contract year.
 *
 * @generated from message mono.govcon.v1.YearEscalation
 */ export class YearEscalation extends Message {
    static fromBinary(bytes, options) {
        return new YearEscalation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new YearEscalation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new YearEscalation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(YearEscalation, a, b);
    }
    constructor(data){
        super(), /**
   * Year number (1 = base year, 2 = option year 1, etc.).
   *
   * @generated from field: int32 year_number = 1;
   */ _define_property(this, "yearNumber", 0), /**
   * Escalation rate for this year (e.g., 0.025 for 2.5%).
   *
   * @generated from field: double escalation_percent = 2;
   */ _define_property(this, "escalationPercent", 0), /**
   * Human-readable label (e.g., "Base Year", "Option Year 1").
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(YearEscalation, "runtime", proto3);
_define_property(YearEscalation, "typeName", "mono.govcon.v1.YearEscalation");
_define_property(YearEscalation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "year_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "escalation_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProposalPricing is the top-level pricing container for a proposal.
 * Inherits company-level IndirectRateConfig but supports per-project overrides.
 * Multiple scenarios per project are supported (e.g., "Competitive", "Target Margin").
 *
 * @generated from message mono.govcon.v1.ProposalPricing
 */ export class ProposalPricing extends Message {
    static fromBinary(bytes, options) {
        return new ProposalPricing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalPricing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalPricing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalPricing, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * Reference to the company-level IndirectRateConfig to inherit from.
   *
   * @generated from field: string indirect_rate_config_id = 4;
   */ _define_property(this, "indirectRateConfigId", ""), /**
   * Project-specific indirect rate overrides (null = use company default).
   *
   * @generated from field: mono.govcon.v1.IndirectRateConfig indirect_rate_override = 5;
   */ _define_property(this, "indirectRateOverride", void 0), /**
   * @generated from field: mono.govcon.v1.FeeConfig fee = 6;
   */ _define_property(this, "fee", void 0), /**
   * @generated from field: mono.govcon.v1.EscalationConfig escalation = 7;
   */ _define_property(this, "escalation", void 0), /**
   * Per-LCAT pricing (base rate, burdened rate, hours, yearly rates).
   *
   * @generated from field: repeated mono.govcon.v1.LaborCategoryRate labor_rates = 8;
   */ _define_property(this, "laborRates", []), /**
   * Team compositions for t-shirt sizing (maps LCATs to team tiers).
   *
   * @generated from field: repeated mono.govcon.v1.TeamComposition team_compositions = 9;
   */ _define_property(this, "teamCompositions", []), /**
   * LCAT → CLIN mapping with hours allocation and non-labor costs.
   *
   * @generated from field: repeated mono.govcon.v1.CLINPricingAssignment clin_assignments = 10;
   */ _define_property(this, "clinAssignments", []), /**
   * Scenario name (e.g., "Competitive", "Target Margin", "Floor Price").
   *
   * @generated from field: string scenario_name = 11;
   */ _define_property(this, "scenarioName", ""), /**
   * @generated from field: string created_at = 12;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string updated_at = 13;
   */ _define_property(this, "updatedAt", ""), /**
   * Whether this is the active/primary scenario.
   *
   * @generated from field: bool is_primary = 14;
   */ _define_property(this, "isPrimary", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalPricing, "runtime", proto3);
_define_property(ProposalPricing, "typeName", "mono.govcon.v1.ProposalPricing");
_define_property(ProposalPricing, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "indirect_rate_config_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "indirect_rate_override",
            kind: "message",
            T: IndirectRateConfig
        },
        {
            no: 6,
            name: "fee",
            kind: "message",
            T: FeeConfig
        },
        {
            no: 7,
            name: "escalation",
            kind: "message",
            T: EscalationConfig
        },
        {
            no: 8,
            name: "labor_rates",
            kind: "message",
            T: LaborCategoryRate,
            repeated: true
        },
        {
            no: 9,
            name: "team_compositions",
            kind: "message",
            T: TeamComposition,
            repeated: true
        },
        {
            no: 10,
            name: "clin_assignments",
            kind: "message",
            T: CLINPricingAssignment,
            repeated: true
        },
        {
            no: 11,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * LaborCategoryRate defines pricing for a single labor category within a proposal.
 *
 * @generated from message mono.govcon.v1.LaborCategoryRate
 */ export class LaborCategoryRate extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryRate, a, b);
    }
    constructor(data){
        super(), /**
   * Links to the extracted LCAT.
   *
   * @generated from field: string labor_category_id = 1;
   */ _define_property(this, "laborCategoryId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * Skill level (e.g., "Senior", "Journeyman", "Junior", "SME").
   *
   * @generated from field: string level = 3;
   */ _define_property(this, "level", ""), /**
   * Base hourly rate (Year 1 direct labor rate).
   *
   * @generated from field: double base_hourly_rate = 4;
   */ _define_property(this, "baseHourlyRate", 0), /**
   * Per-year rates with escalation applied.
   *
   * @generated from field: repeated mono.govcon.v1.YearlyRate yearly_rates = 5;
   */ _define_property(this, "yearlyRates", []), /**
   * Fully burdened rate (base × wrap rate). COMPUTED.
   *
   * @generated from field: double fully_burdened_rate = 6;
   */ _define_property(this, "fullyBurdenedRate", 0), /**
   * Wrap rate multiplier (product of indirect pools + fee). COMPUTED.
   *
   * @generated from field: double wrap_rate = 7;
   */ _define_property(this, "wrapRate", 0), /**
   * When true, fully_burdened_rate is auto-computed; when false, user-entered.
   *
   * @generated from field: bool auto_calc_burdened = 8;
   */ _define_property(this, "autoCalcBurdened", false), /**
   * Estimated hours (per basis period).
   *
   * @generated from field: double estimated_hours = 9;
   */ _define_property(this, "estimatedHours", 0), /**
   * Estimated FTEs (FTE × 2080 = annual hours).
   *
   * @generated from field: double estimated_ftes = 10;
   */ _define_property(this, "estimatedFtes", 0), /**
   * Hours basis: "annual", "monthly", "per_period", "total".
   *
   * @generated from field: string hours_basis = 11;
   */ _define_property(this, "hoursBasis", ""), /**
   * How this rate was seeded: "extracted", "vehicle_catalog", "manual", "gsa_calc".
   *
   * @generated from field: string source = 12;
   */ _define_property(this, "source", ""), /**
   * URL or document reference for compliance traceability.
   *
   * @generated from field: string source_reference = 13;
   */ _define_property(this, "sourceReference", ""), /**
   * Extraction confidence (0-1).
   *
   * @generated from field: double confidence = 14;
   */ _define_property(this, "confidence", 0), /**
   * Vehicle catalog category code (e.g., "311" for Software Developer on Alliant 2).
   *
   * @generated from field: string vehicle_category_code = 15;
   */ _define_property(this, "vehicleCategoryCode", ""), /**
   * BLS Standard Occupational Classification code.
   *
   * @generated from field: string soc_code = 16;
   */ _define_property(this, "socCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryRate, "runtime", proto3);
_define_property(LaborCategoryRate, "typeName", "mono.govcon.v1.LaborCategoryRate");
_define_property(LaborCategoryRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_hourly_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "yearly_rates",
            kind: "message",
            T: YearlyRate,
            repeated: true
        },
        {
            no: 6,
            name: "fully_burdened_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "wrap_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "auto_calc_burdened",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "estimated_hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "estimated_ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "hours_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "vehicle_category_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * YearlyRate captures escalated and burdened rates for a specific contract year.
 *
 * @generated from message mono.govcon.v1.YearlyRate
 */ export class YearlyRate extends Message {
    static fromBinary(bytes, options) {
        return new YearlyRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new YearlyRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new YearlyRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(YearlyRate, a, b);
    }
    constructor(data){
        super(), /**
   * Year number (1 = base year).
   *
   * @generated from field: int32 year_number = 1;
   */ _define_property(this, "yearNumber", 0), /**
   * Human-readable period label (e.g., "Base Year", "Option Year 1").
   *
   * @generated from field: string period_label = 2;
   */ _define_property(this, "periodLabel", ""), /**
   * Base rate for this year (base_hourly_rate × (1 + escalation)^(year-1)). COMPUTED or overridden.
   *
   * @generated from field: double base_rate = 3;
   */ _define_property(this, "baseRate", 0), /**
   * Fully burdened rate for this year (base_rate × wrap_rate). COMPUTED.
   *
   * @generated from field: double burdened_rate = 4;
   */ _define_property(this, "burdenedRate", 0), /**
   * True if the user manually overrode this year's rate.
   *
   * @generated from field: bool is_overridden = 5;
   */ _define_property(this, "isOverridden", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(YearlyRate, "runtime", proto3);
_define_property(YearlyRate, "typeName", "mono.govcon.v1.YearlyRate");
_define_property(YearlyRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "year_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "burdened_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "is_overridden",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * TeamComposition maps labor categories to a team tier for t-shirt sizing.
 *
 * @generated from message mono.govcon.v1.TeamComposition
 */ export class TeamComposition extends Message {
    static fromBinary(bytes, options) {
        return new TeamComposition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamComposition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamComposition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamComposition, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Tier label matching an ExtractedTeamTier (e.g., "Level 5").
   *
   * @generated from field: string tier_label = 2;
   */ _define_property(this, "tierLabel", ""), /**
   * Normalized ordinal.
   *
   * @generated from field: int32 tier_number = 3;
   */ _define_property(this, "tierNumber", 0), /**
   * Which CLIN this team composition prices.
   *
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * Roles composing this team tier.
   *
   * @generated from field: repeated mono.govcon.v1.TeamMember members = 5;
   */ _define_property(this, "members", []), /**
   * Sum of all members' monthly costs. COMPUTED.
   *
   * @generated from field: double monthly_cost = 6;
   */ _define_property(this, "monthlyCost", 0), /**
   * Annual cost (monthly_cost × 12). COMPUTED.
   *
   * @generated from field: double annual_cost = 7;
   */ _define_property(this, "annualCost", 0), /**
   * Total FTEs across all members. COMPUTED.
   *
   * @generated from field: double total_ftes = 8;
   */ _define_property(this, "totalFtes", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TeamComposition, "runtime", proto3);
_define_property(TeamComposition, "typeName", "mono.govcon.v1.TeamComposition");
_define_property(TeamComposition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tier_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tier_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "members",
            kind: "message",
            T: TeamMember,
            repeated: true
        },
        {
            no: 6,
            name: "monthly_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "annual_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "total_ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * TeamMember is a single role within a team composition.
 *
 * @generated from message mono.govcon.v1.TeamMember
 */ export class TeamMember extends Message {
    static fromBinary(bytes, options) {
        return new TeamMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamMember, a, b);
    }
    constructor(data){
        super(), /**
   * Links to a LaborCategoryRate.
   *
   * @generated from field: string labor_category_id = 1;
   */ _define_property(this, "laborCategoryId", ""), /**
   * Denormalized title for display.
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * FTE count (e.g., 1.0, 0.5, 2.0).
   *
   * @generated from field: double ftes = 3;
   */ _define_property(this, "ftes", 0), /**
   * Hours per month (typically FTE × 173.33 = 2080/12).
   *
   * @generated from field: double hours_per_month = 4;
   */ _define_property(this, "hoursPerMonth", 0), /**
   * Monthly cost (hours_per_month × burdened_rate). COMPUTED.
   *
   * @generated from field: double monthly_cost = 5;
   */ _define_property(this, "monthlyCost", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TeamMember, "runtime", proto3);
_define_property(TeamMember, "typeName", "mono.govcon.v1.TeamMember");
_define_property(TeamMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "hours_per_month",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "monthly_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * CLINPricingAssignment maps labor categories and non-labor costs to a CLIN.
 *
 * @generated from message mono.govcon.v1.CLINPricingAssignment
 */ export class CLINPricingAssignment extends Message {
    static fromBinary(bytes, options) {
        return new CLINPricingAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPricingAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPricingAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPricingAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * Cost type: "labor", "travel", "odc", "materials", "subcontractor".
   *
   * @generated from field: string cost_type = 2;
   */ _define_property(this, "costType", ""), /**
   * Labor allocations (which LCATs and how many hours).
   *
   * @generated from field: repeated mono.govcon.v1.CLINLaborAllocation labor_allocations = 3;
   */ _define_property(this, "laborAllocations", []), /**
   * Non-labor cost entries (travel, equipment, etc.).
   *
   * @generated from field: repeated mono.govcon.v1.NonLaborCostEntry non_labor_costs = 4;
   */ _define_property(this, "nonLaborCosts", []), /**
   * Per-year computed totals. COMPUTED.
   *
   * @generated from field: repeated mono.govcon.v1.YearlyCLINTotal yearly_totals = 5;
   */ _define_property(this, "yearlyTotals", []), /**
   * Links to extracted deliverables for compliance verification.
   *
   * @generated from field: repeated string deliverable_ids = 6;
   */ _define_property(this, "deliverableIds", []), /**
   * PWS sections this CLIN covers.
   *
   * @generated from field: repeated string pws_section_refs = 7;
   */ _define_property(this, "pwsSectionRefs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPricingAssignment, "runtime", proto3);
_define_property(CLINPricingAssignment, "typeName", "mono.govcon.v1.CLINPricingAssignment");
_define_property(CLINPricingAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "labor_allocations",
            kind: "message",
            T: CLINLaborAllocation,
            repeated: true
        },
        {
            no: 4,
            name: "non_labor_costs",
            kind: "message",
            T: NonLaborCostEntry,
            repeated: true
        },
        {
            no: 5,
            name: "yearly_totals",
            kind: "message",
            T: YearlyCLINTotal,
            repeated: true
        },
        {
            no: 6,
            name: "deliverable_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "pws_section_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * CLINLaborAllocation assigns a labor category to a CLIN with hours.
 *
 * @generated from message mono.govcon.v1.CLINLaborAllocation
 */ export class CLINLaborAllocation extends Message {
    static fromBinary(bytes, options) {
        return new CLINLaborAllocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINLaborAllocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINLaborAllocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINLaborAllocation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string labor_category_id = 1;
   */ _define_property(this, "laborCategoryId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * Total hours for this LCAT on this CLIN.
   *
   * @generated from field: double hours = 3;
   */ _define_property(this, "hours", 0), /**
   * Hours basis: "per_month", "per_year", "total".
   *
   * @generated from field: string hours_basis = 4;
   */ _define_property(this, "hoursBasis", ""), /**
   * FTE count (alternative to hours).
   *
   * @generated from field: double ftes = 5;
   */ _define_property(this, "ftes", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINLaborAllocation, "runtime", proto3);
_define_property(CLINLaborAllocation, "typeName", "mono.govcon.v1.CLINLaborAllocation");
_define_property(CLINLaborAllocation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "hours_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * NonLaborCostEntry captures a non-labor cost item (travel, equipment, etc.).
 *
 * @generated from message mono.govcon.v1.NonLaborCostEntry
 */ export class NonLaborCostEntry extends Message {
    static fromBinary(bytes, options) {
        return new NonLaborCostEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NonLaborCostEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NonLaborCostEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NonLaborCostEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string description = 1;
   */ _define_property(this, "description", ""), /**
   * Category: "travel", "equipment", "software_license", "per_diem", "other".
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * @generated from field: double unit_cost = 3;
   */ _define_property(this, "unitCost", 0), /**
   * @generated from field: int32 quantity = 4;
   */ _define_property(this, "quantity", 0), /**
   * Unit: "trip", "license", "month", "each".
   *
   * @generated from field: string unit = 5;
   */ _define_property(this, "unit", ""), /**
   * Total cost (unit_cost × quantity). COMPUTED.
   *
   * @generated from field: double total_cost = 6;
   */ _define_property(this, "totalCost", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NonLaborCostEntry, "runtime", proto3);
_define_property(NonLaborCostEntry, "typeName", "mono.govcon.v1.NonLaborCostEntry");
_define_property(NonLaborCostEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "unit_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "total_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * YearlyCLINTotal captures computed pricing totals for a CLIN in a given year.
 *
 * @generated from message mono.govcon.v1.YearlyCLINTotal
 */ export class YearlyCLINTotal extends Message {
    static fromBinary(bytes, options) {
        return new YearlyCLINTotal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new YearlyCLINTotal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new YearlyCLINTotal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(YearlyCLINTotal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 year_number = 1;
   */ _define_property(this, "yearNumber", 0), /**
   * @generated from field: string period_label = 2;
   */ _define_property(this, "periodLabel", ""), /**
   * Sum of labor allocations × burdened rates. COMPUTED.
   *
   * @generated from field: double labor_cost = 3;
   */ _define_property(this, "laborCost", 0), /**
   * Sum of non-labor entries. COMPUTED.
   *
   * @generated from field: double non_labor_cost = 4;
   */ _define_property(this, "nonLaborCost", 0), /**
   * Indirect costs on non-labor items (G&A, etc.). COMPUTED.
   *
   * @generated from field: double indirect_on_non_labor = 5;
   */ _define_property(this, "indirectOnNonLabor", 0), /**
   * Fee/profit amount. COMPUTED.
   *
   * @generated from field: double fee_amount = 6;
   */ _define_property(this, "feeAmount", 0), /**
   * Grand total for this CLIN in this year. COMPUTED.
   *
   * @generated from field: double total_cost = 7;
   */ _define_property(this, "totalCost", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(YearlyCLINTotal, "runtime", proto3);
_define_property(YearlyCLINTotal, "typeName", "mono.govcon.v1.YearlyCLINTotal");
_define_property(YearlyCLINTotal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "year_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "labor_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "non_labor_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "indirect_on_non_labor",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "fee_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "total_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * PricingParameterV2 is the fundamental unit — every value in pricing is one.
 *
 * @generated from message mono.govcon.v1.PricingParameterV2
 */ export class PricingParameterV2 extends Message {
    static fromBinary(bytes, options) {
        return new PricingParameterV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingParameterV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingParameterV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingParameterV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * Type: "rate", "quantity", "currency", "percentage", "count", "ratio", "text".
   *
   * @generated from field: string param_type = 3;
   */ _define_property(this, "paramType", ""), /**
   * Source: "government", "contractor", "computed", "default".
   *
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double value = 5;
   */ _define_property(this, "value", 0), /**
   * @generated from field: bool has_value = 6;
   */ _define_property(this, "hasValue", false), /**
   * @generated from field: mono.govcon.v1.CalculationFormulaV2 formula = 7;
   */ _define_property(this, "formula", void 0), /**
   * @generated from field: mono.govcon.v1.ParameterConstraintsV2 constraints = 8;
   */ _define_property(this, "constraints", void 0), /**
   * @generated from field: bool per_period = 9;
   */ _define_property(this, "perPeriod", false), /**
   * Period-specific values: key = period label, value = numeric value.
   *
   * @generated from field: map<string, double> period_values = 10;
   */ _define_property(this, "periodValues", {}), /**
   * @generated from field: mono.govcon.v1.PricingParameterMetadataV2 metadata = 11;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingParameterV2, "runtime", proto3);
_define_property(PricingParameterV2, "typeName", "mono.govcon.v1.PricingParameterV2");
_define_property(PricingParameterV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "param_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "has_value",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "formula",
            kind: "message",
            T: CalculationFormulaV2
        },
        {
            no: 8,
            name: "constraints",
            kind: "message",
            T: ParameterConstraintsV2
        },
        {
            no: 9,
            name: "per_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "period_values",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 1 /* ScalarType.DOUBLE */ 
            }
        },
        {
            no: 11,
            name: "metadata",
            kind: "message",
            T: PricingParameterMetadataV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PricingParameterMetadataV2
 */ export class PricingParameterMetadataV2 extends Message {
    static fromBinary(bytes, options) {
        return new PricingParameterMetadataV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingParameterMetadataV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingParameterMetadataV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingParameterMetadataV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double gsa_baseline = 1;
   */ _define_property(this, "gsaBaseline", 0), /**
   * @generated from field: double government_estimate = 2;
   */ _define_property(this, "governmentEstimate", 0), /**
   * @generated from field: string source_document = 3;
   */ _define_property(this, "sourceDocument", ""), /**
   * @generated from field: bool is_nte = 4;
   */ _define_property(this, "isNte", false), /**
   * @generated from field: bool locked = 5;
   */ _define_property(this, "locked", false), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingParameterMetadataV2, "runtime", proto3);
_define_property(PricingParameterMetadataV2, "typeName", "mono.govcon.v1.PricingParameterMetadataV2");
_define_property(PricingParameterMetadataV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gsa_baseline",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "government_estimate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "source_document",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "locked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Discriminated union for formulas — typed operations, not eval().
 *
 * @generated from message mono.govcon.v1.CalculationFormulaV2
 */ export class CalculationFormulaV2 extends Message {
    static fromBinary(bytes, options) {
        return new CalculationFormulaV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CalculationFormulaV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CalculationFormulaV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CalculationFormulaV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.CalculationFormulaV2.formula
   */ _define_property(this, "formula", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(CalculationFormulaV2, "runtime", proto3);
_define_property(CalculationFormulaV2, "typeName", "mono.govcon.v1.CalculationFormulaV2");
_define_property(CalculationFormulaV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "multiply",
            kind: "message",
            T: MultiplyFormula,
            oneof: "formula"
        },
        {
            no: 2,
            name: "sum",
            kind: "message",
            T: SumFormula,
            oneof: "formula"
        },
        {
            no: 3,
            name: "subtract",
            kind: "message",
            T: SubtractFormula,
            oneof: "formula"
        },
        {
            no: 4,
            name: "divide",
            kind: "message",
            T: DivideFormula,
            oneof: "formula"
        },
        {
            no: 5,
            name: "percentage",
            kind: "message",
            T: PercentageFormula,
            oneof: "formula"
        },
        {
            no: 6,
            name: "product_chain",
            kind: "message",
            T: ProductChainFormula,
            oneof: "formula"
        },
        {
            no: 7,
            name: "wrap_rate",
            kind: "message",
            T: WrapRateFormula,
            oneof: "formula"
        },
        {
            no: 8,
            name: "escalate",
            kind: "message",
            T: EscalateFormula,
            oneof: "formula"
        },
        {
            no: 9,
            name: "clamp",
            kind: "message",
            T: ClampFormula,
            oneof: "formula"
        },
        {
            no: 10,
            name: "conditional",
            kind: "message",
            T: ConditionalFormula,
            oneof: "formula"
        },
        {
            no: 11,
            name: "lookup",
            kind: "message",
            T: LookupFormula,
            oneof: "formula"
        },
        {
            no: 12,
            name: "custom",
            kind: "message",
            T: CustomFormula,
            oneof: "formula"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.MultiplyFormula
 */ export class MultiplyFormula extends Message {
    static fromBinary(bytes, options) {
        return new MultiplyFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MultiplyFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MultiplyFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MultiplyFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string operands = 1;
   */ _define_property(this, "operands", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MultiplyFormula, "runtime", proto3);
_define_property(MultiplyFormula, "typeName", "mono.govcon.v1.MultiplyFormula");
_define_property(MultiplyFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "operands",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SumFormula
 */ export class SumFormula extends Message {
    static fromBinary(bytes, options) {
        return new SumFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SumFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SumFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SumFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string over = 1;
   */ _define_property(this, "over", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SumFormula, "runtime", proto3);
_define_property(SumFormula, "typeName", "mono.govcon.v1.SumFormula");
_define_property(SumFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "over",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SubtractFormula
 */ export class SubtractFormula extends Message {
    static fromBinary(bytes, options) {
        return new SubtractFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubtractFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubtractFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubtractFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string left = 1;
   */ _define_property(this, "left", ""), /**
   * @generated from field: string right = 2;
   */ _define_property(this, "right", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubtractFormula, "runtime", proto3);
_define_property(SubtractFormula, "typeName", "mono.govcon.v1.SubtractFormula");
_define_property(SubtractFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "left",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "right",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.DivideFormula
 */ export class DivideFormula extends Message {
    static fromBinary(bytes, options) {
        return new DivideFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DivideFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DivideFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DivideFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string numerator = 1;
   */ _define_property(this, "numerator", ""), /**
   * @generated from field: string denominator = 2;
   */ _define_property(this, "denominator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DivideFormula, "runtime", proto3);
_define_property(DivideFormula, "typeName", "mono.govcon.v1.DivideFormula");
_define_property(DivideFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "numerator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "denominator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PercentageFormula
 */ export class PercentageFormula extends Message {
    static fromBinary(bytes, options) {
        return new PercentageFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PercentageFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PercentageFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PercentageFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string value = 1;
   */ _define_property(this, "value", ""), /**
   * @generated from field: string base = 2;
   */ _define_property(this, "base", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PercentageFormula, "runtime", proto3);
_define_property(PercentageFormula, "typeName", "mono.govcon.v1.PercentageFormula");
_define_property(PercentageFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ProductChainFormula
 */ export class ProductChainFormula extends Message {
    static fromBinary(bytes, options) {
        return new ProductChainFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProductChainFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProductChainFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProductChainFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string factors = 1;
   */ _define_property(this, "factors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProductChainFormula, "runtime", proto3);
_define_property(ProductChainFormula, "typeName", "mono.govcon.v1.ProductChainFormula");
_define_property(ProductChainFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "factors",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.WrapRateFormula
 */ export class WrapRateFormula extends Message {
    static fromBinary(bytes, options) {
        return new WrapRateFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WrapRateFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WrapRateFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WrapRateFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pools = 1;
   */ _define_property(this, "pools", ""), /**
   * @generated from field: string fee = 2;
   */ _define_property(this, "fee", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WrapRateFormula, "runtime", proto3);
_define_property(WrapRateFormula, "typeName", "mono.govcon.v1.WrapRateFormula");
_define_property(WrapRateFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fee",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.EscalateFormula
 */ export class EscalateFormula extends Message {
    static fromBinary(bytes, options) {
        return new EscalateFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalateFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalateFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalateFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string base = 1;
   */ _define_property(this, "base", ""), /**
   * @generated from field: string rate = 2;
   */ _define_property(this, "rate", ""), /**
   * @generated from field: string year = 3;
   */ _define_property(this, "year", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalateFormula, "runtime", proto3);
_define_property(EscalateFormula, "typeName", "mono.govcon.v1.EscalateFormula");
_define_property(EscalateFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "year",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClampFormula
 */ export class ClampFormula extends Message {
    static fromBinary(bytes, options) {
        return new ClampFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClampFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClampFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClampFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string value = 1;
   */ _define_property(this, "value", ""), /**
   * @generated from field: string min = 2;
   */ _define_property(this, "min", ""), /**
   * @generated from field: string max = 3;
   */ _define_property(this, "max", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClampFormula, "runtime", proto3);
_define_property(ClampFormula, "typeName", "mono.govcon.v1.ClampFormula");
_define_property(ClampFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "min",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "max",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ConditionalFormula
 */ export class ConditionalFormula extends Message {
    static fromBinary(bytes, options) {
        return new ConditionalFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConditionalFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConditionalFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConditionalFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string condition = 1;
   */ _define_property(this, "condition", ""), /**
   * @generated from field: string if_true = 2;
   */ _define_property(this, "ifTrue", ""), /**
   * @generated from field: string if_false = 3;
   */ _define_property(this, "ifFalse", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConditionalFormula, "runtime", proto3);
_define_property(ConditionalFormula, "typeName", "mono.govcon.v1.ConditionalFormula");
_define_property(ConditionalFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "condition",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "if_true",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "if_false",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.LookupFormula
 */ export class LookupFormula extends Message {
    static fromBinary(bytes, options) {
        return new LookupFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LookupFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LookupFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LookupFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string table = 1;
   */ _define_property(this, "table", ""), /**
   * @generated from field: string key = 2;
   */ _define_property(this, "key", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LookupFormula, "runtime", proto3);
_define_property(LookupFormula, "typeName", "mono.govcon.v1.LookupFormula");
_define_property(LookupFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CustomFormula
 */ export class CustomFormula extends Message {
    static fromBinary(bytes, options) {
        return new CustomFormula().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomFormula().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomFormula().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomFormula, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string expression = 1;
   */ _define_property(this, "expression", ""), /**
   * @generated from field: repeated string variables = 2;
   */ _define_property(this, "variables", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomFormula, "runtime", proto3);
_define_property(CustomFormula, "typeName", "mono.govcon.v1.CustomFormula");
_define_property(CustomFormula, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "expression",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "variables",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ParameterConstraintsV2
 */ export class ParameterConstraintsV2 extends Message {
    static fromBinary(bytes, options) {
        return new ParameterConstraintsV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParameterConstraintsV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParameterConstraintsV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParameterConstraintsV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double min = 1;
   */ _define_property(this, "min", 0), /**
   * @generated from field: double max = 2;
   */ _define_property(this, "max", 0), /**
   * @generated from field: bool no_fractions = 3;
   */ _define_property(this, "noFractions", false), /**
   * @generated from field: int32 decimal_places = 4;
   */ _define_property(this, "decimalPlaces", 0), /**
   * @generated from field: double nte = 5;
   */ _define_property(this, "nte", 0), /**
   * @generated from field: string validation_message = 6;
   */ _define_property(this, "validationMessage", ""), /**
   * @generated from field: string depends_on = 7;
   */ _define_property(this, "dependsOn", ""), /**
   * @generated from field: bool has_min = 8;
   */ _define_property(this, "hasMin", false), /**
   * @generated from field: bool has_max = 9;
   */ _define_property(this, "hasMax", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParameterConstraintsV2, "runtime", proto3);
_define_property(ParameterConstraintsV2, "typeName", "mono.govcon.v1.ParameterConstraintsV2");
_define_property(ParameterConstraintsV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "min",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "max",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "no_fractions",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "decimal_places",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "nte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "validation_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "depends_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "has_min",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "has_max",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PricingLineV2
 */ export class PricingLineV2 extends Message {
    static fromBinary(bytes, options) {
        return new PricingLineV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingLineV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingLineV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingLineV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string labor_category_id = 2;
   */ _define_property(this, "laborCategoryId", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: double fte_count = 4;
   */ _define_property(this, "fteCount", 0), /**
   * Parameters keyed by name (e.g., "hours", "rate", "total").
   *
   * @generated from field: map<string, mono.govcon.v1.PricingParameterV2> parameters = 5;
   */ _define_property(this, "parameters", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingLineV2, "runtime", proto3);
_define_property(PricingLineV2, "typeName", "mono.govcon.v1.PricingLineV2");
_define_property(PricingLineV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "labor_category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fte_count",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "parameters",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PricingParameterV2
            }
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PricingGroupV2
 */ export class PricingGroupV2 extends Message {
    static fromBinary(bytes, options) {
        return new PricingGroupV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingGroupV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingGroupV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingGroupV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * Group type: "tier", "section", "dedicated", "shared", "pws_area", "default".
   *
   * @generated from field: string group_type = 3;
   */ _define_property(this, "groupType", ""), /**
   * @generated from field: repeated mono.govcon.v1.PricingLineV2 lines = 4;
   */ _define_property(this, "lines", []), /**
   * @generated from field: mono.govcon.v1.ParameterConstraintsV2 constraints = 5;
   */ _define_property(this, "constraints", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 subtotal = 6;
   */ _define_property(this, "subtotal", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 discount = 7;
   */ _define_property(this, "discount", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 total = 8;
   */ _define_property(this, "total", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingGroupV2, "runtime", proto3);
_define_property(PricingGroupV2, "typeName", "mono.govcon.v1.PricingGroupV2");
_define_property(PricingGroupV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "group_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lines",
            kind: "message",
            T: PricingLineV2,
            repeated: true
        },
        {
            no: 5,
            name: "constraints",
            kind: "message",
            T: ParameterConstraintsV2
        },
        {
            no: 6,
            name: "subtotal",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 7,
            name: "discount",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 8,
            name: "total",
            kind: "message",
            T: PricingParameterV2
        }
    ]));
/**
 * DIMENSION 1: Labor Structure
 *
 * @generated from message mono.govcon.v1.LaborStructureV2
 */ export class LaborStructureV2 extends Message {
    static fromBinary(bytes, options) {
        return new LaborStructureV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborStructureV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborStructureV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborStructureV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.LaborStructureV2.structure
   */ _define_property(this, "structure", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborStructureV2, "runtime", proto3);
_define_property(LaborStructureV2, "typeName", "mono.govcon.v1.LaborStructureV2");
_define_property(LaborStructureV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "direct",
            kind: "message",
            T: DirectLabor,
            oneof: "structure"
        },
        {
            no: 2,
            name: "tiered",
            kind: "message",
            T: TieredLabor,
            oneof: "structure"
        },
        {
            no: 3,
            name: "government_defined",
            kind: "message",
            T: GovernmentDefinedLabor,
            oneof: "structure"
        },
        {
            no: 4,
            name: "iteration_based",
            kind: "message",
            T: IterationBasedLabor,
            oneof: "structure"
        },
        {
            no: 5,
            name: "none",
            kind: "message",
            T: NoLabor,
            oneof: "structure"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.DirectLabor
 */ export class DirectLabor extends Message {
    static fromBinary(bytes, options) {
        return new DirectLabor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DirectLabor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DirectLabor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DirectLabor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.PricingGroupV2 groups = 1;
   */ _define_property(this, "groups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DirectLabor, "runtime", proto3);
_define_property(DirectLabor, "typeName", "mono.govcon.v1.DirectLabor");
_define_property(DirectLabor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: PricingGroupV2,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.TieredLabor
 */ export class TieredLabor extends Message {
    static fromBinary(bytes, options) {
        return new TieredLabor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TieredLabor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TieredLabor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TieredLabor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.TierConfigV2 tiers = 1;
   */ _define_property(this, "tiers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TieredLabor, "runtime", proto3);
_define_property(TieredLabor, "typeName", "mono.govcon.v1.TieredLabor");
_define_property(TieredLabor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tiers",
            kind: "message",
            T: TierConfigV2,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GovernmentDefinedLabor
 */ export class GovernmentDefinedLabor extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentDefinedLabor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentDefinedLabor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentDefinedLabor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentDefinedLabor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.PricingGroupV2 groups = 1;
   */ _define_property(this, "groups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentDefinedLabor, "runtime", proto3);
_define_property(GovernmentDefinedLabor, "typeName", "mono.govcon.v1.GovernmentDefinedLabor");
_define_property(GovernmentDefinedLabor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: PricingGroupV2,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.IterationBasedLabor
 */ export class IterationBasedLabor extends Message {
    static fromBinary(bytes, options) {
        return new IterationBasedLabor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IterationBasedLabor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IterationBasedLabor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IterationBasedLabor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, int32> iterations_per_period = 1;
   */ _define_property(this, "iterationsPerPeriod", {}), /**
   * @generated from field: string unit_type = 2;
   */ _define_property(this, "unitType", ""), /**
   * @generated from field: mono.govcon.v1.PricingGroupV2 labor_backup = 3;
   */ _define_property(this, "laborBackup", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IterationBasedLabor, "runtime", proto3);
_define_property(IterationBasedLabor, "typeName", "mono.govcon.v1.IterationBasedLabor");
_define_property(IterationBasedLabor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "iterations_per_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 2,
            name: "unit_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "labor_backup",
            kind: "message",
            T: PricingGroupV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.NoLabor
 */ export class NoLabor extends Message {
    static fromBinary(bytes, options) {
        return new NoLabor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoLabor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoLabor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoLabor, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoLabor, "runtime", proto3);
_define_property(NoLabor, "typeName", "mono.govcon.v1.NoLabor");
_define_property(NoLabor, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.govcon.v1.TierConfigV2
 */ export class TierConfigV2 extends Message {
    static fromBinary(bytes, options) {
        return new TierConfigV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TierConfigV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TierConfigV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TierConfigV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tier_label = 1;
   */ _define_property(this, "tierLabel", ""), /**
   * @generated from field: int32 tier_number = 2;
   */ _define_property(this, "tierNumber", 0), /**
   * @generated from field: mono.govcon.v1.PricingGroupV2 group = 3;
   */ _define_property(this, "group", void 0), /**
   * @generated from field: mono.govcon.v1.ParameterConstraintsV2 fte_constraints = 4;
   */ _define_property(this, "fteConstraints", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 exercise_count = 5;
   */ _define_property(this, "exerciseCount", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TierConfigV2, "runtime", proto3);
_define_property(TierConfigV2, "typeName", "mono.govcon.v1.TierConfigV2");
_define_property(TierConfigV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tier_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tier_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "group",
            kind: "message",
            T: PricingGroupV2
        },
        {
            no: 4,
            name: "fte_constraints",
            kind: "message",
            T: ParameterConstraintsV2
        },
        {
            no: 5,
            name: "exercise_count",
            kind: "message",
            T: PricingParameterV2
        }
    ]));
/**
 * DIMENSION 2: Rate Method
 *
 * @generated from message mono.govcon.v1.RateMethodV2
 */ export class RateMethodV2 extends Message {
    static fromBinary(bytes, options) {
        return new RateMethodV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateMethodV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateMethodV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateMethodV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.RateMethodV2.method
   */ _define_property(this, "method", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateMethodV2, "runtime", proto3);
_define_property(RateMethodV2, "typeName", "mono.govcon.v1.RateMethodV2");
_define_property(RateMethodV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bare_plus_wrap",
            kind: "message",
            T: BarePlusWrapRate,
            oneof: "method"
        },
        {
            no: 2,
            name: "fully_loaded",
            kind: "message",
            T: FullyLoadedRate,
            oneof: "method"
        },
        {
            no: 3,
            name: "gsa_schedule",
            kind: "message",
            T: GsaScheduleRate,
            oneof: "method"
        },
        {
            no: 4,
            name: "ceiling_constrained",
            kind: "message",
            T: CeilingConstrainedRate,
            oneof: "method"
        },
        {
            no: 5,
            name: "sca_wage",
            kind: "message",
            T: ScaWageRate,
            oneof: "method"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.BarePlusWrapRate
 */ export class BarePlusWrapRate extends Message {
    static fromBinary(bytes, options) {
        return new BarePlusWrapRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BarePlusWrapRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BarePlusWrapRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BarePlusWrapRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.IndirectRateConfig wrap_rate_config = 1;
   */ _define_property(this, "wrapRateConfig", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BarePlusWrapRate, "runtime", proto3);
_define_property(BarePlusWrapRate, "typeName", "mono.govcon.v1.BarePlusWrapRate");
_define_property(BarePlusWrapRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "wrap_rate_config",
            kind: "message",
            T: IndirectRateConfig
        }
    ]));
/**
 * @generated from message mono.govcon.v1.FullyLoadedRate
 */ export class FullyLoadedRate extends Message {
    static fromBinary(bytes, options) {
        return new FullyLoadedRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FullyLoadedRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FullyLoadedRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FullyLoadedRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rate_label = 1;
   */ _define_property(this, "rateLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FullyLoadedRate, "runtime", proto3);
_define_property(FullyLoadedRate, "typeName", "mono.govcon.v1.FullyLoadedRate");
_define_property(FullyLoadedRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GsaScheduleRate
 */ export class GsaScheduleRate extends Message {
    static fromBinary(bytes, options) {
        return new GsaScheduleRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GsaScheduleRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GsaScheduleRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GsaScheduleRate, a, b);
    }
    constructor(data){
        super(), /**
   * category → period → GSA rate (nested map not supported; use repeated).
   *
   * @generated from field: repeated mono.govcon.v1.GsaBaselineEntry gsa_baselines = 1;
   */ _define_property(this, "gsaBaselines", []), /**
   * @generated from field: repeated string location_variants = 2;
   */ _define_property(this, "locationVariants", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GsaScheduleRate, "runtime", proto3);
_define_property(GsaScheduleRate, "typeName", "mono.govcon.v1.GsaScheduleRate");
_define_property(GsaScheduleRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gsa_baselines",
            kind: "message",
            T: GsaBaselineEntry,
            repeated: true
        },
        {
            no: 2,
            name: "location_variants",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GsaBaselineEntry
 */ export class GsaBaselineEntry extends Message {
    static fromBinary(bytes, options) {
        return new GsaBaselineEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GsaBaselineEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GsaBaselineEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GsaBaselineEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category = 1;
   */ _define_property(this, "category", ""), /**
   * @generated from field: map<string, double> period_rates = 2;
   */ _define_property(this, "periodRates", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(GsaBaselineEntry, "runtime", proto3);
_define_property(GsaBaselineEntry, "typeName", "mono.govcon.v1.GsaBaselineEntry");
_define_property(GsaBaselineEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_rates",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 1 /* ScalarType.DOUBLE */ 
            }
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CeilingConstrainedRate
 */ export class CeilingConstrainedRate extends Message {
    static fromBinary(bytes, options) {
        return new CeilingConstrainedRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CeilingConstrainedRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CeilingConstrainedRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CeilingConstrainedRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, double> ceiling_rates = 1;
   */ _define_property(this, "ceilingRates", {}), /**
   * @generated from field: string base_contract_ref = 2;
   */ _define_property(this, "baseContractRef", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CeilingConstrainedRate, "runtime", proto3);
_define_property(CeilingConstrainedRate, "typeName", "mono.govcon.v1.CeilingConstrainedRate");
_define_property(CeilingConstrainedRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ceiling_rates",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 1 /* ScalarType.DOUBLE */ 
            }
        },
        {
            no: 2,
            name: "base_contract_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ScaWageRate
 */ export class ScaWageRate extends Message {
    static fromBinary(bytes, options) {
        return new ScaWageRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScaWageRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScaWageRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScaWageRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string wd_number = 1;
   */ _define_property(this, "wdNumber", ""), /**
   * @generated from field: string locality = 2;
   */ _define_property(this, "locality", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScaWageRate, "runtime", proto3);
_define_property(ScaWageRate, "typeName", "mono.govcon.v1.ScaWageRate");
_define_property(ScaWageRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "wd_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "locality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DIMENSION 3: Fee Method
 *
 * @generated from message mono.govcon.v1.FeeMethodV2
 */ export class FeeMethodV2 extends Message {
    static fromBinary(bytes, options) {
        return new FeeMethodV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeeMethodV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeeMethodV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeeMethodV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.FeeMethodV2.method
   */ _define_property(this, "method", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(FeeMethodV2, "runtime", proto3);
_define_property(FeeMethodV2, "typeName", "mono.govcon.v1.FeeMethodV2");
_define_property(FeeMethodV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fixed_percentage",
            kind: "message",
            T: FixedPercentageFee,
            oneof: "method"
        },
        {
            no: 2,
            name: "incentive",
            kind: "message",
            T: IncentiveFee,
            oneof: "method"
        },
        {
            no: 3,
            name: "award_fee",
            kind: "message",
            T: AwardFee,
            oneof: "method"
        },
        {
            no: 4,
            name: "incentive_firm",
            kind: "message",
            T: IncentiveFirmFee,
            oneof: "method"
        },
        {
            no: 5,
            name: "embedded",
            kind: "message",
            T: EmbeddedFee,
            oneof: "method"
        },
        {
            no: 6,
            name: "none",
            kind: "message",
            T: NoFee,
            oneof: "method"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.FixedPercentageFee
 */ export class FixedPercentageFee extends Message {
    static fromBinary(bytes, options) {
        return new FixedPercentageFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixedPercentageFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixedPercentageFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixedPercentageFee, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 fee_percent = 1;
   */ _define_property(this, "feePercent", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixedPercentageFee, "runtime", proto3);
_define_property(FixedPercentageFee, "typeName", "mono.govcon.v1.FixedPercentageFee");
_define_property(FixedPercentageFee, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fee_percent",
            kind: "message",
            T: PricingParameterV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.IncentiveFee
 */ export class IncentiveFee extends Message {
    static fromBinary(bytes, options) {
        return new IncentiveFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IncentiveFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IncentiveFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IncentiveFee, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 target_cost = 1;
   */ _define_property(this, "targetCost", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 target_fee = 2;
   */ _define_property(this, "targetFee", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 min_fee = 3;
   */ _define_property(this, "minFee", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 max_fee = 4;
   */ _define_property(this, "maxFee", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 share_ratio_under = 5;
   */ _define_property(this, "shareRatioUnder", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 share_ratio_over = 6;
   */ _define_property(this, "shareRatioOver", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IncentiveFee, "runtime", proto3);
_define_property(IncentiveFee, "typeName", "mono.govcon.v1.IncentiveFee");
_define_property(IncentiveFee, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_cost",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 2,
            name: "target_fee",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 3,
            name: "min_fee",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 4,
            name: "max_fee",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 5,
            name: "share_ratio_under",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 6,
            name: "share_ratio_over",
            kind: "message",
            T: PricingParameterV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AwardFee
 */ export class AwardFee extends Message {
    static fromBinary(bytes, options) {
        return new AwardFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardFee, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 base_fee_percent = 1;
   */ _define_property(this, "baseFeePercent", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 award_fee_pool_percent = 2;
   */ _define_property(this, "awardFeePoolPercent", void 0), /**
   * @generated from field: repeated string evaluation_criteria = 3;
   */ _define_property(this, "evaluationCriteria", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardFee, "runtime", proto3);
_define_property(AwardFee, "typeName", "mono.govcon.v1.AwardFee");
_define_property(AwardFee, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base_fee_percent",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 2,
            name: "award_fee_pool_percent",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 3,
            name: "evaluation_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.IncentiveFirmFee
 */ export class IncentiveFirmFee extends Message {
    static fromBinary(bytes, options) {
        return new IncentiveFirmFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IncentiveFirmFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IncentiveFirmFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IncentiveFirmFee, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 target_cost = 1;
   */ _define_property(this, "targetCost", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 target_profit = 2;
   */ _define_property(this, "targetProfit", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 ceiling_price = 3;
   */ _define_property(this, "ceilingPrice", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 share_ratio = 4;
   */ _define_property(this, "shareRatio", void 0), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 pta = 5;
   */ _define_property(this, "pta", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IncentiveFirmFee, "runtime", proto3);
_define_property(IncentiveFirmFee, "typeName", "mono.govcon.v1.IncentiveFirmFee");
_define_property(IncentiveFirmFee, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_cost",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 2,
            name: "target_profit",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 3,
            name: "ceiling_price",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 4,
            name: "share_ratio",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 5,
            name: "pta",
            kind: "message",
            T: PricingParameterV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.EmbeddedFee
 */ export class EmbeddedFee extends Message {
    static fromBinary(bytes, options) {
        return new EmbeddedFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbeddedFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbeddedFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbeddedFee, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmbeddedFee, "runtime", proto3);
_define_property(EmbeddedFee, "typeName", "mono.govcon.v1.EmbeddedFee");
_define_property(EmbeddedFee, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.govcon.v1.NoFee
 */ export class NoFee extends Message {
    static fromBinary(bytes, options) {
        return new NoFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoFee, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoFee, "runtime", proto3);
_define_property(NoFee, "typeName", "mono.govcon.v1.NoFee");
_define_property(NoFee, "fields", proto3.util.newFieldList(()=>[]));
/**
 * DIMENSION 4: Volume Method
 *
 * @generated from message mono.govcon.v1.VolumeMethodV2
 */ export class VolumeMethodV2 extends Message {
    static fromBinary(bytes, options) {
        return new VolumeMethodV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VolumeMethodV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VolumeMethodV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VolumeMethodV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.VolumeMethodV2.method
   */ _define_property(this, "method", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(VolumeMethodV2, "runtime", proto3);
_define_property(VolumeMethodV2, "typeName", "mono.govcon.v1.VolumeMethodV2");
_define_property(VolumeMethodV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contractor_proposed",
            kind: "message",
            T: ContractorProposedVolume,
            oneof: "method"
        },
        {
            no: 2,
            name: "government_locked",
            kind: "message",
            T: GovernmentLockedVolume,
            oneof: "method"
        },
        {
            no: 3,
            name: "exercise_based",
            kind: "message",
            T: ExerciseBasedVolume,
            oneof: "method"
        },
        {
            no: 4,
            name: "fixed_quantity",
            kind: "message",
            T: FixedQuantityVolume,
            oneof: "method"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ContractorProposedVolume
 */ export class ContractorProposedVolume extends Message {
    static fromBinary(bytes, options) {
        return new ContractorProposedVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractorProposedVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractorProposedVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractorProposedVolume, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool has_fte_column = 1;
   */ _define_property(this, "hasFteColumn", false), /**
   * @generated from field: bool has_hours_column = 2;
   */ _define_property(this, "hasHoursColumn", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractorProposedVolume, "runtime", proto3);
_define_property(ContractorProposedVolume, "typeName", "mono.govcon.v1.ContractorProposedVolume");
_define_property(ContractorProposedVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "has_fte_column",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "has_hours_column",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GovernmentLockedVolume
 */ export class GovernmentLockedVolume extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentLockedVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentLockedVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentLockedVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentLockedVolume, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string locked_parameters = 1;
   */ _define_property(this, "lockedParameters", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentLockedVolume, "runtime", proto3);
_define_property(GovernmentLockedVolume, "typeName", "mono.govcon.v1.GovernmentLockedVolume");
_define_property(GovernmentLockedVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "locked_parameters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExerciseBasedVolume
 */ export class ExerciseBasedVolume extends Message {
    static fromBinary(bytes, options) {
        return new ExerciseBasedVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExerciseBasedVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExerciseBasedVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExerciseBasedVolume, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, int32> months_per_period = 1;
   */ _define_property(this, "monthsPerPeriod", {}), /**
   * "total_div_months" or "direct".
   *
   * @generated from field: string unit_price_formula = 2;
   */ _define_property(this, "unitPriceFormula", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExerciseBasedVolume, "runtime", proto3);
_define_property(ExerciseBasedVolume, "typeName", "mono.govcon.v1.ExerciseBasedVolume");
_define_property(ExerciseBasedVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "months_per_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 2,
            name: "unit_price_formula",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.FixedQuantityVolume
 */ export class FixedQuantityVolume extends Message {
    static fromBinary(bytes, options) {
        return new FixedQuantityVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixedQuantityVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixedQuantityVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixedQuantityVolume, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingParameterV2 quantity = 1;
   */ _define_property(this, "quantity", void 0), /**
   * @generated from field: string unit = 2;
   */ _define_property(this, "unit", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixedQuantityVolume, "runtime", proto3);
_define_property(FixedQuantityVolume, "typeName", "mono.govcon.v1.FixedQuantityVolume");
_define_property(FixedQuantityVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "quantity",
            kind: "message",
            T: PricingParameterV2
        },
        {
            no: 2,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DIMENSION 5: Aggregation Method
 *
 * @generated from message mono.govcon.v1.AggregationMethodV2
 */ export class AggregationMethodV2 extends Message {
    static fromBinary(bytes, options) {
        return new AggregationMethodV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AggregationMethodV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AggregationMethodV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AggregationMethodV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.govcon.v1.AggregationMethodV2.method
   */ _define_property(this, "method", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(AggregationMethodV2, "runtime", proto3);
_define_property(AggregationMethodV2, "typeName", "mono.govcon.v1.AggregationMethodV2");
_define_property(AggregationMethodV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sum",
            kind: "message",
            T: SumAggregation,
            oneof: "method"
        },
        {
            no: 2,
            name: "sum_with_discount",
            kind: "message",
            T: SumWithDiscountAggregation,
            oneof: "method"
        },
        {
            no: 3,
            name: "tier_rollup",
            kind: "message",
            T: TierRollupAggregation,
            oneof: "method"
        },
        {
            no: 4,
            name: "pass_through",
            kind: "message",
            T: PassThroughAggregation,
            oneof: "method"
        },
        {
            no: 5,
            name: "subcontractor_pass_through",
            kind: "message",
            T: SubcontractorPassThroughAggregation,
            oneof: "method"
        }
    ]));
/**
 * @generated from message mono.govcon.v1.SumAggregation
 */ export class SumAggregation extends Message {
    static fromBinary(bytes, options) {
        return new SumAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SumAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SumAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SumAggregation, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SumAggregation, "runtime", proto3);
_define_property(SumAggregation, "typeName", "mono.govcon.v1.SumAggregation");
_define_property(SumAggregation, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.govcon.v1.SumWithDiscountAggregation
 */ export class SumWithDiscountAggregation extends Message {
    static fromBinary(bytes, options) {
        return new SumWithDiscountAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SumWithDiscountAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SumWithDiscountAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SumWithDiscountAggregation, a, b);
    }
    constructor(data){
        super(), /**
   * "flat" or "percentage".
   *
   * @generated from field: string discount_type = 1;
   */ _define_property(this, "discountType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SumWithDiscountAggregation, "runtime", proto3);
_define_property(SumWithDiscountAggregation, "typeName", "mono.govcon.v1.SumWithDiscountAggregation");
_define_property(SumWithDiscountAggregation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discount_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.TierRollupAggregation
 */ export class TierRollupAggregation extends Message {
    static fromBinary(bytes, options) {
        return new TierRollupAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TierRollupAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TierRollupAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TierRollupAggregation, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(TierRollupAggregation, "runtime", proto3);
_define_property(TierRollupAggregation, "typeName", "mono.govcon.v1.TierRollupAggregation");
_define_property(TierRollupAggregation, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.govcon.v1.PassThroughAggregation
 */ export class PassThroughAggregation extends Message {
    static fromBinary(bytes, options) {
        return new PassThroughAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PassThroughAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PassThroughAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PassThroughAggregation, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(PassThroughAggregation, "runtime", proto3);
_define_property(PassThroughAggregation, "typeName", "mono.govcon.v1.PassThroughAggregation");
_define_property(PassThroughAggregation, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.govcon.v1.SubcontractorPassThroughAggregation
 */ export class SubcontractorPassThroughAggregation extends Message {
    static fromBinary(bytes, options) {
        return new SubcontractorPassThroughAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubcontractorPassThroughAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubcontractorPassThroughAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubcontractorPassThroughAggregation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double prime_percent = 1;
   */ _define_property(this, "primePercent", 0), /**
   * @generated from field: double sub_percent = 2;
   */ _define_property(this, "subPercent", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubcontractorPassThroughAggregation, "runtime", proto3);
_define_property(SubcontractorPassThroughAggregation, "typeName", "mono.govcon.v1.SubcontractorPassThroughAggregation");
_define_property(SubcontractorPassThroughAggregation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "prime_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "sub_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ColumnConfigV2
 */ export class ColumnConfigV2 extends Message {
    static fromBinary(bytes, options) {
        return new ColumnConfigV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ColumnConfigV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ColumnConfigV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ColumnConfigV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string parameter_name = 3;
   */ _define_property(this, "parameterName", ""), /**
   * @generated from field: bool editable = 4;
   */ _define_property(this, "editable", false), /**
   * @generated from field: bool per_period = 5;
   */ _define_property(this, "perPeriod", false), /**
   * @generated from field: int32 width = 6;
   */ _define_property(this, "width", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ColumnConfigV2, "runtime", proto3);
_define_property(ColumnConfigV2, "typeName", "mono.govcon.v1.ColumnConfigV2");
_define_property(ColumnConfigV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parameter_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "editable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "per_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "width",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PeriodTotalV2
 */ export class PeriodTotalV2 extends Message {
    static fromBinary(bytes, options) {
        return new PeriodTotalV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodTotalV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodTotalV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodTotalV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double labor_cost = 1;
   */ _define_property(this, "laborCost", 0), /**
   * @generated from field: double non_labor_cost = 2;
   */ _define_property(this, "nonLaborCost", 0), /**
   * @generated from field: double indirect_cost = 3;
   */ _define_property(this, "indirectCost", 0), /**
   * @generated from field: double fee_cost = 4;
   */ _define_property(this, "feeCost", 0), /**
   * @generated from field: double total_cost = 5;
   */ _define_property(this, "totalCost", 0), /**
   * @generated from field: double unit_price = 6;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: bool has_unit_price = 7;
   */ _define_property(this, "hasUnitPrice", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodTotalV2, "runtime", proto3);
_define_property(PeriodTotalV2, "typeName", "mono.govcon.v1.PeriodTotalV2");
_define_property(PeriodTotalV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "non_labor_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "indirect_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "fee_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "total_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "has_unit_price",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLINPricingMetadataV2
 */ export class CLINPricingMetadataV2 extends Message {
    static fromBinary(bytes, options) {
        return new CLINPricingMetadataV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPricingMetadataV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPricingMetadataV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPricingMetadataV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string contract_type = 2;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string cost_type = 3;
   */ _define_property(this, "costType", ""), /**
   * @generated from field: string pricing_unit = 4;
   */ _define_property(this, "pricingUnit", ""), /**
   * @generated from field: string pricing_quantity = 5;
   */ _define_property(this, "pricingQuantity", ""), /**
   * @generated from field: string period_name = 6;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: int32 pop_months = 7;
   */ _define_property(this, "popMonths", 0), /**
   * @generated from field: bool is_optional_task = 8;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: string corresponding_base_clin = 9;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: double nte_ceiling = 10;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: bool needs_team_pricing = 11;
   */ _define_property(this, "needsTeamPricing", false), /**
   * @generated from field: repeated string nsp_items = 12;
   */ _define_property(this, "nspItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPricingMetadataV2, "runtime", proto3);
_define_property(CLINPricingMetadataV2, "typeName", "mono.govcon.v1.CLINPricingMetadataV2");
_define_property(CLINPricingMetadataV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pricing_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pricing_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pop_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "needs_team_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "nsp_items",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CLINPricingV2
 */ export class CLINPricingV2 extends Message {
    static fromBinary(bytes, options) {
        return new CLINPricingV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPricingV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPricingV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPricingV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: mono.govcon.v1.LaborStructureV2 labor_structure = 2;
   */ _define_property(this, "laborStructure", void 0), /**
   * @generated from field: mono.govcon.v1.RateMethodV2 rate_method = 3;
   */ _define_property(this, "rateMethod", void 0), /**
   * @generated from field: mono.govcon.v1.FeeMethodV2 fee_method = 4;
   */ _define_property(this, "feeMethod", void 0), /**
   * @generated from field: mono.govcon.v1.VolumeMethodV2 volume_method = 5;
   */ _define_property(this, "volumeMethod", void 0), /**
   * @generated from field: mono.govcon.v1.AggregationMethodV2 aggregation = 6;
   */ _define_property(this, "aggregation", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ColumnConfigV2 columns = 7;
   */ _define_property(this, "columns", []), /**
   * @generated from field: repeated string periods = 8;
   */ _define_property(this, "periods", []), /**
   * @generated from field: map<string, mono.govcon.v1.PeriodTotalV2> period_totals = 9;
   */ _define_property(this, "periodTotals", {}), /**
   * @generated from field: double grand_total = 10;
   */ _define_property(this, "grandTotal", 0), /**
   * @generated from field: mono.govcon.v1.CLINPricingMetadataV2 metadata = 11;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPricingV2, "runtime", proto3);
_define_property(CLINPricingV2, "typeName", "mono.govcon.v1.CLINPricingV2");
_define_property(CLINPricingV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "labor_structure",
            kind: "message",
            T: LaborStructureV2
        },
        {
            no: 3,
            name: "rate_method",
            kind: "message",
            T: RateMethodV2
        },
        {
            no: 4,
            name: "fee_method",
            kind: "message",
            T: FeeMethodV2
        },
        {
            no: 5,
            name: "volume_method",
            kind: "message",
            T: VolumeMethodV2
        },
        {
            no: 6,
            name: "aggregation",
            kind: "message",
            T: AggregationMethodV2
        },
        {
            no: 7,
            name: "columns",
            kind: "message",
            T: ColumnConfigV2,
            repeated: true
        },
        {
            no: 8,
            name: "periods",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "period_totals",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PeriodTotalV2
            }
        },
        {
            no: 10,
            name: "grand_total",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "metadata",
            kind: "message",
            T: CLINPricingMetadataV2
        }
    ]));
/**
 * @generated from message mono.govcon.v1.LCATQualificationV2
 */ export class LCATQualificationV2 extends Message {
    static fromBinary(bytes, options) {
        return new LCATQualificationV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LCATQualificationV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LCATQualificationV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LCATQualificationV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string education = 1;
   */ _define_property(this, "education", ""), /**
   * @generated from field: string degree_field = 2;
   */ _define_property(this, "degreeField", ""), /**
   * @generated from field: int32 years_experience = 3;
   */ _define_property(this, "yearsExperience", 0), /**
   * @generated from field: string substitution = 4;
   */ _define_property(this, "substitution", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string clearance_required = 6;
   */ _define_property(this, "clearanceRequired", ""), /**
   * @generated from field: repeated string certifications = 7;
   */ _define_property(this, "certifications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LCATQualificationV2, "runtime", proto3);
_define_property(LCATQualificationV2, "typeName", "mono.govcon.v1.LCATQualificationV2");
_define_property(LCATQualificationV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "degree_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "years_experience",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "substitution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "clearance_required",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GsaMappingV2
 */ export class GsaMappingV2 extends Message {
    static fromBinary(bytes, options) {
        return new GsaMappingV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GsaMappingV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GsaMappingV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GsaMappingV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string gsa_category_name = 1;
   */ _define_property(this, "gsaCategoryName", ""), /**
   * @generated from field: map<string, double> gsa_rates = 2;
   */ _define_property(this, "gsaRates", {}), /**
   * @generated from field: map<string, double> discount_percents = 3;
   */ _define_property(this, "discountPercents", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(GsaMappingV2, "runtime", proto3);
_define_property(GsaMappingV2, "typeName", "mono.govcon.v1.GsaMappingV2");
_define_property(GsaMappingV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gsa_category_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "gsa_rates",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 1 /* ScalarType.DOUBLE */ 
            }
        },
        {
            no: 3,
            name: "discount_percents",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 1 /* ScalarType.DOUBLE */ 
            }
        }
    ]));
/**
 * @generated from message mono.govcon.v1.LaborCategoryRateV2
 */ export class LaborCategoryRateV2 extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryRateV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryRateV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryRateV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryRateV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string labor_category_id = 2;
   */ _define_property(this, "laborCategoryId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string level = 4;
   */ _define_property(this, "level", ""), /**
   * @generated from field: map<string, mono.govcon.v1.PricingParameterV2> rates = 5;
   */ _define_property(this, "rates", {}), /**
   * @generated from field: mono.govcon.v1.GsaMappingV2 gsa_mapping = 6;
   */ _define_property(this, "gsaMapping", void 0), /**
   * @generated from field: mono.govcon.v1.LCATQualificationV2 qualifications = 7;
   */ _define_property(this, "qualifications", void 0), /**
   * Source: "extracted", "vehicle_catalog", "manual", "xlsx_lcat_sheet".
   *
   * @generated from field: string source = 8;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double confidence = 9;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryRateV2, "runtime", proto3);
_define_property(LaborCategoryRateV2, "typeName", "mono.govcon.v1.LaborCategoryRateV2");
_define_property(LaborCategoryRateV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "labor_category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rates",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PricingParameterV2
            }
        },
        {
            no: 6,
            name: "gsa_mapping",
            kind: "message",
            T: GsaMappingV2
        },
        {
            no: 7,
            name: "qualifications",
            kind: "message",
            T: LCATQualificationV2
        },
        {
            no: 8,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RateCardV2
 */ export class RateCardV2 extends Message {
    static fromBinary(bytes, options) {
        return new RateCardV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateCardV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateCardV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateCardV2, a, b);
    }
    constructor(data){
        super(), /**
   * Rate type: "bare", "fully_loaded", "gsa_schedule".
   *
   * @generated from field: string rate_type = 1;
   */ _define_property(this, "rateType", ""), /**
   * @generated from field: repeated mono.govcon.v1.LaborCategoryRateV2 categories = 2;
   */ _define_property(this, "categories", []), /**
   * @generated from field: repeated string location_variants = 3;
   */ _define_property(this, "locationVariants", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateCardV2, "runtime", proto3);
_define_property(RateCardV2, "typeName", "mono.govcon.v1.RateCardV2");
_define_property(RateCardV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "categories",
            kind: "message",
            T: LaborCategoryRateV2,
            repeated: true
        },
        {
            no: 3,
            name: "location_variants",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ColumnSchema describes one column in a pricing sheet as understood by the extractor.
 *
 * @generated from message mono.govcon.v1.ColumnSchema
 */ export class ColumnSchema extends Message {
    static fromBinary(bytes, options) {
        return new ColumnSchema().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ColumnSchema().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ColumnSchema().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ColumnSchema, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string column_letter = 1;
   */ _define_property(this, "columnLetter", ""), /**
   * @generated from field: string header_text = 2;
   */ _define_property(this, "headerText", ""), /**
   * Semantic role: "lcat_name", "level", "ftes", "hours", "rate", "total",
   * "unit_price", "extended_price", "section_label", "period_label", "other".
   *
   * @generated from field: string semantic_role = 3;
   */ _define_property(this, "semanticRole", ""), /**
   * Whether this column is computed (formula) vs input (editable by proposer).
   *
   * @generated from field: bool is_computed = 4;
   */ _define_property(this, "isComputed", false), /**
   * Simplified formula pattern (e.g., "=rate*hours", "=SUM(group)").
   *
   * @generated from field: string formula_pattern = 5;
   */ _define_property(this, "formulaPattern", ""), /**
   * V2 pricing parameter name this column maps to.
   *
   * @generated from field: string parameter_name = 6;
   */ _define_property(this, "parameterName", ""), /**
   * Whether this column repeats per period (side-by-side layout).
   *
   * @generated from field: bool per_period = 7;
   */ _define_property(this, "perPeriod", false), /**
   * Period label if per_period is true.
   *
   * @generated from field: string period_label = 8;
   */ _define_property(this, "periodLabel", ""), /**
   * Detected constraints from data validation or instructions.
   *
   * @generated from field: mono.govcon.v1.ParameterConstraintsV2 constraints = 9;
   */ _define_property(this, "constraints", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ColumnSchema, "runtime", proto3);
_define_property(ColumnSchema, "typeName", "mono.govcon.v1.ColumnSchema");
_define_property(ColumnSchema, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "column_letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "header_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "semantic_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_computed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "formula_pattern",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parameter_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "per_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "constraints",
            kind: "message",
            T: ParameterConstraintsV2
        }
    ]));
/**
 * SheetSchema describes the structure of a single pricing sheet.
 *
 * @generated from message mono.govcon.v1.SheetSchema
 */ export class SheetSchema extends Message {
    static fromBinary(bytes, options) {
        return new SheetSchema().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SheetSchema().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SheetSchema().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SheetSchema, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sheet_name = 1;
   */ _define_property(this, "sheetName", ""), /**
   * Purpose: "labor_breakdown", "rate_table", "summary", "lcat_descriptions", "instructions", "other".
   *
   * @generated from field: string purpose = 2;
   */ _define_property(this, "purpose", ""), /**
   * CLINs this sheet maps to. Empty means "all" or "summary".
   *
   * @generated from field: repeated string clin_numbers = 3;
   */ _define_property(this, "clinNumbers", []), /**
   * @generated from field: repeated mono.govcon.v1.ColumnSchema columns = 4;
   */ _define_property(this, "columns", []), /**
   * @generated from field: int32 header_row = 5;
   */ _define_property(this, "headerRow", 0), /**
   * @generated from field: int32 data_start_row = 6;
   */ _define_property(this, "dataStartRow", 0), /**
   * Rows that are subtotals/totals (0-indexed from data_start_row).
   *
   * @generated from field: repeated int32 subtotal_rows = 7;
   */ _define_property(this, "subtotalRows", []), /**
   * @generated from field: repeated int32 discount_rows = 8;
   */ _define_property(this, "discountRows", []), /**
   * Group/section labels found (e.g., "Level 5", "Dedicated Resources").
   *
   * @generated from field: repeated string section_labels = 9;
   */ _define_property(this, "sectionLabels", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SheetSchema, "runtime", proto3);
_define_property(SheetSchema, "typeName", "mono.govcon.v1.SheetSchema");
_define_property(SheetSchema, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "columns",
            kind: "message",
            T: ColumnSchema,
            repeated: true
        },
        {
            no: 5,
            name: "header_row",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "data_start_row",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "subtotal_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 8,
            name: "discount_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 9,
            name: "section_labels",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * LCATQualificationEntry holds qualification requirements for a labor category
 * extracted from an LCAT Descriptions sheet in a pricing spreadsheet.
 *
 * @generated from message mono.govcon.v1.LCATQualificationEntry
 */ export class LCATQualificationEntry extends Message {
    static fromBinary(bytes, options) {
        return new LCATQualificationEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LCATQualificationEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LCATQualificationEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LCATQualificationEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_title = 1;
   */ _define_property(this, "categoryTitle", ""), /**
   * @generated from field: mono.govcon.v1.LCATQualificationV2 qualifications = 2;
   */ _define_property(this, "qualifications", void 0), /**
   * Source sheet name where this was found.
   *
   * @generated from field: string source_sheet = 3;
   */ _define_property(this, "sourceSheet", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LCATQualificationEntry, "runtime", proto3);
_define_property(LCATQualificationEntry, "typeName", "mono.govcon.v1.LCATQualificationEntry");
_define_property(LCATQualificationEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "qualifications",
            kind: "message",
            T: LCATQualificationV2
        },
        {
            no: 3,
            name: "source_sheet",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExtractRateObservationsRequest carries the document AND the context the sheet
 * cannot supply. Every field below except the path is something only the caller
 * knows, which is why none of them has a default.
 * What a pricing sheet says about ITSELF, read before anything is staged.
 *
 * This exists because asking a person to fill in the vehicle, the publisher and
 * the rate type is asking them for facts the document already states and the
 * parser already reads. The upload flow reads first and asks for CONFIRMATION,
 * which is a different question and a much shorter one.
 *
 * @generated from message mono.govcon.v1.InspectPricingSheetRequest
 */ export class InspectPricingSheetRequest extends Message {
    static fromBinary(bytes, options) {
        return new InspectPricingSheetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InspectPricingSheetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InspectPricingSheetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InspectPricingSheetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 2;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: bytes file_data = 3;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(InspectPricingSheetRequest, "runtime", proto3);
_define_property(InspectPricingSheetRequest, "typeName", "mono.govcon.v1.InspectPricingSheetRequest");
_define_property(InspectPricingSheetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PreviewRateSheetRequest
 */ export class PreviewRateSheetRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewRateSheetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewRateSheetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewRateSheetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewRateSheetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The document. filename is required: the native reader dispatches on the
   * extension.
   *
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 2;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: bytes file_data = 3;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * What KIND of fact these prices are (CEILING, FLOOR, PROPOSED, ...). Empty
   * reads as CEILING, which is what a published schedule is; a column header
   * that states its own type still wins.
   *
   * @generated from field: string observation_type = 4;
   */ _define_property(this, "observationType", ""), /**
   * Optional scope for the registry match, as on ExtractRateObservations.
   *
   * @generated from field: string company_profile_id = 5;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 6;
   */ _define_property(this, "contractVehicleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewRateSheetRequest, "runtime", proto3);
_define_property(PreviewRateSheetRequest, "typeName", "mono.govcon.v1.PreviewRateSheetRequest");
_define_property(PreviewRateSheetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PreviewRate is one parsed rate and where it came from.
 *
 * @generated from message mono.govcon.v1.PreviewRate
 */ export class PreviewRate extends Message {
    static fromBinary(bytes, options) {
        return new PreviewRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string labor_category = 1;
   */ _define_property(this, "laborCategory", ""), /**
   * The registry entry this title matched; empty when the registry has no such
   * category, which staging would propose as a new one.
   *
   * @generated from field: string registry_entry_id = 2;
   */ _define_property(this, "registryEntryId", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string rate_unit = 4;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string observation_type = 5;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string burden_basis = 6;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string currency = 7;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string company = 8;
   */ _define_property(this, "company", ""), /**
   * @generated from field: string uei = 9;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string contract_vehicle = 10;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string period_label = 11;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string period_start = 12;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 13;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: string worksite = 14;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string locality = 15;
   */ _define_property(this, "locality", ""), /**
   * @generated from field: string sin = 16;
   */ _define_property(this, "sin", ""), /**
   * @generated from field: string sheet_name = 17;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: string cell_ref = 18;
   */ _define_property(this, "cellRef", ""), /**
   * @generated from field: string cell_text = 19;
   */ _define_property(this, "cellText", ""), /**
   * HIGH, MEDIUM or LOW, and why.
   *
   * @generated from field: string confidence = 20;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string confidence_why = 21;
   */ _define_property(this, "confidenceWhy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewRate, "runtime", proto3);
_define_property(PreviewRate, "typeName", "mono.govcon.v1.PreviewRate");
_define_property(PreviewRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "registry_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "locality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "cell_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "cell_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "confidence_why",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PreviewRateSheetResponse
 */ export class PreviewRateSheetResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewRateSheetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewRateSheetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewRateSheetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewRateSheetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.PreviewRate rates = 1;
   */ _define_property(this, "rates", []), /**
   * What the document says about itself.
   *
   * @generated from field: string company = 2;
   */ _define_property(this, "company", ""), /**
   * @generated from field: string uei = 3;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string contract_vehicle = 4;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: int32 sheets_read = 6;
   */ _define_property(this, "sheetsRead", 0), /**
   * For a converted document: pages, tables found, tables read as grids.
   *
   * @generated from field: int32 pages = 7;
   */ _define_property(this, "pages", 0), /**
   * @generated from field: int32 tables = 8;
   */ _define_property(this, "tables", 0), /**
   * @generated from field: int32 tables_parsed = 9;
   */ _define_property(this, "tablesParsed", 0), /**
   * Why a sheet yielded nothing, in the parser's words.
   *
   * @generated from field: repeated string refusals = 10;
   */ _define_property(this, "refusals", []), /**
   * Distinct labor categories that matched the registry, and that did not.
   *
   * @generated from field: int32 categories_matched = 11;
   */ _define_property(this, "categoriesMatched", 0), /**
   * @generated from field: int32 categories_new = 12;
   */ _define_property(this, "categoriesNew", 0), /**
   * @generated from field: int64 processing_time_ms = 13;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewRateSheetResponse, "runtime", proto3);
_define_property(PreviewRateSheetResponse, "typeName", "mono.govcon.v1.PreviewRateSheetResponse");
_define_property(PreviewRateSheetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rates",
            kind: "message",
            T: PreviewRate,
            repeated: true
        },
        {
            no: 2,
            name: "company",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sheets_read",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "tables",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "tables_parsed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "refusals",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "categories_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "categories_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * A fact the document stated, with where it came from and what it matched.
 *
 * @generated from message mono.govcon.v1.PricingSheetFinding
 */ export class PricingSheetFinding extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetFinding().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetFinding().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetFinding().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetFinding, a, b);
    }
    constructor(data){
        super(), /**
   * The value as the document wrote it.
   *
   * @generated from field: string value = 1;
   */ _define_property(this, "value", ""), /**
   * Where it was read — "the sheet's Contractor: label", "the file name",
   * "the document title". A person deciding whether to trust a guess needs to
   * know which, and a filename is much weaker evidence than a labelled cell.
   *
   * @generated from field: string source = 2;
   */ _define_property(this, "source", ""), /**
   * The registry row this matched, empty when nothing did. Empty with a
   * non-empty value is the interesting case: the document names something we do
   * not have yet.
   *
   * @generated from field: string matched_id = 3;
   */ _define_property(this, "matchedId", ""), /**
   * @generated from field: string matched_name = 4;
   */ _define_property(this, "matchedName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetFinding, "runtime", proto3);
_define_property(PricingSheetFinding, "typeName", "mono.govcon.v1.PricingSheetFinding");
_define_property(PricingSheetFinding, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "matched_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "matched_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.InspectPricingSheetResponse
 */ export class InspectPricingSheetResponse extends Message {
    static fromBinary(bytes, options) {
        return new InspectPricingSheetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InspectPricingSheetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InspectPricingSheetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InspectPricingSheetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The vehicle, recognised from the document's own words or its file name.
   *
   * @generated from field: mono.govcon.v1.PricingSheetFinding vehicle = 1;
   */ _define_property(this, "vehicle", void 0), /**
   * Agency and type for a RECOGNISED vehicle, from the embedded catalog — so a
   * vehicle we have to create is created properly rather than as a bare name.
   *
   * @generated from field: string vehicle_agency = 2;
   */ _define_property(this, "vehicleAgency", ""), /**
   * @generated from field: string vehicle_type = 3;
   */ _define_property(this, "vehicleType", ""), /**
   * The publisher, when the sheet names one. A GOVERNMENT rate book names no
   * single company and leaves this empty, which is itself the answer to "who
   * published this".
   *
   * @generated from field: mono.govcon.v1.PricingSheetFinding company = 4;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: string uei = 5;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage = 6;
   */ _define_property(this, "cage", ""), /**
   * @generated from field: string contract_number = 7;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string pool = 8;
   */ _define_property(this, "pool", ""), /**
   * @generated from field: string effective = 9;
   */ _define_property(this, "effective", ""), /**
   * GOVERNMENT or COMPANY, decided by whether the sheet names a publisher.
   *
   * @generated from field: string issuer_kind = 10;
   */ _define_property(this, "issuerKind", ""), /**
   * The rate type the DOCUMENT implies — a wage determination is a FLOOR, a
   * published schedule is a CEILING. The caller still confirms it, because
   * filing one as the other inverts the document on every row.
   *
   * @generated from field: string observation_type = 11;
   */ _define_property(this, "observationType", ""), /**
   * Why that type, in one sentence, so the confirmation is informed rather than
   * a shrug.
   *
   * @generated from field: string observation_type_why = 12;
   */ _define_property(this, "observationTypeWhy", ""), /**
   * True when the document is not natively tabular, so these findings come from
   * the FILE NAME alone — the tables are read during the ingest. Said plainly
   * rather than presenting weak guesses as if they were read from the document.
   *
   * @generated from field: bool needs_conversion = 13;
   */ _define_property(this, "needsConversion", false), /**
   * Sheet or table names, for a person recognising their own file.
   *
   * @generated from field: repeated string sheet_names = 14;
   */ _define_property(this, "sheetNames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(InspectPricingSheetResponse, "runtime", proto3);
_define_property(InspectPricingSheetResponse, "typeName", "mono.govcon.v1.InspectPricingSheetResponse");
_define_property(InspectPricingSheetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle",
            kind: "message",
            T: PricingSheetFinding
        },
        {
            no: 2,
            name: "vehicle_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company",
            kind: "message",
            T: PricingSheetFinding
        },
        {
            no: 5,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pool",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "effective",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "observation_type_why",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "needs_conversion",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "sheet_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * A re-read runs in the background exactly like a fresh extraction, and the
 * response is the RUN to follow — nothing more. Its own message rather than
 * reusing ExtractRateObservationsResponse, because buf (rightly) requires each
 * RPC to own its response type, and because this response never carried more
 * than the run id anyway: everything else about a re-read arrives through the
 * run record and the staged change set, same as a fresh upload.
 *
 * @generated from message mono.govcon.v1.ReExtractPricingSheetResponse
 */ export class ReExtractPricingSheetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReExtractPricingSheetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReExtractPricingSheetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReExtractPricingSheetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReExtractPricingSheetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReExtractPricingSheetResponse, "runtime", proto3);
_define_property(ReExtractPricingSheetResponse, "typeName", "mono.govcon.v1.ReExtractPricingSheetResponse");
_define_property(ReExtractPricingSheetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ReExtractPricingSheetRequest
 */ export class ReExtractPricingSheetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReExtractPricingSheetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReExtractPricingSheetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReExtractPricingSheetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReExtractPricingSheetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * The artifact the sheet was uploaded as. Everything else — vehicle, company,
   * rate type — is re-derived, so a re-read reflects TODAY'S parser rather than
   * replaying yesterday's decisions.
   *
   * @generated from field: string source_document_id = 2;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * Carried through because they scope labor-category resolution and are not
   * recoverable from the bytes.
   *
   * @generated from field: string contract_vehicle_id = 3;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string observation_type = 5;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: bool seed_missing_categories = 6;
   */ _define_property(this, "seedMissingCategories", false), /**
   * The change set this replaces, if any. Superseded rather than deleted: a
   * reviewer may already have ruled on some of its blocks, and those decisions
   * are history worth keeping.
   *
   * @generated from field: string supersedes_change_set_id = 7;
   */ _define_property(this, "supersedesChangeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReExtractPricingSheetRequest, "runtime", proto3);
_define_property(ReExtractPricingSheetRequest, "typeName", "mono.govcon.v1.ReExtractPricingSheetRequest");
_define_property(ReExtractPricingSheetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "seed_missing_categories",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "supersedes_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GetPricingSheetPageRequest
 */ export class GetPricingSheetPageRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingSheetPageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingSheetPageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingSheetPageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingSheetPageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * The artifact the sheet was uploaded as — the same id a re-read takes.
   *
   * @generated from field: string source_document_id = 2;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * 1-based, matching what a person sees printed on the page.
   *
   * @generated from field: int32 page_number = 3;
   */ _define_property(this, "pageNumber", 0), /**
   * Optional literal citation. Page zero locates its first physical page.
   *
   * @generated from field: string quote = 4;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingSheetPageRequest, "runtime", proto3);
_define_property(GetPricingSheetPageRequest, "typeName", "mono.govcon.v1.GetPricingSheetPageRequest");
_define_property(GetPricingSheetPageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GetPricingSheetPageResponse
 */ export class GetPricingSheetPageResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingSheetPageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingSheetPageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingSheetPageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingSheetPageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page_number = 1;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: int32 total_pages = 2;
   */ _define_property(this, "totalPages", 0), /**
   * The size of the IMAGE below, in pixels. Every box is already scaled into
   * this space, so a viewer never has to know the render DPI.
   *
   * @generated from field: int32 page_width = 3;
   */ _define_property(this, "pageWidth", 0), /**
   * @generated from field: int32 page_height = 4;
   */ _define_property(this, "pageHeight", 0), /**
   * A data: URL. Inline rather than presigned because the artifact is behind
   * the gateway's auth and a second signed route is a second thing to secure.
   *
   * @generated from field: string image_data_url = 5;
   */ _define_property(this, "imageDataUrl", ""), /**
   * @generated from field: repeated mono.govcon.v1.PricingSheetPageBlock blocks = 6;
   */ _define_property(this, "blocks", []), /**
   * False for scanned documents or unmatched quotations; never guessed.
   *
   * @generated from field: bool quote_matched = 7;
   */ _define_property(this, "quoteMatched", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingSheetPageResponse, "runtime", proto3);
_define_property(GetPricingSheetPageResponse, "typeName", "mono.govcon.v1.GetPricingSheetPageResponse");
_define_property(GetPricingSheetPageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_width",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_height",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "image_data_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "blocks",
            kind: "message",
            T: PricingSheetPageBlock,
            repeated: true
        },
        {
            no: 7,
            name: "quote_matched",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PricingSheetPageBlock
 */ export class PricingSheetPageBlock extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetPageBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetPageBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetPageBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetPageBlock, a, b);
    }
    constructor(data){
        super(), /**
   * The converter's own id, e.g. "/page/3/Table/3" — exactly what a staged
   * rate's evidence carries, so the two match without translation.
   *
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string content = 3;
   */ _define_property(this, "content", ""), /**
   * @generated from field: double x = 4;
   */ _define_property(this, "x", 0), /**
   * @generated from field: double y = 5;
   */ _define_property(this, "y", 0), /**
   * @generated from field: double width = 6;
   */ _define_property(this, "width", 0), /**
   * @generated from field: double height = 7;
   */ _define_property(this, "height", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetPageBlock, "runtime", proto3);
_define_property(PricingSheetPageBlock, "typeName", "mono.govcon.v1.PricingSheetPageBlock");
_define_property(PricingSheetPageBlock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "x",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "y",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "width",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "height",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractRateObservationsRequest
 */ export class ExtractRateObservationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractRateObservationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractRateObservationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractRateObservationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractRateObservationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Path to the document. A spreadsheet is read NATIVELY — the same reader the
   * parser's corpus is scored with — so a lossy conversion cannot silently change
   * what production reads.
   *
   * Supply file_data INSTEAD when the caller has the bytes but not a path baltigo
   * can see, which is the REPLAY case: a rate whose category was unregistered
   * filed a candidate, and by the time a human accepts it the path from the
   * original run is long gone. Without this, replay would require a shared
   * filesystem between whoever accepts a candidate and whoever reads documents.
   *
   * @generated from field: string document_path = 1;
   */ _define_property(this, "documentPath", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * The document itself. filename must still be set — the native reader dispatches
   * on the extension, because that is what says whether the bytes are a workbook,
   * a CSV or a page of HTML.
   *
   * @generated from field: bytes file_data = 11;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * Scope for resolving a labor-category title: the same title is a different
   * entry for a different company on a different vehicle.
   *
   * @generated from field: string company_profile_id = 5;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 6;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string program_id = 7;
   */ _define_property(this, "programId", ""), /**
   * The artifact these rates came from, so a filed candidate can be replayed.
   *
   * @generated from field: string source_document_id = 8;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string recorded_by = 9;
   */ _define_property(this, "recordedBy", ""), /**
   * What KIND of fact these prices are: CEILING | FLOOR | PROPOSED | AWARDED |
   * SUBK_AGREED | BILLED | INFERRED. REQUIRED — a sheet of amounts does not say
   * whether nobody may charge more than them or nobody may pay less, and filing
   * one as the other is the most expensive mistake available here. A column
   * header that states its own type still wins over this.
   *
   * @generated from field: string observation_type = 10;
   */ _define_property(this, "observationType", ""), /**
   * Run this in the BACKGROUND and report progress against an intelligence run
   * instead of blocking.
   *
   * Off by default so the existing synchronous callers are untouched. On, the
   * response carries `run_id` immediately and every count stays zero — the work
   * has not happened yet — and the caller watches
   * IntelligenceGatewayService.GetIntelligenceRun for state, current_step and
   * progress_percent until it reaches READY_FOR_REVIEW or PARTIALLY_READY.
   *
   * This exists because the honest steps are minutes long: accurate-mode
   * conversion of a scanned 24-page pricelist, then a sheet at a time across a
   * vehicle-wide workbook. A browser cannot hold that request open, and a
   * spinner over it tells a person nothing.
   *
   * @generated from field: bool background = 12;
   */ _define_property(this, "background", false), /**
   * Create a registry entry for any labor category the sheet names and the
   * registry does not have, instead of filing it as a candidate.
   *
   * This is what makes a COLD START work. A rate must attach to a
   * labor_category_entries row, so a tenant with nothing seeded stages ZERO
   * rates from a perfectly good rate book — every title becomes a candidate and
   * every block is dropped. Measured, not assumed.
   *
   * Off by default and never inferred: minting 190 catalog entries is a real
   * write on shared data, so the caller must have shown a person the count and
   * been told yes. The upload flow does that on its confirmation screen.
   *
   * @generated from field: bool seed_missing_categories = 13;
   */ _define_property(this, "seedMissingCategories", false), /**
   * PROVENANCE of a sheet pulled from the web, all optional. Recorded on the
   * sheet's document row (delivery.pricing_sheet_generations) so a later reader
   * can say "this sheet came from <url>, pulled <retrieved_at>, sha256 <x>" and
   * re-pull to check for changes. Empty for a plain upload.
   *
   * source_url is the document itself; source_page_url the page that linked it.
   *
   * @generated from field: string source_url = 14;
   */ _define_property(this, "sourceUrl", ""), /**
   * @generated from field: string source_page_url = 15;
   */ _define_property(this, "sourcePageUrl", ""), /**
   * When the bytes were fetched from source_url.
   *
   * @generated from field: google.protobuf.Timestamp retrieved_at = 16;
   */ _define_property(this, "retrievedAt", void 0), /**
   * Lowercase hex SHA-256 of the bytes as fetched. When empty, baltigo computes
   * it from the bytes it reads, so every recorded sheet carries one.
   *
   * @generated from field: string source_sha256 = 17;
   */ _define_property(this, "sourceSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractRateObservationsRequest, "runtime", proto3);
_define_property(ExtractRateObservationsRequest, "typeName", "mono.govcon.v1.ExtractRateObservationsRequest");
_define_property(ExtractRateObservationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "background",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "seed_missing_categories",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "source_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractRateObservationsResponse
 */ export class ExtractRateObservationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractRateObservationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractRateObservationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractRateObservationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractRateObservationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Rates persisted DIRECTLY by this call. Now always 0, and kept rather than
   * renamed because that is a true statement rather than a compatibility shim: a
   * pricing sheet is staged as a change set of type 'PricingSheet' and nothing
   * reaches the rate book until a human accepts a block. A caller that has not
   * been updated reports "0 rates persisted", which is correct and sends them
   * looking — whereas reusing this field for the staged count would have them
   * report 1,060,674 rates as recorded fact.
   *
   * @generated from field: int32 observations = 1;
   */ _define_property(this, "observations", 0), /**
   * Rates NOT persisted because their labor category is unregistered. Reported
   * separately from the categories: "3 categories to accept" and "1,200 rates
   * waiting on them" are different situations for whoever reads this.
   *
   * @generated from field: int32 rates_unresolved = 2;
   */ _define_property(this, "ratesUnresolved", 0), /**
   * @generated from field: repeated mono.govcon.v1.UnresolvedLaborCategory unresolved = 3;
   */ _define_property(this, "unresolved", []), /**
   * Why a sheet yielded nothing, in the parser's own words. Silence and "found
   * nothing" are indistinguishable without these.
   *
   * @generated from field: repeated string refusals = 4;
   */ _define_property(this, "refusals", []), /**
   * Rates worth a human's attention FIRST, within what was staged. Every staged
   * rate is reviewable; these are the ones whose reading the parser was least
   * sure of.
   *
   * @generated from field: repeated mono.govcon.v1.RateReviewItem review_items = 5;
   */ _define_property(this, "reviewItems", []), /**
   * @generated from field: int32 sheets_read = 6;
   */ _define_property(this, "sheetsRead", 0), /**
   * Set when the run failed PART WAY. The counts above still hold, because a
   * caller told only "it failed" cannot tell whether to retry or reconcile.
   *
   * @generated from field: string error = 7;
   */ _define_property(this, "error", ""), /**
   * @generated from field: int64 processing_time_ms = 8;
   */ _define_property(this, "processingTimeMs", protoInt64.zero), /**
   * The change set holding the staged items. This is the handle the review UI
   * opens; without it a caller knows rates were staged and cannot find them.
   *
   * @generated from field: string change_set_id = 9;
   */ _define_property(this, "changeSetId", ""), /**
   * Rates STAGED for review: parsed, resolved to a registered labor category,
   * and waiting on a human. THIS is the number that used to be `observations`.
   *
   * @generated from field: int32 staged_rates = 10;
   */ _define_property(this, "stagedRates", 0), /**
   * The intelligence run tracking this ingest, set only when `background` was
   * requested. Poll it for the steps; every count in this response is zero
   * because nothing has been read yet.
   *
   * @generated from field: string run_id = 12;
   */ _define_property(this, "runId", ""), /**
   * Reviewable BLOCKS, which is what a person actually works through — one per
   * (company x period x worksite x burden x locality) plus one per sheet for the
   * reading itself. 42,000 rates are ~380 blocks; the rate count says how much
   * rides on the review, this says how long it takes.
   *
   * @generated from field: int32 review_blocks = 11;
   */ _define_property(this, "reviewBlocks", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractRateObservationsResponse, "runtime", proto3);
_define_property(ExtractRateObservationsResponse, "typeName", "mono.govcon.v1.ExtractRateObservationsResponse");
_define_property(ExtractRateObservationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "rates_unresolved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "unresolved",
            kind: "message",
            T: UnresolvedLaborCategory,
            repeated: true
        },
        {
            no: 4,
            name: "refusals",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "review_items",
            kind: "message",
            T: RateReviewItem,
            repeated: true
        },
        {
            no: 6,
            name: "sheets_read",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "staged_rates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "review_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.UnresolvedLaborCategory
 */ export class UnresolvedLaborCategory extends Message {
    static fromBinary(bytes, options) {
        return new UnresolvedLaborCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnresolvedLaborCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnresolvedLaborCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnresolvedLaborCategory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * How many rates are waiting on this one category being accepted.
   *
   * @generated from field: int32 rates = 2;
   */ _define_property(this, "rates", 0), /**
   * @generated from field: string sheet_name = 3;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: string first_cell_ref = 4;
   */ _define_property(this, "firstCellRef", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnresolvedLaborCategory, "runtime", proto3);
_define_property(UnresolvedLaborCategory, "typeName", "mono.govcon.v1.UnresolvedLaborCategory");
_define_property(UnresolvedLaborCategory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "first_cell_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.RateReviewItem
 */ export class RateReviewItem extends Message {
    static fromBinary(bytes, options) {
        return new RateReviewItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateReviewItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateReviewItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateReviewItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sheet_name = 1;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: string cell_ref = 2;
   */ _define_property(this, "cellRef", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string labor_category = 4;
   */ _define_property(this, "laborCategory", ""), /**
   * @generated from field: string company = 5;
   */ _define_property(this, "company", ""), /**
   * HIGH | MEDIUM | LOW, with the evidence that set it. A grade a reviewer
   * cannot interrogate is one they either trust blindly or ignore.
   *
   * @generated from field: string confidence = 6;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string confidence_why = 7;
   */ _define_property(this, "confidenceWhy", ""), /**
   * @generated from field: repeated string issues = 8;
   */ _define_property(this, "issues", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateReviewItem, "runtime", proto3);
_define_property(RateReviewItem, "typeName", "mono.govcon.v1.RateReviewItem");
_define_property(RateReviewItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cell_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence_why",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "issues",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractPricingTemplateRequest
 */ export class ExtractPricingTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractPricingTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractPricingTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractPricingTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractPricingTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * Extracted CLINs so the extractor knows what CLINs exist and their metadata.
   *
   * @generated from field: repeated mono.govcon.v1.CLIN extracted_clins = 4;
   */ _define_property(this, "extractedClins", []), /**
   * Optional: pre-classified tab summaries (from ClassifySpreadsheet) to skip Pass 1.
   *
   * @generated from field: repeated mono.govcon.v1.SpreadsheetTabSummary tab_classifications = 5;
   */ _define_property(this, "tabClassifications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractPricingTemplateRequest, "runtime", proto3);
_define_property(ExtractPricingTemplateRequest, "typeName", "mono.govcon.v1.ExtractPricingTemplateRequest");
_define_property(ExtractPricingTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "extracted_clins",
            kind: "message",
            T: CLIN,
            repeated: true
        },
        {
            no: 5,
            name: "tab_classifications",
            kind: "message",
            T: SpreadsheetTabSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractPricingTemplateResponse
 */ export class ExtractPricingTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractPricingTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractPricingTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractPricingTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractPricingTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.PricingTemplateResult result = 1;
   */ _define_property(this, "result", void 0), /**
   * @generated from field: int64 processing_time_ms = 2;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractPricingTemplateResponse, "runtime", proto3);
_define_property(ExtractPricingTemplateResponse, "typeName", "mono.govcon.v1.ExtractPricingTemplateResponse");
_define_property(ExtractPricingTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: PricingTemplateResult
        },
        {
            no: 2,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.PricingTemplateResult
 */ export class PricingTemplateResult extends Message {
    static fromBinary(bytes, options) {
        return new PricingTemplateResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingTemplateResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingTemplateResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingTemplateResult, a, b);
    }
    constructor(data){
        super(), /**
   * Extracted rate card with labor category rates.
   *
   * @generated from field: mono.govcon.v1.RateCardV2 rate_card = 1;
   */ _define_property(this, "rateCard", void 0), /**
   * Per-CLIN dimension composition.
   *
   * @generated from field: repeated mono.govcon.v1.CLINPricingV2 clin_pricing = 2;
   */ _define_property(this, "clinPricing", []), /**
   * Global fee method (applies to all CLINs unless overridden).
   *
   * @generated from field: mono.govcon.v1.FeeMethodV2 global_fee_method = 3;
   */ _define_property(this, "globalFeeMethod", void 0), /**
   * Extraction confidence (0.0-1.0).
   *
   * @generated from field: double template_confidence = 4;
   */ _define_property(this, "templateConfidence", 0), /**
   * Always "xlsx_extraction".
   *
   * @generated from field: string template_source = 5;
   */ _define_property(this, "templateSource", ""), /**
   * LCAT qualification entries from the LCAT Descriptions sheet.
   *
   * @generated from field: repeated mono.govcon.v1.LCATQualificationEntry lcat_qualifications = 6;
   */ _define_property(this, "lcatQualifications", []), /**
   * Extraction issues and warnings.
   *
   * @generated from field: repeated string warnings = 7;
   */ _define_property(this, "warnings", []), /**
   * Detailed sheet schemas (for debugging/transparency).
   *
   * @generated from field: repeated mono.govcon.v1.SheetSchema sheet_schemas = 8;
   */ _define_property(this, "sheetSchemas", []), /**
   * Inferred contract type across all CLINs.
   *
   * @generated from field: string contract_type = 9;
   */ _define_property(this, "contractType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingTemplateResult, "runtime", proto3);
_define_property(PricingTemplateResult, "typeName", "mono.govcon.v1.PricingTemplateResult");
_define_property(PricingTemplateResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_card",
            kind: "message",
            T: RateCardV2
        },
        {
            no: 2,
            name: "clin_pricing",
            kind: "message",
            T: CLINPricingV2,
            repeated: true
        },
        {
            no: 3,
            name: "global_fee_method",
            kind: "message",
            T: FeeMethodV2
        },
        {
            no: 4,
            name: "template_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "template_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "lcat_qualifications",
            kind: "message",
            T: LCATQualificationEntry,
            repeated: true
        },
        {
            no: 7,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "sheet_schemas",
            kind: "message",
            T: SheetSchema,
            repeated: true
        },
        {
            no: 9,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AnalyzeContractRequest
 */ export class AnalyzeContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Document content (markdown from ExtractBlocks or raw text)
   *
   * @generated from field: string content = 1;
   */ _define_property(this, "content", ""), /**
   * Storage context
   *
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * baltigo doc ID (if blocks already extracted)
   *
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * The award's attachments, read with it as on ExtractCLINsRequest, so one
   * reading of the award serves both calls.
   *
   * @generated from field: repeated mono.govcon.v1.AwardAttachmentRef attachments = 5;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeContractRequest, "runtime", proto3);
_define_property(AnalyzeContractRequest, "typeName", "mono.govcon.v1.AnalyzeContractRequest");
_define_property(AnalyzeContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: AwardAttachmentRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AnalyzeContractResponse
 */ export class AnalyzeContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ContractHeaderExtracted header = 1;
   */ _define_property(this, "header", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ContractorPartyExtracted parties = 2;
   */ _define_property(this, "parties", []), /**
   * @generated from field: repeated mono.govcon.v1.GovernmentContactExtracted contacts = 3;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: mono.govcon.v1.ContractPoPExtracted period_of_performance = 4;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * @generated from field: repeated mono.govcon.v1.PlaceOfPerformanceExtracted places_of_performance = 5;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: double overall_confidence = 6;
   */ _define_property(this, "overallConfidence", 0), /**
   * @generated from field: repeated string extraction_notes = 7;
   */ _define_property(this, "extractionNotes", []), /**
   * Facts the analysis could not settle (D86/D93): a period whose window or
   * total the period locator could not settle, or that the document prints
   * two different totals for. They ride to the program's ContractIntake set
   * beside the CLIN extraction's own.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 8;
   */ _define_property(this, "reviewItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeContractResponse, "runtime", proto3);
_define_property(AnalyzeContractResponse, "typeName", "mono.govcon.v1.AnalyzeContractResponse");
_define_property(AnalyzeContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "header",
            kind: "message",
            T: ContractHeaderExtracted
        },
        {
            no: 2,
            name: "parties",
            kind: "message",
            T: ContractorPartyExtracted,
            repeated: true
        },
        {
            no: 3,
            name: "contacts",
            kind: "message",
            T: GovernmentContactExtracted,
            repeated: true
        },
        {
            no: 4,
            name: "period_of_performance",
            kind: "message",
            T: ContractPoPExtracted
        },
        {
            no: 5,
            name: "places_of_performance",
            kind: "message",
            T: PlaceOfPerformanceExtracted,
            repeated: true
        },
        {
            no: 6,
            name: "overall_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "extraction_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        }
    ]));
/**
 * Contract header — extracted from contract document via LLM.
 * contract_number is REQUIRED; extraction fails without it.
 *
 * @generated from message mono.govcon.v1.ContractHeaderExtracted
 */ export class ContractHeaderExtracted extends Message {
    static fromBinary(bytes, options) {
        return new ContractHeaderExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractHeaderExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractHeaderExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractHeaderExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * REQUIRED
   *
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string contract_title = 2;
   */ _define_property(this, "contractTitle", ""), /**
   * FFP, T&M, CPFF, CPIF, CPAF, IDIQ, BPA, HYBRID, OTHER
   *
   * @generated from field: string contract_type = 3;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string solicitation_number = 4;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string agency_name = 5;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: string agency_acronym = 6;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string sub_agency = 7;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 8;
   */ _define_property(this, "subAgencyAcronym", ""), /**
   * e.g. "Alliant 2"
   *
   * @generated from field: string vehicle_name = 9;
   */ _define_property(this, "vehicleName", ""), /**
   * GSA_SCHEDULE, GWAC, BPA, IDIQ, OTHER
   *
   * @generated from field: string vehicle_type = 10;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: string vehicle_contract_number = 11;
   */ _define_property(this, "vehicleContractNumber", ""), /**
   * ISO 8601
   *
   * @generated from field: string award_date = 12;
   */ _define_property(this, "awardDate", ""), /**
   * @generated from field: string effective_date = 13;
   */ _define_property(this, "effectiveDate", ""), /**
   * @generated from field: double confidence = 14;
   */ _define_property(this, "confidence", 0), /**
   * Task/delivery order number when the award is a TO under a vehicle (the
   * program's own identity; vehicle_contract_number is the linked parent).
   *
   * @generated from field: string task_order_number = 15;
   */ _define_property(this, "taskOrderNumber", ""), /**
   * @generated from field: string naics_code = 16;
   */ _define_property(this, "naicsCode", ""), /**
   * The document's own declared total ("The Total Task Order Value is
   * $X") -- the evaluated award value. Distinct from any sum of CLIN rows:
   * optional-task lines price ceilings ("Up to N EA"), so the CLIN-table sum
   * can legitimately exceed it. 0 when the document states no total.
   *
   * @generated from field: double stated_total_value = 17;
   */ _define_property(this, "statedTotalValue", 0), /**
   * Each period total the period locator settled (SAD-778): the model names
   * the line, code reads the figure, Jev and the arithmetic confirm it. It is
   * the period's total_amount; a line sum is only the fallback. A period whose
   * total did not settle, or that the document prints two ways without
   * evidence for one, is absent here and raised as a review item instead.
   *
   * @generated from field: repeated mono.govcon.v1.StatedPeriodTotal stated_period_totals = 18;
   */ _define_property(this, "statedPeriodTotals", []), /**
   * The obligated total the award prints (SAD-885): Block 26, or its
   * obligation statements. Absent when it prints none, or prints two figures
   * (then a review item is raised instead).
   *
   * @generated from field: mono.common.v1.StatedObligation stated_obligation = 19;
   */ _define_property(this, "statedObligation", void 0), /**
   * The ceilings the award states for the whole order, one per kind. A
   * ceiling sentence that names no kind, or one kind printed two ways, is a
   * review item instead.
   *
   * @generated from field: repeated mono.common.v1.OrderCeiling order_ceilings = 20;
   */ _define_property(this, "orderCeilings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractHeaderExtracted, "runtime", proto3);
_define_property(ContractHeaderExtracted, "typeName", "mono.govcon.v1.ContractHeaderExtracted");
_define_property(ContractHeaderExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "award_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "task_order_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "stated_total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "stated_period_totals",
            kind: "message",
            T: StatedPeriodTotal,
            repeated: true
        },
        {
            no: 19,
            name: "stated_obligation",
            kind: "message",
            T: StatedObligation
        },
        {
            no: 20,
            name: "order_ceilings",
            kind: "message",
            T: OrderCeiling,
            repeated: true
        }
    ]));
/**
 * StatedPeriodTotal is one period's value as the document prints it.
 *
 * @generated from message mono.govcon.v1.StatedPeriodTotal
 */ export class StatedPeriodTotal extends Message {
    static fromBinary(bytes, options) {
        return new StatedPeriodTotal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatedPeriodTotal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatedPeriodTotal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatedPeriodTotal, a, b);
    }
    constructor(data){
        super(), /**
   * "base" or "option:N".
   *
   * @generated from field: string period_key = 1;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: double amount = 2;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string quote = 3;
   */ _define_property(this, "quote", ""), /**
   * The page the quote is printed on (SAD-778).
   *
   * @generated from field: int32 page = 4;
   */ _define_property(this, "page", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StatedPeriodTotal, "runtime", proto3);
_define_property(StatedPeriodTotal, "typeName", "mono.govcon.v1.StatedPeriodTotal");
_define_property(StatedPeriodTotal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Contractor party (prime or sub) — extracted from contract document.
 *
 * @generated from message mono.govcon.v1.ContractorPartyExtracted
 */ export class ContractorPartyExtracted extends Message {
    static fromBinary(bytes, options) {
        return new ContractorPartyExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractorPartyExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractorPartyExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractorPartyExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string duns = 2;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 3;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * prime, subcontractor, teaming_partner
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: double percentage = 6;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string street1 = 7;
   */ _define_property(this, "street1", ""), /**
   * @generated from field: string street2 = 8;
   */ _define_property(this, "street2", ""), /**
   * @generated from field: string city = 9;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 10;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 11;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 12;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractorPartyExtracted, "runtime", proto3);
_define_property(ContractorPartyExtracted, "typeName", "mono.govcon.v1.ContractorPartyExtracted");
_define_property(ContractorPartyExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "street1",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "street2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Government contact — extracted from contract document.
 *
 * @generated from message mono.govcon.v1.GovernmentContactExtracted
 */ export class GovernmentContactExtracted extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentContactExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentContactExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentContactExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentContactExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * contracting_officer, cor, technical_poc, program_manager, contract_specialist, other
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 5;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentContactExtracted, "runtime", proto3);
_define_property(GovernmentContactExtracted, "typeName", "mono.govcon.v1.GovernmentContactExtracted");
_define_property(GovernmentContactExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Period of performance — extracted from contract document.
 *
 * @generated from message mono.govcon.v1.ContractPoPExtracted
 */ export class ContractPoPExtracted extends Message {
    static fromBinary(bytes, options) {
        return new ContractPoPExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPoPExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPoPExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPoPExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * ISO 8601
   *
   * @generated from field: string start_date = 1;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 2;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 duration_months = 3;
   */ _define_property(this, "durationMonths", 0), /**
   * @generated from field: mono.govcon.v1.ContractPeriodExtracted base_period = 4;
   */ _define_property(this, "basePeriod", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ContractPeriodExtracted option_periods = 5;
   */ _define_property(this, "optionPeriods", []), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPoPExtracted, "runtime", proto3);
_define_property(ContractPoPExtracted, "typeName", "mono.govcon.v1.ContractPoPExtracted");
_define_property(ContractPoPExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "base_period",
            kind: "message",
            T: ContractPeriodExtracted
        },
        {
            no: 5,
            name: "option_periods",
            kind: "message",
            T: ContractPeriodExtracted,
            repeated: true
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ContractPeriodExtracted
 */ export class ContractPeriodExtracted extends Message {
    static fromBinary(bytes, options) {
        return new ContractPeriodExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPeriodExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPeriodExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPeriodExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * "Base Period", "Option Period 1"
   *
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string start_date = 2;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 3;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 duration_months = 4;
   */ _define_property(this, "durationMonths", 0), /**
   * "base" or "option_period"
   *
   * @generated from field: string type = 5;
   */ _define_property(this, "type", ""), /**
   * 0 for base, 1+ for options
   *
   * @generated from field: int32 option_number = 6;
   */ _define_property(this, "optionNumber", 0), /**
   * Where the window is printed, when the period locator settled it (SAD-778).
   *
   * @generated from field: string source_quote = 7;
   */ _define_property(this, "sourceQuote", ""), /**
   * @generated from field: int32 source_page = 8;
   */ _define_property(this, "sourcePage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPeriodExtracted, "runtime", proto3);
_define_property(ContractPeriodExtracted, "typeName", "mono.govcon.v1.ContractPeriodExtracted");
_define_property(ContractPeriodExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Place of performance — extracted from contract document.
 *
 * @generated from message mono.govcon.v1.PlaceOfPerformanceExtracted
 */ export class PlaceOfPerformanceExtracted extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformanceExtracted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformanceExtracted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformanceExtracted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformanceExtracted, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool primary = 1;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 3;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 4;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 6;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 7;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformanceExtracted, "runtime", proto3);
_define_property(PlaceOfPerformanceExtracted, "typeName", "mono.govcon.v1.PlaceOfPerformanceExtracted");
_define_property(PlaceOfPerformanceExtracted, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyContractRequest
 */ export class ClassifyContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string minio_path = 3;
   */ _define_property(this, "minioPath", ""), /**
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string contract_number = 7;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: repeated string batch_filenames = 8;
   */ _define_property(this, "batchFilenames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyContractRequest, "runtime", proto3);
_define_property(ClassifyContractRequest, "typeName", "mono.govcon.v1.ClassifyContractRequest");
_define_property(ClassifyContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "minio_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "batch_filenames",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ClassifyContractResponse
 */ export class ClassifyContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ContractClassificationProto classification = 1;
   */ _define_property(this, "classification", void 0), /**
   * @generated from field: mono.govcon.v1.ContractDocumentSummaryProto summary = 2;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyContractResponse, "runtime", proto3);
_define_property(ClassifyContractResponse, "typeName", "mono.govcon.v1.ClassifyContractResponse");
_define_property(ClassifyContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification",
            kind: "message",
            T: ContractClassificationProto
        },
        {
            no: 2,
            name: "summary",
            kind: "message",
            T: ContractDocumentSummaryProto
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ContractClassificationProto
 */ export class ContractClassificationProto extends Message {
    static fromBinary(bytes, options) {
        return new ContractClassificationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractClassificationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractClassificationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractClassificationProto, a, b);
    }
    constructor(data){
        super(), /**
   * e.g. "CONTRACT_MODIFICATION"
   *
   * @generated from field: string document_type = 1;
   */ _define_property(this, "documentType", ""), /**
   * e.g. "MODIFICATION"
   *
   * @generated from field: string primary_type = 2;
   */ _define_property(this, "primaryType", ""), /**
   * @generated from field: double confidence = 3;
   */ _define_property(this, "confidence", 0), /**
   * "filename", "content-analysis", "filename-override"
   *
   * @generated from field: string confidence_source = 4;
   */ _define_property(this, "confidenceSource", ""), /**
   * @generated from field: mono.govcon.v1.ContractClassificationMetadataProto metadata = 5;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractClassificationProto, "runtime", proto3);
_define_property(ContractClassificationProto, "typeName", "mono.govcon.v1.ContractClassificationProto");
_define_property(ContractClassificationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "primary_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "confidence_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "metadata",
            kind: "message",
            T: ContractClassificationMetadataProto
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ContractClassificationMetadataProto
 */ export class ContractClassificationMetadataProto extends Message {
    static fromBinary(bytes, options) {
        return new ContractClassificationMetadataProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractClassificationMetadataProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractClassificationMetadataProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractClassificationMetadataProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string classification_reason = 1;
   */ _define_property(this, "classificationReason", ""), /**
   * @generated from field: string modification_number = 2;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_order_number = 4;
   */ _define_property(this, "taskOrderNumber", ""), /**
   * @generated from field: string effective_date = 5;
   */ _define_property(this, "effectiveDate", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractClassificationMetadataProto, "runtime", proto3);
_define_property(ContractClassificationMetadataProto, "typeName", "mono.govcon.v1.ContractClassificationMetadataProto");
_define_property(ContractClassificationMetadataProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "classification_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "task_order_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ContractDocumentSummaryProto
 */ export class ContractDocumentSummaryProto extends Message {
    static fromBinary(bytes, options) {
        return new ContractDocumentSummaryProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDocumentSummaryProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDocumentSummaryProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDocumentSummaryProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string short_summary = 1;
   */ _define_property(this, "shortSummary", ""), /**
   * @generated from field: repeated string key_topics = 2;
   */ _define_property(this, "keyTopics", []), /**
   * @generated from field: repeated string key_entities = 3;
   */ _define_property(this, "keyEntities", []), /**
   * @generated from field: string contract_number = 4;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string agency = 5;
   */ _define_property(this, "agency", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDocumentSummaryProto, "runtime", proto3);
_define_property(ContractDocumentSummaryProto, "typeName", "mono.govcon.v1.ContractDocumentSummaryProto");
_define_property(ContractDocumentSummaryProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "short_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key_topics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "key_entities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AnalyzeModificationRequest
 */ export class AnalyzeModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string content = 1;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string document_id = 5;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string contract_number = 6;
   */ _define_property(this, "contractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeModificationRequest, "runtime", proto3);
_define_property(AnalyzeModificationRequest, "typeName", "mono.govcon.v1.AnalyzeModificationRequest");
_define_property(AnalyzeModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AnalyzeModificationResponse
 */ export class AnalyzeModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ModificationMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ModFundingChange funding_changes = 2;
   */ _define_property(this, "fundingChanges", []), /**
   * @generated from field: repeated mono.govcon.v1.ModScopeChange scope_changes = 3;
   */ _define_property(this, "scopeChanges", []), /**
   * @generated from field: repeated mono.govcon.v1.ModPeriodChange period_changes = 4;
   */ _define_property(this, "periodChanges", []), /**
   * @generated from field: repeated mono.govcon.v1.ModPartyChange party_changes = 5;
   */ _define_property(this, "partyChanges", []), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string extraction_notes = 7;
   */ _define_property(this, "extractionNotes", []), /**
   * What the judged analysis could not settle (D91, D101): a type or purpose
   * under the gate is raised here and left empty in metadata, never guessed.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 8;
   */ _define_property(this, "reviewItems", []), /**
   * The analysis ran the deterministic parse plus System One judgments
   * (AnalyzeModificationJudged), not the completion fallback; only a judged
   * type and purpose are settled by code.
   *
   * @generated from field: bool judged = 9;
   */ _define_property(this, "judged", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeModificationResponse, "runtime", proto3);
_define_property(AnalyzeModificationResponse, "typeName", "mono.govcon.v1.AnalyzeModificationResponse");
_define_property(AnalyzeModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: ModificationMetadata
        },
        {
            no: 2,
            name: "funding_changes",
            kind: "message",
            T: ModFundingChange,
            repeated: true
        },
        {
            no: 3,
            name: "scope_changes",
            kind: "message",
            T: ModScopeChange,
            repeated: true
        },
        {
            no: 4,
            name: "period_changes",
            kind: "message",
            T: ModPeriodChange,
            repeated: true
        },
        {
            no: 5,
            name: "party_changes",
            kind: "message",
            T: ModPartyChange,
            repeated: true
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "extraction_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 9,
            name: "judged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ModificationMetadata
 */ export class ModificationMetadata extends Message {
    static fromBinary(bytes, options) {
        return new ModificationMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_number = 1;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string modification_type = 2;
   */ _define_property(this, "modificationType", ""), /**
   * @generated from field: string effective_date = 3;
   */ _define_property(this, "effectiveDate", ""), /**
   * @generated from field: string signed_date = 4;
   */ _define_property(this, "signedDate", ""), /**
   * @generated from field: string purpose = 5;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: repeated string change_categories = 6;
   */ _define_property(this, "changeCategories", []), /**
   * @generated from field: bool no_cost_modification = 7;
   */ _define_property(this, "noCostModification", false), /**
   * @generated from field: double total_funding_impact = 8;
   */ _define_property(this, "totalFundingImpact", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationMetadata, "runtime", proto3);
_define_property(ModificationMetadata, "typeName", "mono.govcon.v1.ModificationMetadata");
_define_property(ModificationMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "signed_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "change_categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "no_cost_modification",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "total_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ModFundingChange
 */ export class ModFundingChange extends Message {
    static fromBinary(bytes, options) {
        return new ModFundingChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModFundingChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModFundingChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModFundingChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: double previous_amount = 3;
   */ _define_property(this, "previousAmount", 0), /**
   * @generated from field: double new_amount = 4;
   */ _define_property(this, "newAmount", 0), /**
   * @generated from field: double change_amount = 5;
   */ _define_property(this, "changeAmount", 0), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModFundingChange, "runtime", proto3);
_define_property(ModFundingChange, "typeName", "mono.govcon.v1.ModFundingChange");
_define_property(ModFundingChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "new_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "change_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ModScopeChange
 */ export class ModScopeChange extends Message {
    static fromBinary(bytes, options) {
        return new ModScopeChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModScopeChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModScopeChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModScopeChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string previous_description = 4;
   */ _define_property(this, "previousDescription", ""), /**
   * @generated from field: string new_description = 5;
   */ _define_property(this, "newDescription", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModScopeChange, "runtime", proto3);
_define_property(ModScopeChange, "typeName", "mono.govcon.v1.ModScopeChange");
_define_property(ModScopeChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "previous_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "new_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ModPeriodChange
 */ export class ModPeriodChange extends Message {
    static fromBinary(bytes, options) {
        return new ModPeriodChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModPeriodChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModPeriodChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModPeriodChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string period_name = 1;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string previous_start_date = 3;
   */ _define_property(this, "previousStartDate", ""), /**
   * @generated from field: string new_start_date = 4;
   */ _define_property(this, "newStartDate", ""), /**
   * @generated from field: string previous_end_date = 5;
   */ _define_property(this, "previousEndDate", ""), /**
   * @generated from field: string new_end_date = 6;
   */ _define_property(this, "newEndDate", ""), /**
   * @generated from field: repeated string affected_clins = 7;
   */ _define_property(this, "affectedClins", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModPeriodChange, "runtime", proto3);
_define_property(ModPeriodChange, "typeName", "mono.govcon.v1.ModPeriodChange");
_define_property(ModPeriodChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "previous_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "new_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "affected_clins",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ModPartyChange
 */ export class ModPartyChange extends Message {
    static fromBinary(bytes, options) {
        return new ModPartyChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModPartyChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModPartyChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModPartyChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_type = 1;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string party_name = 2;
   */ _define_property(this, "partyName", ""), /**
   * @generated from field: string previous_role = 3;
   */ _define_property(this, "previousRole", ""), /**
   * @generated from field: string new_role = 4;
   */ _define_property(this, "newRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModPartyChange, "runtime", proto3);
_define_property(ModPartyChange, "typeName", "mono.govcon.v1.ModPartyChange");
_define_property(ModPartyChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "party_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractCapabilitiesRequest
 */ export class ExtractCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 1;
   */ _define_property(this, "blocks", []), /**
   * Storage path to HTML output for structured block parsing.
   *
   * @generated from field: string html_path = 2;
   */ _define_property(this, "htmlPath", ""), /**
   * Tenant ID for storage access.
   *
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * MinIO path to pre-parsed blocks.json.
   *
   * @generated from field: string blocks_path = 4;
   */ _define_property(this, "blocksPath", ""), /**
   * Project ID for hierarchical MinIO storage.
   *
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * Company ID (tenant prefix) for MinIO storage.
   *
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", ""), /**
   * Baltigo document ID.
   *
   * @generated from field: string doc_id = 7;
   */ _define_property(this, "docId", ""), /**
   * Original filename.
   *
   * @generated from field: string doc_filename = 8;
   */ _define_property(this, "docFilename", ""), /**
   * Classified document type (e.g., "PAST_PERFORMANCE", "PWS", "RESUME").
   *
   * @generated from field: string doc_type = 9;
   */ _define_property(this, "docType", ""), /**
   * Extraction options.
   *
   * @generated from field: mono.govcon.v1.CapabilityExtractionOptions options = 10;
   */ _define_property(this, "options", void 0), /**
   * Tesoro artifact ID. When set, baltigo writes the per-doc capabilities
   * JSON at artifactstore.BuildProcessedKey(tenant, project, artifact_id,
   * "capabilities.json") so zou can read it from the shared key without
   * hardcoding ad-hoc paths.
   *
   * @generated from field: string artifact_id = 11;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractCapabilitiesRequest, "runtime", proto3);
_define_property(ExtractCapabilitiesRequest, "typeName", "mono.govcon.v1.ExtractCapabilitiesRequest");
_define_property(ExtractCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 2,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "doc_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "options",
            kind: "message",
            T: CapabilityExtractionOptions
        },
        {
            no: 11,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CapabilityExtractionOptions
 */ export class CapabilityExtractionOptions extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityExtractionOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityExtractionOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityExtractionOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityExtractionOptions, a, b);
    }
    constructor(data){
        super(), /**
   * Minimum confidence score to include (0.0–1.0). Default: 0.5.
   * Pass a negative value to disable filtering entirely.
   *
   * @generated from field: double min_confidence = 1;
   */ _define_property(this, "minConfidence", 0), /**
   * Maximum capabilities to extract per document. Default: 50.
   *
   * @generated from field: int32 max_capabilities = 2;
   */ _define_property(this, "maxCapabilities", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityExtractionOptions, "runtime", proto3);
_define_property(CapabilityExtractionOptions, "typeName", "mono.govcon.v1.CapabilityExtractionOptions");
_define_property(CapabilityExtractionOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "min_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "max_capabilities",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractCapabilitiesResponse
 */ export class ExtractCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.ExtractedCapability capabilities = 1;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: mono.govcon.v1.CapabilityExtractionStatistics statistics = 2;
   */ _define_property(this, "statistics", void 0), /**
   * @generated from field: repeated string warnings = 3;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: int64 processing_time_ms = 4;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractCapabilitiesResponse, "runtime", proto3);
_define_property(ExtractCapabilitiesResponse, "typeName", "mono.govcon.v1.ExtractCapabilitiesResponse");
_define_property(ExtractCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: ExtractedCapability,
            repeated: true
        },
        {
            no: 2,
            name: "statistics",
            kind: "message",
            T: CapabilityExtractionStatistics
        },
        {
            no: 3,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * ExtractedCapability is a single capability extracted from a vendor document.
 *
 * @generated from message mono.govcon.v1.ExtractedCapability
 */ export class ExtractedCapability extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedCapability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedCapability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedCapability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedCapability, a, b);
    }
    constructor(data){
        super(), /**
   * TECHNICAL, PAST_PERFORMANCE, PERSONNEL, CERTIFICATION
   *
   * @generated from field: string capability_type = 1;
   */ _define_property(this, "capabilityType", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string skills = 4;
   */ _define_property(this, "skills", []), /**
   * @generated from field: repeated string certifications = 5;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: repeated string naics_codes = 6;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string contract_types = 7;
   */ _define_property(this, "contractTypes", []), /**
   * @generated from field: repeated string agencies = 8;
   */ _define_property(this, "agencies", []), /**
   * Past performance proof (populated for PAST_PERFORMANCE type).
   *
   * @generated from field: mono.govcon.v1.ExtractedPastPerformance past_performance = 9;
   */ _define_property(this, "pastPerformance", void 0), /**
   * Source location in the document.
   *
   * @generated from field: mono.govcon.v1.CapabilitySource source = 10;
   */ _define_property(this, "source", void 0), /**
   * Extraction confidence (0.0–1.0).
   *
   * @generated from field: double confidence = 11;
   */ _define_property(this, "confidence", 0), /**
   * Exact quote from document supporting this capability.
   *
   * @generated from field: string evidence = 12;
   */ _define_property(this, "evidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedCapability, "runtime", proto3);
_define_property(ExtractedCapability, "typeName", "mono.govcon.v1.ExtractedCapability");
_define_property(ExtractedCapability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "skills",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "contract_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "agencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "past_performance",
            kind: "message",
            T: ExtractedPastPerformance
        },
        {
            no: 10,
            name: "source",
            kind: "message",
            T: CapabilitySource
        },
        {
            no: 11,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CapabilitySource identifies where a capability was found in its source document.
 *
 * @generated from message mono.govcon.v1.CapabilitySource
 */ export class CapabilitySource extends Message {
    static fromBinary(bytes, options) {
        return new CapabilitySource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilitySource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilitySource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilitySource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string block_id = 2;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string section_number = 3;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 page_number = 4;
   */ _define_property(this, "pageNumber", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilitySource, "runtime", proto3);
_define_property(CapabilitySource, "typeName", "mono.govcon.v1.CapabilitySource");
_define_property(CapabilitySource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractedPastPerformance
 */ export class ExtractedPastPerformance extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedPastPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedPastPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedPastPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedPastPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string contract_value = 2;
   */ _define_property(this, "contractValue", ""), /**
   * @generated from field: string performance_period = 3;
   */ _define_property(this, "performancePeriod", ""), /**
   * @generated from field: string client_name = 4;
   */ _define_property(this, "clientName", ""), /**
   * @generated from field: string project_description = 5;
   */ _define_property(this, "projectDescription", ""), /**
   * @generated from field: repeated string key_outcomes = 6;
   */ _define_property(this, "keyOutcomes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedPastPerformance, "runtime", proto3);
_define_property(ExtractedPastPerformance, "typeName", "mono.govcon.v1.ExtractedPastPerformance");
_define_property(ExtractedPastPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "performance_period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "client_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "key_outcomes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.CapabilityExtractionStatistics
 */ export class CapabilityExtractionStatistics extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityExtractionStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityExtractionStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityExtractionStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityExtractionStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 blocks_processed = 1;
   */ _define_property(this, "blocksProcessed", 0), /**
   * @generated from field: int32 capabilities_found = 2;
   */ _define_property(this, "capabilitiesFound", 0), /**
   * @generated from field: int32 technical_count = 3;
   */ _define_property(this, "technicalCount", 0), /**
   * @generated from field: int32 past_performance_count = 4;
   */ _define_property(this, "pastPerformanceCount", 0), /**
   * @generated from field: int32 personnel_count = 5;
   */ _define_property(this, "personnelCount", 0), /**
   * @generated from field: int32 certification_count = 6;
   */ _define_property(this, "certificationCount", 0), /**
   * @generated from field: double average_confidence = 7;
   */ _define_property(this, "averageConfidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityExtractionStatistics, "runtime", proto3);
_define_property(CapabilityExtractionStatistics, "typeName", "mono.govcon.v1.CapabilityExtractionStatistics");
_define_property(CapabilityExtractionStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "blocks_processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "capabilities_found",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "technical_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "past_performance_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "personnel_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "certification_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "average_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.MatchCapabilitiesRequest
 */ export class MatchCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MatchCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The requirement text to match against.
   *
   * @generated from field: string requirement_text = 1;
   */ _define_property(this, "requirementText", ""), /**
   * Obligation strength (MUST, SHOULD, MAY, etc.).
   *
   * @generated from field: string obligation_strength = 2;
   */ _define_property(this, "obligationStrength", ""), /**
   * Candidate capabilities to score against the requirement.
   *
   * @generated from field: repeated mono.govcon.v1.CapabilityInput capabilities = 3;
   */ _define_property(this, "capabilities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchCapabilitiesRequest, "runtime", proto3);
_define_property(MatchCapabilitiesRequest, "typeName", "mono.govcon.v1.MatchCapabilitiesRequest");
_define_property(MatchCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "obligation_strength",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capabilities",
            kind: "message",
            T: CapabilityInput,
            repeated: true
        }
    ]));
/**
 * CapabilityInput is a candidate capability for matching.
 *
 * @generated from message mono.govcon.v1.CapabilityInput
 */ export class CapabilityInput extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string skills = 4;
   */ _define_property(this, "skills", []), /**
   * Evidence text from the source document.
   *
   * @generated from field: string evidence = 5;
   */ _define_property(this, "evidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityInput, "runtime", proto3);
_define_property(CapabilityInput, "typeName", "mono.govcon.v1.CapabilityInput");
_define_property(CapabilityInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "skills",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.MatchCapabilitiesResponse
 */ export class MatchCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MatchCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.CapabilityMatchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: int64 processing_time_ms = 2;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchCapabilitiesResponse, "runtime", proto3);
_define_property(MatchCapabilitiesResponse, "typeName", "mono.govcon.v1.MatchCapabilitiesResponse");
_define_property(MatchCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: CapabilityMatchResult,
            repeated: true
        },
        {
            no: 2,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * CapabilityMatchResult is the LLM's assessment of one capability against a requirement.
 *
 * @generated from message mono.govcon.v1.CapabilityMatchResult
 */ export class CapabilityMatchResult extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityMatchResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityMatchResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityMatchResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityMatchResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * Match score 0-100.
   *
   * @generated from field: double match_score = 2;
   */ _define_property(this, "matchScore", 0), /**
   * LLM justification for the score.
   *
   * @generated from field: string justification = 3;
   */ _define_property(this, "justification", ""), /**
   * Exact quotes from the capability evidence supporting the match.
   *
   * @generated from field: repeated string evidence_excerpts = 4;
   */ _define_property(this, "evidenceExcerpts", []), /**
   * Gaps identified — what the capability doesn't cover.
   *
   * @generated from field: repeated string gaps = 5;
   */ _define_property(this, "gaps", []), /**
   * Suggested actions to strengthen the match.
   *
   * @generated from field: repeated string recommended_actions = 6;
   */ _define_property(this, "recommendedActions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityMatchResult, "runtime", proto3);
_define_property(CapabilityMatchResult, "typeName", "mono.govcon.v1.CapabilityMatchResult");
_define_property(CapabilityMatchResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "justification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence_excerpts",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "gaps",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "recommended_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractOutlineRequest
 */ export class ExtractOutlineRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractOutlineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractOutlineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractOutlineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractOutlineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * MinIO object key for the document (e.g., "tenant/docid/current.docx").
   *
   * @generated from field: string minio_key = 1;
   */ _define_property(this, "minioKey", ""), /**
   * Document type: "docx", "xlsx", "pptx".
   *
   * @generated from field: string document_type = 2;
   */ _define_property(this, "documentType", ""), /**
   * MinIO bucket override. Empty = default baltigo bucket.
   *
   * @generated from field: string minio_bucket = 3;
   */ _define_property(this, "minioBucket", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractOutlineRequest, "runtime", proto3);
_define_property(ExtractOutlineRequest, "typeName", "mono.govcon.v1.ExtractOutlineRequest");
_define_property(ExtractOutlineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "minio_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "minio_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractOutlineResponse
 */ export class ExtractOutlineResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractOutlineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractOutlineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractOutlineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractOutlineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * For DOCX: heading entries extracted from document.xml.
   * For XLSX: one entry per sheet.
   * For PPTX: one entry per slide.
   *
   * @generated from field: repeated mono.govcon.v1.OutlineEntry entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractOutlineResponse, "runtime", proto3);
_define_property(ExtractOutlineResponse, "typeName", "mono.govcon.v1.ExtractOutlineResponse");
_define_property(ExtractOutlineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: OutlineEntry,
            repeated: true
        }
    ]));
/**
 * OutlineEntry is a single heading, sheet, or slide extracted from an OOXML file.
 *
 * @generated from message mono.govcon.v1.OutlineEntry
 */ export class OutlineEntry extends Message {
    static fromBinary(bytes, options) {
        return new OutlineEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutlineEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutlineEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutlineEntry, a, b);
    }
    constructor(data){
        super(), /**
   * Heading level (1-6 for DOCX, 0 for sheets/slides).
   *
   * @generated from field: int32 level = 1;
   */ _define_property(this, "level", 0), /**
   * Title text (heading content, sheet name, or slide title).
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * Stable ID for bookmark targeting. For DOCX: auto-generated bookmark ID
   * derived from the heading text. For XLSX: sheet name. For PPTX: slide index.
   *
   * @generated from field: string bookmark_id = 3;
   */ _define_property(this, "bookmarkId", ""), /**
   * Zero-based index in document order.
   *
   * @generated from field: int32 index = 4;
   */ _define_property(this, "index", 0), /**
   * WRT-29 (DOCX only): the heading's anchor bookmark (^_?spx_[0-9a-f]{32}$),
   * empty when it has none or when it duplicates an earlier heading's.
   *
   * @generated from field: string anchor = 5;
   */ _define_property(this, "anchor", ""), /**
   * The legacy slug (= bookmark_id for DOCX).
   *
   * @generated from field: string legacy_slug = 6;
   */ _define_property(this, "legacySlug", ""), /**
   * Word count and normalized-text sha256 of the heading's region.
   *
   * @generated from field: int32 words = 7;
   */ _define_property(this, "words", 0), /**
   * @generated from field: string region_sha256 = 8;
   */ _define_property(this, "regionSha256", ""), /**
   * True when the heading carries a copy of an earlier heading's anchor.
   *
   * @generated from field: bool duplicate_anchor = 9;
   */ _define_property(this, "duplicateAnchor", false), /**
   * PRP-31: the entry's own body measure (> 0 = "drafted"). DOCX:
   * non-whitespace characters between the heading and the next heading of any
   * level (nested headings excluded). XLSX: non-empty cells outside row 1.
   * PPTX: non-whitespace characters on the slide outside its title.
   *
   * @generated from field: int32 body_chars = 10;
   */ _define_property(this, "bodyChars", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OutlineEntry, "runtime", proto3);
_define_property(OutlineEntry, "typeName", "mono.govcon.v1.OutlineEntry");
_define_property(OutlineEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "bookmark_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "legacy_slug",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "words",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "duplicate_anchor",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "body_chars",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractDocumentTextRequest
 */ export class ExtractDocumentTextRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractDocumentTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractDocumentTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractDocumentTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractDocumentTextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string minio_key = 1;
   */ _define_property(this, "minioKey", ""), /**
   * "docx", "xlsx", "pptx"
   *
   * @generated from field: string document_type = 2;
   */ _define_property(this, "documentType", ""), /**
   * optional override
   *
   * @generated from field: string minio_bucket = 3;
   */ _define_property(this, "minioBucket", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractDocumentTextRequest, "runtime", proto3);
_define_property(ExtractDocumentTextRequest, "typeName", "mono.govcon.v1.ExtractDocumentTextRequest");
_define_property(ExtractDocumentTextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "minio_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "minio_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractDocumentTextResponse
 */ export class ExtractDocumentTextResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractDocumentTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractDocumentTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractDocumentTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractDocumentTextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * @generated from field: int32 character_count = 2;
   */ _define_property(this, "characterCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractDocumentTextResponse, "runtime", proto3);
_define_property(ExtractDocumentTextResponse, "typeName", "mono.govcon.v1.ExtractDocumentTextResponse");
_define_property(ExtractDocumentTextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "character_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExtractAwardedContractRequest mirrors the input cascade the other GovCon
 * extractors use: callers may pass pre-parsed blocks, a MinIO blocks_path
 * to a JSON dump, or an HTML path — the extractor falls through to the
 * first available source. `source_artifact_ids` is forwarded onto the
 * resulting AwardedContractData.source_artifact_ids so reviewers can trace
 * each extracted field back to the originating PDF.
 *
 * @generated from message mono.govcon.v1.ExtractAwardedContractRequest
 */ export class ExtractAwardedContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractAwardedContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractAwardedContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractAwardedContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractAwardedContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 4;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string doc_filename = 5;
   */ _define_property(this, "docFilename", ""), /**
   * @generated from field: string blocks_path = 6;
   */ _define_property(this, "blocksPath", ""), /**
   * @generated from field: string html_path = 7;
   */ _define_property(this, "htmlPath", ""), /**
   * @generated from field: repeated string source_artifact_ids = 8;
   */ _define_property(this, "sourceArtifactIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractAwardedContractRequest, "runtime", proto3);
_define_property(ExtractAwardedContractRequest, "typeName", "mono.govcon.v1.ExtractAwardedContractRequest");
_define_property(ExtractAwardedContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractAwardedContractResponse
 */ export class ExtractAwardedContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractAwardedContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractAwardedContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractAwardedContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractAwardedContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.AwardedContractData awarded_contract = 1;
   */ _define_property(this, "awardedContract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractAwardedContractResponse, "runtime", proto3);
_define_property(ExtractAwardedContractResponse, "typeName", "mono.govcon.v1.ExtractAwardedContractResponse");
_define_property(ExtractAwardedContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awarded_contract",
            kind: "message",
            T: AwardedContractData
        }
    ]));
/**
 * Phase 4c-3 — ExtractAwardedContractV2 (field-level + per-value source metadata).
 *
 * @generated from message mono.govcon.v1.ExtractAwardedContractV2Request
 */ export class ExtractAwardedContractV2Request extends Message {
    static fromBinary(bytes, options) {
        return new ExtractAwardedContractV2Request().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractAwardedContractV2Request().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractAwardedContractV2Request().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractAwardedContractV2Request, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 4;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string doc_filename = 5;
   */ _define_property(this, "docFilename", ""), /**
   * @generated from field: string blocks_path = 6;
   */ _define_property(this, "blocksPath", ""), /**
   * @generated from field: string html_path = 7;
   */ _define_property(this, "htmlPath", ""), /**
   * @generated from field: repeated string source_artifact_ids = 8;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * Original upload key, resolved by the authorized project service.
   *
   * @generated from field: string source_path = 9;
   */ _define_property(this, "sourcePath", ""), /**
   * @generated from field: bool skip_extraction_cache = 10;
   */ _define_property(this, "skipExtractionCache", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractAwardedContractV2Request, "runtime", proto3);
_define_property(ExtractAwardedContractV2Request, "typeName", "mono.govcon.v1.ExtractAwardedContractV2Request");
_define_property(ExtractAwardedContractV2Request, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "source_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "skip_extraction_cache",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractAwardedContractV2Response
 */ export class ExtractAwardedContractV2Response extends Message {
    static fromBinary(bytes, options) {
        return new ExtractAwardedContractV2Response().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractAwardedContractV2Response().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractAwardedContractV2Response().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractAwardedContractV2Response, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.AwardedContractDataV2 awarded_contract = 1;
   */ _define_property(this, "awardedContract", void 0), /**
   * @generated from field: mono.common.v1.ExtractionCacheInfo cache_info = 2;
   */ _define_property(this, "cacheInfo", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractAwardedContractV2Response, "runtime", proto3);
_define_property(ExtractAwardedContractV2Response, "typeName", "mono.govcon.v1.ExtractAwardedContractV2Response");
_define_property(ExtractAwardedContractV2Response, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awarded_contract",
            kind: "message",
            T: AwardedContractDataV2
        },
        {
            no: 2,
            name: "cache_info",
            kind: "message",
            T: ExtractionCacheInfo
        }
    ]));
/**
 * Phase 4d — AnalyzeModificationV2 (deterministic field-level mod extraction).
 * Mirrors ExtractAwardedContractV2's block-load cascade (blocks_path -> html_path).
 *
 * @generated from message mono.govcon.v1.AnalyzeModificationV2Request
 */ export class AnalyzeModificationV2Request extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeModificationV2Request().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeModificationV2Request().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeModificationV2Request().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeModificationV2Request, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 4;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string doc_filename = 5;
   */ _define_property(this, "docFilename", ""), /**
   * @generated from field: string blocks_path = 6;
   */ _define_property(this, "blocksPath", ""), /**
   * @generated from field: string html_path = 7;
   */ _define_property(this, "htmlPath", ""), /**
   * @generated from field: repeated string source_artifact_ids = 8;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * Attachments uploaded in the same batch as the modification (its funding
   * workbook, say): read as part of it, their figures returned on the
   * modification's attachments. One uploaded later on its own is never here.
   *
   * @generated from field: repeated mono.govcon.v1.AwardAttachmentRef attachments = 9;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeModificationV2Request, "runtime", proto3);
_define_property(AnalyzeModificationV2Request, "typeName", "mono.govcon.v1.AnalyzeModificationV2Request");
_define_property(AnalyzeModificationV2Request, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "doc_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "attachments",
            kind: "message",
            T: AwardAttachmentRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.AnalyzeModificationV2Response
 */ export class AnalyzeModificationV2Response extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeModificationV2Response().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeModificationV2Response().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeModificationV2Response().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeModificationV2Response, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ParsedModificationV2 modification = 1;
   */ _define_property(this, "modification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeModificationV2Response, "runtime", proto3);
_define_property(AnalyzeModificationV2Response, "typeName", "mono.govcon.v1.AnalyzeModificationV2Response");
_define_property(AnalyzeModificationV2Response, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification",
            kind: "message",
            T: ParsedModificationV2
        }
    ]));
/**
 * ExtractGlossary (SAD-857).
 *
 * @generated from message mono.govcon.v1.ExtractGlossaryRequest
 */ export class ExtractGlossaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractGlossaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractGlossaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractGlossaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractGlossaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * The document to read: its stored blocks.json (blocks_path).
   *
   * @generated from field: mono.govcon.v1.DocumentReference document = 2;
   */ _define_property(this, "document", void 0), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * ask_model runs the model pass over the acronyms the document uses but
   * never defines. Without it that section comes back unread (empty status)
   * with its cache key, so the caller can look it up before paying for it.
   *
   * @generated from field: bool ask_model = 4;
   */ _define_property(this, "askModel", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractGlossaryRequest, "runtime", proto3);
_define_property(ExtractGlossaryRequest, "typeName", "mono.govcon.v1.ExtractGlossaryRequest");
_define_property(ExtractGlossaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document",
            kind: "message",
            T: DocumentReference
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ask_model",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GlossaryQuote
 */ export class GlossaryQuote extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryQuote().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryQuote().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryQuote().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryQuote, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 2;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryQuote, "runtime", proto3);
_define_property(GlossaryQuote, "typeName", "mono.govcon.v1.GlossaryQuote");
_define_property(GlossaryQuote, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.govcon.v1.GlossaryTermReading
 */ export class GlossaryTermReading extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryTermReading().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryTermReading().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryTermReading().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryTermReading, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string term = 1;
   */ _define_property(this, "term", ""), /**
   * @generated from field: string expansion = 2;
   */ _define_property(this, "expansion", ""), /**
   * agency | team | product | funding_pot | role | other
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: repeated mono.govcon.v1.GlossaryQuote quotes = 4;
   */ _define_property(this, "quotes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryTermReading, "runtime", proto3);
_define_property(GlossaryTermReading, "typeName", "mono.govcon.v1.GlossaryTermReading");
_define_property(GlossaryTermReading, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "expansion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "quotes",
            kind: "message",
            T: GlossaryQuote,
            repeated: true
        }
    ]));
/**
 * GlossarySectionReading is one section as pangaea caches it: section_key
 * "definitions" (code) or "acronyms" (model and Jev).
 *
 * @generated from message mono.govcon.v1.GlossarySectionReading
 */ export class GlossarySectionReading extends Message {
    static fromBinary(bytes, options) {
        return new GlossarySectionReading().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossarySectionReading().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossarySectionReading().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossarySectionReading, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_key = 1;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string heading = 2;
   */ _define_property(this, "heading", ""), /**
   * @generated from field: string content_sha256 = 3;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string prompt_version = 4;
   */ _define_property(this, "promptVersion", ""), /**
   * @generated from field: string model = 5;
   */ _define_property(this, "model", ""), /**
   * verified | failed; empty when the section was not read (ask_model off).
   *
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 proposed = 7;
   */ _define_property(this, "proposed", 0), /**
   * @generated from field: int32 kept = 8;
   */ _define_property(this, "kept", 0), /**
   * @generated from field: int32 dropped = 9;
   */ _define_property(this, "dropped", 0), /**
   * @generated from field: repeated mono.govcon.v1.GlossaryTermReading terms = 10;
   */ _define_property(this, "terms", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossarySectionReading, "runtime", proto3);
_define_property(GlossarySectionReading, "typeName", "mono.govcon.v1.GlossarySectionReading");
_define_property(GlossarySectionReading, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "heading",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "prompt_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "kept",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "dropped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "terms",
            kind: "message",
            T: GlossaryTermReading,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.govcon.v1.ExtractGlossaryResponse
 */ export class ExtractGlossaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractGlossaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractGlossaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractGlossaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractGlossaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.govcon.v1.GlossarySectionReading sections = 1;
   */ _define_property(this, "sections", []), /**
   * The model pass's spend in dollars (0 when it did not run).
   *
   * @generated from field: double cost_usd = 2;
   */ _define_property(this, "costUsd", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractGlossaryResponse, "runtime", proto3);
_define_property(ExtractGlossaryResponse, "typeName", "mono.govcon.v1.ExtractGlossaryResponse");
_define_property(ExtractGlossaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sections",
            kind: "message",
            T: GlossarySectionReading,
            repeated: true
        },
        {
            no: 2,
            name: "cost_usd",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
